import { deepMerge } from './merge';
import { getShellUiOverlay } from '../data/shellUiTranslations';
import { getScreenUiOverlay } from '../data/screenUiTranslations';
import { phaseMyPageDashboardEn } from './partials/i18nPhaseMyPageDashboard';
import { phaseE1En } from './partials/i18nPhaseE1DashboardTabs';
import { phaseE2En } from './partials/i18nPhaseE2BookingTab';
import { phaseE3En } from './partials/i18nPhaseE3ManageBookingPanels';
import { phaseE4En } from './partials/i18nPhaseE4OverviewSectionLabels';
import { phaseGroupsCreateEn } from './partials/i18nPhaseGroupsCreate';
import { phaseGroupsListDetailEn } from './partials/i18nPhaseGroupsListDetail';
import { phaseGroupCategoriesEn } from './partials/i18nPhaseGroupCategories';
import { phaseTradeChatEn } from './partials/i18nPhaseTradeChat';
import { phaseHandleH0En } from './partials/i18nPhaseHandleH0';
import { phaseP0DashEn } from './partials/i18nPhaseP0DashboardPlanAds';
import { phaseManageWidgetsEn } from './partials/i18nPhaseManageFormWidgets';
import { phaseP0CatalogEn } from './partials/i18nPhaseP0CatalogForms';
import { phaseFoodOrderFlowEn } from './partials/i18nPhaseFoodOrderFlow';
import { phaseUserAddressBookEn } from './partials/i18nPhaseUserAddressBook';
import { phaseHomeWeatherHourlyEn } from './partials/i18nPhaseHomeWeatherHourly';
import { phaseLostFoundResolveEn } from './partials/i18nPhaseLostFoundResolve';
import { phaseBrandCatalogEn } from './partials/i18nPhaseBrandCatalog';
import { phaseMenuFeedEn } from './partials/i18nPhaseMenuFeed';
import { phaseBrandPageEn } from './partials/i18nPhaseBrandPage';
import { phaseLocationSetupEn } from './partials/i18nPhaseLocationSetup';
import { phaseAdminCoreEn } from './partials/i18nPhaseAdminCore';
import { phaseBusinessRegInquiryEn } from './partials/i18nPhaseBusinessRegInquiry';
import { phaseJobsHireGateEn } from './partials/i18nPhaseJobsHireGate';
import { phaseSearchSurfaceEn } from './partials/i18nPhaseSearchSurface';
import { phaseHubEmptyEn } from './partials/i18nPhaseHubEmpty';
import { phaseBizNotifEn } from './partials/i18nPhaseBusinessNotifications';
import { phaseCatalogBookingEn } from './partials/i18nPhaseCatalogDetailBooking';
import { phaseCreatorCommissionEn } from './partials/i18nPhaseCreatorCommission';
import { phaseTravelerFormEn } from './partials/i18nPhaseTravelerForm';
import { phaseRestaurantRegisterEn } from './partials/i18nPhaseRestaurantRegister';
import { phaseLocalRegisterChipsEn } from './partials/i18nPhaseLocalRegisterChips';
import { phaseMentorBusinessRegisterEn } from './partials/i18nPhaseMentorBusinessRegister';
import { phaseLocalRegisterChips2En } from './partials/i18nPhaseLocalRegisterChips2';
import { phaseWriteChipsEn } from './partials/i18nPhaseWriteChips';
import { phaseLiveHangulEn } from './partials/i18nPhaseLiveHangul';

const en = {
  common: {
    appName: 'Mingo',
    tabBar: 'Main menu',
    preparing: 'Coming soon.',
    report: 'Report',
    done: 'Done',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    back: 'Back',
    close: 'Close',
    more: 'More',
    loadingLabel: 'Loading…',
    uploading: 'Uploading…',
    viewAll: 'View all',
    share: 'Share',
    loadMore: 'Load more',
    search: 'Search',
    all: 'All',
  },
  settings: {
    messengerTitle: 'Connect Messenger',
    messengerDesc: 'Receive Mingo notifications on your preferred messenger',
    messengerConnect: 'Connect',
    messengerConnected: 'Connected',
    messengerSaved: 'Messenger connected',
    messengerVnBadge: '🇻🇳 Vietnam',
    messengerChannels: {
      kakao: 'KakaoTalk',
      zalo: 'Zalo',
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      sms: 'SMS',
    },
    resetLocation: 'Reset location',
    resetLocationConfirm: 'Your saved location settings will be reset. Continue?',
  },
  about: {
    title: 'About Mingo',
  },
  privacy: {
    title: 'Privacy Policy',
    section1Title: 'Information We Collect',
    section1Body:
      'Mingo collects the following information.\n- Name, nickname\n- Email address\n- Country and city of residence\n- Service usage history\n- Device information (for push notifications)',
    section2Title: 'How We Use Your Information',
    section2Body:
      'Collected information is used only for:\n- Service provision and improvement\n- Notification delivery\n- Customer support\n- Fraud prevention',
    section3Title: 'Data Retention',
    section3Body:
      'All personal data is deleted upon account deletion.\nExceptions apply where required by law.',
    section4Title: 'Third-Party Sharing',
    section4Body:
      'Mingo does not share personal information without consent.\nExceptions apply to legally mandated disclosures.',
    section5Title: 'Contact',
    section5Body: 'For privacy inquiries, please use the in-app customer support channel.',
    updated: 'Last updated',
  },
  terms: {
    title: 'Terms of Service',
    section1Title: 'About the Service',
    section1Body:
      'Mingo is a community platform for overseas Koreans.\nThese terms govern the use of Mingo services.',
    section2Title: 'Usage Rules',
    section2Body:
      'The following actions are prohibited:\n- Impersonation or false information\n- Spam or mass advertising\n- Illegal transactions or fraud\n- Unauthorized collection of others information\n- Actions that disrupt service operations',
    section3Title: 'Content Responsibility',
    section3Body:
      'Users are responsible for content they post.\nMingo is not liable for disputes from user-to-user transactions.',
    section4Title: 'Service Changes',
    section4Body:
      'Mingo may modify or discontinue services.\nSignificant changes will be announced in advance.',
    section5Title: 'Governing Law',
    section5Body: 'These terms are governed by the laws of the Republic of Korea.',
    updated: 'Last updated',
  },
  refund: {
    title: 'Refund Policy',
    updated: 'Last updated',
  },
  register: {
    goToDashboard: 'Go to profile',
  },
  status: {
    all: 'All',
    approved: 'Approved',
    pending: 'Pending review',
    pending_review: 'Pending review',
    limited: 'Limited',
    shadow_blocked: 'Suspected spam',
    paused: 'Paused',
    draft: 'Draft',
    rejected: 'Rejected',
    suspended: 'Suspended',
    rejectedReason: 'Reason',
    reRegister: 'Register again',
  },
  admin: {
    adBotSettings: {
      title: 'Ad AI Chatbot Settings',
      loading: 'Loading...',
      loadFailed: 'Failed to load',
      saveFailed: 'Failed to save',
      desc: 'The chatbot only quotes values entered here. If left blank, it will only say it will confirm and get back to you. Pricing and bank details are never invented by the AI, so only enter values you want shown to real customers.',
      noSettingsRow: 'No settings row found. Please check that the DB migration has been applied.',
      pricingTitle: 'Ad pricing (by scope)',
      scopeNeighborhood: 'Neighborhood',
      scopeCity: 'City',
      scopeCountry: 'Country',
      scopeGlobal: 'Global',
      amountPlaceholder: 'Amount',
      currencyPlaceholder: 'Currency',
      periodPlaceholder: 'Period (e.g. month)',
      bankTitle: 'Bank account (shown to customers by the chatbot)',
      bankNamePlaceholder: 'Bank name',
      bankHolderPlaceholder: 'Account holder',
      bankNumberPlaceholder: 'Account number',
      paymentNotesTitle: 'Payment notes',
      paymentNotesPlaceholder: 'e.g. Please send a payment screenshot in this chat and your ad will go live after confirmation.',
      faqTitle: 'FAQ — for the chatbot to reference',
      faqPlaceholder: 'Free-form text. e.g. Q. How soon does my ad go live? A. Within 1 business day after payment is confirmed.',
      extraTitle: 'Extra instructions (optional)',
      extraHint: 'Freely add tone or extra rules for the chatbot (e.g. "always use formal language", "always say a human will confirm discount requests").',
      savedAt: 'Saved ({time})',
      saving: 'Saving...',
      save: 'Save',
    },
    summaryTitle: 'Overview',
    summaryHint: 'Based on businesses.moderation_status, review reports in report_logs, and no_show_records.',
    summaryRefresh: 'Refresh summary',
    summary: {
      pending: 'Pending Approval',
      todayNew: 'New Today',
      reportedReviews: 'Reported Reviews',
      totalApproved: 'Approved Businesses',
      noShowPending: 'No-show Pending',
      shortsPending: 'AI Shorts queue (pending)',
      chargeRequestsPending: 'Point charge requests',
      subscriptionsActive: 'Active subscriptions',
    },
    businessesTitle: 'Business moderation',
    reviewsTitle: 'Reported reviews',
    reviewsHint: 'Shows pending reports where target_type = review.',
    empty: 'No rows.',
    approve: 'Approve',
    reject: 'Reject',
    suspend: 'Suspend',
    restore: 'Restore',
    rejectReasonPrompt: 'Reject reason (optional)',
    suspendReasonPrompt: 'Suspend reason (optional)',
    reportReason: 'Report Reason',
    deleteReview: 'Delete Review',
    keepReview: 'Dismiss Report',
    noShow: 'No-show Management',
    noShowHint: 'Shows no_show_records with status = pending.',
    noShowConfirm: 'Confirm No-show',
    noShowDismiss: 'Dismiss',
    bookings: 'Bookings',
    bookingsHint: 'Browse all bookings (booking_ledger) by status.',
    bookingsPackageFallback: 'Untitled item',
    bookingsParty: '{n} guests',
    bookingsCreatedAt: 'Requested {date}',
    bookingsSearchPlaceholder: 'Search by business, item, or nickname',
    bookingsSearchBtn: 'Search',
    bookingStatus: {
      all: 'All',
      pending: 'Pending',
      holding: 'Holding',
      confirmed: 'Confirmed',
      in_progress: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      failed: 'Failed',
    },
    settlements: {
      pageTitle: 'Settlements',
      pageDesc: 'Check pending settlement amounts per business and mark as paid after wiring the money.',
      empty: 'No pending settlements.',
      pendingCount: '{n} pending',
      noAccount: 'No settlement account on file',
      showDetail: 'Show details',
      hideDetail: 'Hide details',
      markPaidBtn: 'Mark as paid',
      confirmMarkPaid: 'Mark {amount} for {name} as paid? Do this only after the actual bank transfer is done.',
      errMarkPaidFailed: 'Failed to mark settlement as paid.',
      feeLabel: 'Fee {fee}',
      status: {
        holding: 'Pending',
        payable: 'Pending',
        paid: 'Paid',
        disputed: 'Disputed',
        refunded: 'Refunded',
      },
    },
    medicines: 'Medicine Management',
    activate: 'Activate',
    deactivate: 'Deactivate',
    actions: 'Actions',
    stats: {
      title: 'Statistics',
      domainChart: 'Registrations by Domain',
      dailyNew: 'Daily New (7 days)',
      approvalRate: 'Approval Rate',
    },
    domain: {
      all: 'All Domains',
      hospital: 'Hospital',
      restaurant: 'Restaurant',
      rental: 'Rental',
      academy: 'Academy',
      hotel: 'Hotel',
      visa_service: 'Visa/Admin',
      property: 'Property',
      guide: 'Guide',
    },
    businessRow: {
      optionEdit: 'Edit options',
      recommendOn: 'Featured ON',
      recommendOff: 'Featured OFF',
      singlePortionOn: 'Solo ON',
      singlePortionOff: 'Solo OFF',
      deliveryFeePrefix: 'Delivery fee',
      freeDeliverySuffix: ' · Free delivery',
      noServiceOptions: 'No service options',
      approveFailScope: 'Approval failed (business may be outside your managed country/city scope)',
      rejectFailScope: 'Rejection failed (business may be outside your managed country/city scope)',
      suspendFailScope: 'Suspension failed (business may be outside your managed country/city scope)',
      restoreFailScope: 'Restore failed (business may be outside your managed country/city scope)',
      serviceOptionsHint: 'Allowed options: {list}',
      serviceOptionsPrompt: 'Enter as comma-separated values. Leave empty to remove all options.',
      foodUnclassifiedFilter: 'Unclassified only ({count})',
      foodUnclassifiedHint: 'Show only businesses missing a food/cafe major category (food_menu_category)',
      foodUnclassifiedTag: 'Unclassified',
      foodMenuCategoryEdit: 'Set category',
      foodMenuCategoryPrompt: 'Enter a category key (leave empty to reset to unclassified):',
      foodMenuCategoryInvalid: 'Not an allowed category key',
      commissionLabel: 'Commission {rate}%',
      commissionEdit: 'Edit commission',
      commissionPrompt: 'Enter commission rate (%) (0-100):',
      commissionInvalid: 'Enter a valid number between 0 and 100',
    },
    nav: {
      scamContacts: 'Scam contact lookup',
      reports: 'Report management',
    },
    common: {
      colType: 'Type',
      colDate: 'Date',
      colStatus: 'Status',
      colActions: 'Actions',
      languageAll: 'All',
    },
    scamContacts: {
      title: 'Scam contact lookup',
      filterAll: 'All',
      statusPending: 'Pending review',
      statusVerified: 'Public (verified)',
      statusRejected: 'Rejected',
      colContact: 'Contact',
      colCompany: 'Company',
      colDescription: 'Description',
      colDate: 'Date',
      colStatus: 'Status',
      colActions: 'Actions',
      loading: 'Loading…',
      verify: 'Verify (publish)',
      reject: 'Reject',
      updateFailed: 'Failed to update status.',
    },
    reports: {
      colTarget: 'Target ID',
      colReporter: 'Reporter ID',
      statusPending: 'Pending',
      statusReviewing: 'Reviewing',
      statusResolved: 'Resolved',
      statusDismissed: 'Dismissed',
      actionWarn: 'Send warning',
      actionDeletePost: 'Delete post',
      actionDeactivateJob: 'Deactivate listing',
      actionSanctionUser: 'Sanction user',
      actionDismiss: 'Dismiss',
      jobActionFailed: 'Failed to deactivate the listing.',
      actionFailed: 'Action failed.',
    },
  },
  adminUi: {
    "dashboard": {
      "chartAria": "Daily sign-ups (last 14 days)",
      "title": "Dashboard",
      "intro": "Shows Supabase RPC stats together with sample metrics stored in the browser. Remote stats refresh after migrations and RPC deploy.",
      "refreshLoading": "Loading…",
      "refreshReady": "Refresh remote stats",
      "remoteErrPrefix": "Remote:",
      "supabaseSummary": "Supabase summary",
      "cityStatsNote": "City-scoped stats (region = {scope})",
      "totalUsersDb": "Total users (DB)",
      "publicUsers": "public.users",
      "adCtr": "Ad CTR",
      "adCtrSub": "ad_stats clicks / impressions",
      "usersByCountry": "Users by country (residence_country)",
      "usersByLang": "Users by language",
      "productsByCategory": "Listings by category",
      "signups14": "Sign-ups by day (last 14 days)",
      "topLocations": "Top locations (listing location)",
      "noData": "No data",
      "propertiesSection": "Property listings",
      "propTotal": "Total listings",
      "propToday": "New today",
      "propReported": "Reported (pending)",
      "topWishlist": "Most wishlisted TOP 5 (property_wishlist)",
      "wishlistEmptyNote": "No data (wishlist not wired or RLS)",
      "opsSection": "Operations",
      "totalUsers": "Total users",
      "todaySignups": "Sign-ups today",
      "totalBusinesses": "Total businesses",
      "pendingBusinesses": "Pending approval",
      "runningAds": "Active ads",
      "pendingAds": "Ads pending approval",
      "todaySos": "SOS requests today",
      "unresolvedReports": "Unresolved reports",
      "totalPointsIssued": "Total Mingo points issued"
    },
    "system": {
      "saved": "Saved.",
      "title": "System settings",
      "intro": "Stored in localStorage; affects ad spacing and commission calculations in the app.",
      "tablistAria": "System / points",
      "tabSystem": "System",
      "tabPoints": "Points",
      "tabErrors": "Error logs",
      "newErrorsBadge": "New errors!",
      "cityAdminTitle": "City Admin accounts",
      "cityAdminBody": "Promote an existing user to city admin, or create a new account and attach the role. If email confirmation is on, profile refresh may be needed after signup.",
      "emailLabel": "Target email",
      "cityLabel": "Managed city (region_key)",
      "promoteOk": "City Admin role granted to the existing user.",
      "promoteFail": "Failed: {msg}",
      "promoteBtn": "Grant role to existing account",
      "newAccountHeading": "New account + temporary password",
      "newAccountBody": "Enter the super-admin password to restore the session. Share the generated temporary password securely.",
      "tempPwdLabel": "Temporary password (auto-generated)",
      "tempPwdPh": "Click generate",
      "generateBtn": "Generate",
      "superPwdLabel": "Super-admin password (re-login)",
      "superNotFound": "Could not find super-admin email in session.",
      "createOk": "New City Admin account prepared.",
      "createFail": "Failed: {msg}",
      "createBtn": "Create account and grant role",
      "confirmOpenRegion": "Open this region and notify everyone on the waitlist?",
      "wlActionOpen": "Opened + notified",
      "confirmNotifyOnly": "Send a notification to all waiters for this region (regardless of open state)?",
      "wlActionNotify": "Notified {n}",
      "commissionTitle": "Commission",
      "commissionOn": "Enable commission",
      "announcementLabel": "Notice text",
      "tradeRate": "Used marketplace fee (%)",
      "rentRate": "Rent fee (%)",
      "jobFixed": "Jobs flat fee ($)",
      "jobPremTitle": "Jobs premium",
      "jobPremOn": "Jobs premium commission ON — show prices in listings",
      "jobPremHint": "OFF by default. Option checkout is coming soon; only prices are shown in the app.",
      "pinUsd": "Pin to top ($/week)",
      "urgentUsd": "Urgent badge ($)",
      "resumeUsd": "Resume view ($)",
      "adSlotsTitle": "Ad slots",
      "feedInterval": "Feed ad interval (every N items)",
      "commInterval": "Community ad interval",
      "adPriceTitle": "Ad pricing ($/month)",
      "tierLocal": "Local",
      "tierCity": "City",
      "tierNational": "National",
      "tierGlobal": "Global",
      "stripeTitle": "Stripe payments",
      "stripeOn": "Payment system ON (allow card checkout attempts in the app)",
      "stripeBody": "OFF by default. To enable: set REACT_APP_PAYMENT_ENABLED=true, a valid REACT_APP_STRIPE_PUBLISHABLE_KEY (pk_test… or pk_live…), and REACT_APP_STRIPE_PAYMENT_API_URL (POST endpoint for PaymentIntent). Receipt email integration is planned.",
      "stripeDash": "Stripe dashboard:",
      "paymentTotalLabel": "Completed payments total (USD)",
      "thWhen": "Time",
      "thType": "Type",
      "thAmount": "Amount",
      "thStatus": "Status",
      "paymentEmpty": "No rows",
      "appBannerTitle": "App notice banner",
      "bannerLabel": "Banner text",
      "bannerPh": "e.g. Safe trade beta opening soon",
      "bannerOn": "Enable banner",
      "featureFlagsHint": "Supabase `feature_flags` — only `users.is_admin` accounts are written to the DB. Check the message if it fails.",
      "flagsSaveBtn": "Save feature flags",
      "flagsLoadFail": "Could not load flags.",
      "thKey": "Key",
      "thOn": "ON",
      "saveBtn": "Save"
    },
    "posts": {
      "pageTitle": "Posts & reports",
      "reportList": "Reports",
      "deselectAll": "Deselect all",
      "selectAll": "Select all",
      "bulkHide": "Hide selected",
      "bulkRestore": "Restore selected",
      "bulkDelete": "Delete selected permanently",
      "thTitle": "Title",
      "thAuthor": "Author",
      "thReports": "Reports",
      "thDate": "Date",
      "thStatus": "Status",
      "thActions": "Actions",
      "selectAria": "Select",
      "hide": "Hide",
      "warnAuthor": "Warn author",
      "blockAuthor": "Block author",
      "permanentDelete": "Delete permanently",
      "hiddenSection": "Auto-hidden posts (status: hidden)",
      "hiddenHint": "Hidden after 3+ reports.",
      "emptyHidden": "No hidden posts.",
      "restore": "Restore",
      "mediaSection": "Auto-hidden images (3+ media reports)",
      "thUrl": "URL",
      "thCount": "Reports",
      "thTime": "Time",
      "thAct": "Actions",
      "restoreClear": "Restore & clear reports",
      "emptyMedia": "No items.",
      "statusOpen": "Open",
      "statusHidden": "Hidden",
      "statusRestored": "Restored"
    },
    "properties": {
      "title": "Property listings",
      "cityScope": "City scope:",
      "stats": "Stats",
      "total": "Total listings",
      "active": "Active",
      "reserved": "Reserved",
      "todayNew": "New today",
      "reportedPending": "Reports (pending)",
      "filters": "Filters",
      "searchPh": "Search title / address",
      "refresh": "Refresh",
      "listTitle": "Listings ({n})",
      "loading": "Loading…",
      "thImage": "Image",
      "thTitleAddr": "Title / address",
      "thTx": "Deal type",
      "thPrice": "Price",
      "thOwner": "Owner",
      "thCreated": "Created",
      "thViews": "Views",
      "thStatus": "Status",
      "thActions": "Actions",
      "approveShow": "Approve (show)",
      "hide": "Hide",
      "detail": "Detail",
      "publicPage": "Public page",
      "delete": "Delete",
      "reportsBtn": "Reports ({n})",
      "detailTitle": "Listing detail",
      "landlord": "Landlord",
      "reportList": "Reports",
      "resolve": "Resolved",
      "dismiss": "Dismiss",
      "noLinkedReports": "No linked reports (shows when target_type=property is registered).",
      "close": "Close",
      "reportModalTitle": "Reports — {title}",
      "noReports": "No reports",
      "confirmDelete": "Delete this listing? This cannot be undone.",
      "type": {
        "all": "All types",
        "long_stay": "Long stay",
        "short_stay": "Short stay",
        "sale": "Sale"
      },
      "tx": {
        "all": "All deals",
        "monthly_no_deposit": "Monthly (no deposit)",
        "monthly_with_deposit": "Monthly (with deposit)",
        "sale": "Sale",
        "short_rent": "Short rent",
        "long_rent": "Long rent"
      },
      "txMap": {
        "monthly_no_deposit": "Monthly (no deposit)",
        "monthly_with_deposit": "Monthly (with deposit)",
        "sale": "Sale",
        "short_rent": "Short rent",
        "long_rent": "Long rent",
        "monthly": "Monthly",
        "jeonse": "Jeonse"
      },
      "typeSale": "Sale",
      "typeShort": "Short stay",
      "categoryMonthly": "Monthly",
      "categoryJeonse": "Jeonse",
      "fallbackTx": "{type}/{category}",
      "suffixMonth": "/mo",
      "suffixNight": "/night",
      "status": {
        "all": "All statuses",
        "active": "active",
        "reserved": "Reserved",
        "hidden": "hidden"
      },
      "region": {
        "all": "All regions",
        "danang": "Da Nang",
        "hoian": "Hoi An",
        "hcmc": "HCMC",
        "other": "Other"
      }
    }
  },
  nav: {
    home: 'Home',
    trade: 'Trade',
    community: 'Community',
    localInfo: 'Local info',
    mypage: 'My page',
    chat: 'Chat',
    search: 'Search',
    notification: 'Notifications',
    back: 'Back',
    allServices: 'All services',
    appHome: 'Mingo home',
  },
  btn: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'OK',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    report: 'Report',
    block: 'Block',
    share: 'Share',
    copy: 'Copy',
    more: 'More',
    write: 'Write',
    submit: 'Post',
    submitting: 'Submitting...',
    login: 'Log in',
    signup: 'Sign up',
    logout: 'Log out',
    chat: 'Chat',
    like: 'Like',
    comment: 'Comment',
    translate: 'Translate',
    original: 'Show original',
    call: 'Call',
    map: 'Map',
    apply: 'Apply',
    complete: 'Done',
    next: 'Next',
    prev: 'Previous',
    retry: 'Retry',
  },
  expiry: {
    title: 'Expiry Manager',
    menuLabel: 'Expiry Reminders',
    addItem: '+ Add Item',
    formTitle: 'Add New Item',
    labelCategory: 'Category',
    labelTitle: 'Title',
    titlePlaceholder: 'e.g. E-7 Visa, Apartment Lease',
    labelExpiryDate: 'Expiry Date',
    labelAlertDays: 'Alert Schedule',
    labelMemo: 'Memo (optional)',
    memoPlaceholder: 'Add a note',
    expiryDate: 'Expires',
    renewalGuide: 'How to Renew',
    expired: 'Expired',
    today: 'D-Day',
    empty: 'No items registered',
    categoryVisa: 'Visa',
    categoryResidence: 'Residence Registration',
    categoryLease: 'Lease Contract',
    categoryLicense: "Int'l Driver's License",
    categoryInsurance: 'Insurance',
    categoryPassport: 'Passport',
    categoryBusiness: 'Business Registration',
    categoryHealth: 'Health Checkup',
    categoryOther: 'Other',
    labelReminderKind: 'Reminder type',
    kindExpiry: 'By expiry date',
    kindMonthly: 'Same day each month',
    hintExpiry: 'Get alerts when your deadline is D-180, D-30, or any D-day you add.',
    hintMonthly: 'Get an alert on the same calendar day every month. Short months use the last day (e.g. 31 → Feb 28/29).',
    labelMonthlyDay: 'Day of month',
    hintMonthlyDom: '1–31. If the month has fewer days, we notify on the last day of that month.',
    monthlyShort: 'Day {day} each month',
    monthlyLine: 'Alert every month on day {day}',
    addCustomDday: 'Add',
    customDdayPlaceholder: 'e.g. 45',
    customDdayHint: 'Add any D-day (e.g. 120) that is not in the presets. Tap a chip again to turn it off.',
    customDdayInvalid: 'Enter a number from 1 to 999.',
    needExpiryAndAlerts: 'Set an expiry date and at least one alert day.',
    needMonthlyDay: 'Choose which day of the month (1–31).',
  },
  lostFound: {
    title: 'Lost & Found',
    tabLost: 'Lost Item',
    tabFound: 'Found Item',
    tabMissing: 'Missing Person',
    reportLost: 'Report Lost',
    reportFound: 'Report Found',
    formTitleLost: 'Report Lost Item',
    formTitleFound: 'Report Found Item',
    labelUrgent: 'Urgency',
    urgentYes: 'Urgent',
    urgentNo: 'Normal',
    labelMissingPhoto: 'Photo (required)',
    missingPhotoHint: 'Please upload a recent clear photo',
    labelMissingName: 'Name',
    missingNamePlaceholder: 'Real name or nickname',
    labelAge: 'Age',
    agePlaceholder: 'e.g. 35',
    ageUnit: ' yrs',
    labelGender: 'Gender',
    genderSelect: 'Select',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderUnknown: 'Unknown',
    labelLastSeen: 'Last Seen Location',
    lastSeenPlaceholder: 'e.g. Near Da Nang Han Market',
    labelLastSeenTime: 'Last Seen Time',
    labelFeatures: 'Physical Features',
    featuresPlaceholder: 'Height, build, clothing, language...',
    labelPhoto: 'Photo (optional)',
    photoHint: 'Up to 3 photos',
    labelItemType: 'Item Type',
    labelTitle: 'Title',
    titlePlaceholder: 'e.g. Lost black wallet',
    labelLocation: 'Location',
    locationPlaceholder: 'e.g. Near My Khe Beach',
    labelDate: 'Date',
    labelContact: 'Contact',
    contactPlaceholder: 'Phone or KakaoTalk ID',
    labelDesc: 'Description',
    descPlaceholder: 'Color, brand, features...',
    empty: 'No posts yet',
    urgentBadge: 'URGENT',
    statusActive: 'Searching',
    statusUrgent: 'Urgent',
    statusResolved: 'Resolved',
    typeWallet: 'Wallet',
    typePhone: 'Phone',
    typeKey: 'Keys',
    typePassport: 'Passport',
    typeBag: 'Bag',
    typeOther: 'Other',
  },
  category: {
    all: 'All',
    trade: 'Marketplace',
    rent: 'Rent',
    jobs: 'Jobs',
    question: 'Q&A',
    info: 'Info',
    meetup: 'Meetup',
    lost: 'Lost',
    free: 'Open',
    electronics: 'Electronics',
    furniture: 'Furniture',
    clothing: 'Clothing',
    motorbike: 'Motorbike',
    car: 'Car',
    household: 'Home goods',
    sports: 'Sports',
    food: 'Food',
    other: 'Other',
    groupBuy: 'Group buy',
    realEstate: 'Real estate',
    restaurant: 'Restaurant',
    academy: 'Academy',
    hotel: 'Stay',
    hospital: 'Hospital',
    visa_service: 'Visa & admin',
    property: 'Property',
    guide: 'Guide',
    rental: 'Rental',
    delivery: 'Delivery',
    business: 'Business',
  },
  error: {
    network: 'A network error occurred',
    saveFailed: 'Could not save',
    loginRequired: 'Please sign in',
    noPermission: "You don't have permission",
    tryAgain: 'Please try again in a moment',
    notFound: 'Not found',
    serverError: 'A server error occurred',
    imageUploadFailed: 'Image upload failed',
  },
  notification: {
    noShowWarning: 'You have {count} no-shows. Account will be blocked at 5',
  },
  toast: {
    saved: 'Saved',
    deleted: 'Deleted',
    copied: 'Copied',
    reported: 'Report sent',
    blocked: 'User blocked',
    linkCopied: 'Link copied',
    pointEarned: 'Points added',
    liked: 'Liked',
    unliked: 'Like removed',
    commentAdded: 'Comment posted',
    applied: 'Applied',
  },
  waitlist: {
    nowOpen: 'Live now',
    preparing: 'Coming soon',
    countLine: '{n} people on the waitlist',
    openAt: 'We open when we hit {n} people',
    cta: 'Join the waitlist',
    joined: "We’ll notify you when it's open!",
    joinedDup: "You're already on the list for this area.",
    loginToJoin: 'Sign in to join the waitlist',
    backEdit: 'Back (change cities)',
    startDanang: 'Start in Da Nang now',
    openBadge: 'Available',
    soonBadge: 'Waitlist',
    regionTitle: 'Service areas & waitlist',
    benefitTitle: 'Early member perks',
    benefitPremium: '1 month of Premium on launch',
    benefitBadge: 'Founding member badge',
    benefitAd: '1 month ad credit',
    noNetwork: 'Could not load area settings. Check your connection.',
    notifHint: 'We’ll use in-app notifications (and push when enabled)',
    title: 'This area is coming soon',
    current: 'People on the waitlist',
    threshold: 'people needed to launch',
    apply: 'Join waitlist',
    applied: 'You’re on the waitlist',
    benefit: 'Early member perks',
    useDanang: 'Use Mingo in Da Nang first',
  },
  adminRegions: {
    title: 'Regions & waitlist',
    hint: 'Signed-in staff admins can open regions and notify waitlist users.',
    secretMissing: 'Admin access required. Sign in again with a staff account.',
    refresh: 'Refresh',
    colRegion: 'Area',
    colState: 'Status',
    colCount: 'Waitlist',
    colThreshold: 'Target',
    openBtn: 'Open now + notify',
    notifyBtn: 'Notify all waiters',
    loadFail: 'Load failed. Check staff admin access and migrations.',
  },
  productCard: {
    chatCountAria: 'Chats: {n}',
    metaLine: '{flag}{nickname} · {location} · {time}',
  },
  tabs: {
    home: 'Home',
    trade: 'Trade',
    story: 'Story',
    services: 'Search & Services',
    events: 'Events',
    life: 'Local',
    community: 'Community',
    chat: 'Chat',
    profile: 'Profile',
  },
  userFab: {
    create: 'Create',
    close: 'Close',
    sheetTitle: 'What would you like to do?',
    propertyWrite: 'List property',
    myProperties: 'My listings',
    communityWrite: 'Write post',
    myCommunityPosts: 'My posts',
    groupCreate: 'Create group',
    myGroups: 'My groups',
    searchGroups: 'Search groups',
    storyWrite: 'Post story',
    businessRegister: 'Register business',
    myBusinesses: 'My businesses',
    productWrite: 'Sell item',
    myTrades: 'My items & trades',
    search: 'Search',
    hubRegister: 'Register',
    hubMyRegister: 'My listings',
  },
  shortsV2: {
    tabDiscover: 'Discover',
    tabStoryHome: 'Story Home',
    create: 'Create Story',
    createTitle: 'Create Story',
    shortBadge: 'Short',
    next: 'Next video',
    viewLink: 'View details',
    chipAll: 'All nearby',
    chipNearby: 'Walk 10 min',
    chipRealEstate: 'Real estate',
    chipMeetup: 'Meetup',
    uploadVideo: 'Upload video',
    uploadVideoDone: 'Video added',
    uploadPhoto: 'Add photo',
    uploadPhotoDone: 'Photo added',
    addOnePhoto: 'Add one photo (optional)',
    photoHint: 'You can upload up to {max} photos. Images are compressed automatically on upload.',
    photoMax: 'You can upload up to {max} photos.',
    photoCount: '{count}/{max} photos',
    filterLabel: 'Filter',
    intensityLabel: 'Intensity',
    filterNone: 'Original',
    filterWarm: 'Warm',
    filterCool: 'Cool',
    filterVintage: 'Vintage',
    filterContrast: 'Vivid',
    filterMono: 'B&W',
    durationHint: 'Only videos between 5 and 60 seconds are allowed.',
    durationInvalid: 'Videos must be between 5 and 60 seconds. Please choose another video.',
    uploadNetworkError: 'Please check your network connection.',
    uploadTooLarge: 'This video is too large. Try a shorter video.',
    storyPhotoOptionalHint: 'Photo is optional. You can post a story with text only.',
    titleLabel: 'Title',
    titlePlaceholder: 'Enter a title (optional)',
    contentLabel: 'Content',
    content: 'Content',
    contentPlaceholder: 'Write a short description for your story.',
    place: 'Place',
    placePlaceholder: 'Add a location related to this story.',
    noTitle: 'Untitled story',
    addTag: 'Add tag',
    submit: 'Publish',
    created: 'Story posted.',
    tabVideo: 'Video',
    tabPhoto: 'Photo',
    tabStory: 'Story',
    mentionHint: '(@nickname to mention)',
    optionalParen: '(optional)',
    dragReorderHint: 'Drag to reorder',
    changeVideo: 'Change video',
    businessBlockTitle: 'Register business promos as a campaign',
    businessBlockDesc: 'Personal story and short creation is for personal accounts only. Register business promo videos as an ad campaign (ad_creative).',
    businessPromoCta: 'Register promo video',
    toolDockAria: 'Media editing tools',
    mirrorFlip: 'Flip horizontal',
    trimStart: 'Trim start ({sec}s)',
    trimEnd: 'Trim end ({sec}s)',
    playbackRate: 'Speed',
    coverFrame: 'Cover frame ({sec}s)',
    altTextLabel: 'Alt text (optional)',
    altTextPlaceholder: 'Description for screen readers',
    pinPlaceLabel: 'Pin place name (optional)',
    pinPlacePlaceholder: 'e.g. My Khe Beach',
    aspectTitle: 'Fit to 9:16 portrait',
    aspectDesc: 'Original ({width}×{height}) is not 9:16. Choose how to display it. The original file is uploaded unchanged.',
    aspectCrop: 'Crop (fill)',
    aspectLetterbox: 'Letterbox (blur background)',
    aspectOriginal: 'Keep original',
    overlayTextPlaceholder: 'Text',
    overlayAdd: 'Add',
    overlayAddAria: 'Add text',
    overlayBgHighlight: 'Background highlight',
    overlayTextPrompt: 'Enter text',
    overlayTextAria: 'Text overlay',
    overlayStickerAria: 'Sticker overlay',
    overlayDrawAria: 'Drawing overlay',
    overlayPinAria: 'Location pin',
    overlayDrawColorAria: 'Draw color {color}',
    overlayDrawHint: 'Drag on the photo to draw.',
    overlayPinHint: 'Tap the photo to place a pin.',
    font: {
      default: 'Default',
      hand: 'Handwriting',
      bold: 'Bold',
      typewriter: 'Typewriter',
    },
    stroke: {
      thin: 'Thin',
      normal: 'Regular',
      thick: 'Thick',
    },
    tool: {
      stickers: 'Stickers',
      text: 'Text',
      filter: 'Filter',
      frame: 'Frame',
      draw: 'Draw',
      pin: 'Place pin',
      video: 'Edit video',
    },
    filterPreset: {
      none: 'Original',
      bright: 'Bright',
      vintage: 'Vintage',
      cool: 'Cool',
      warm: 'Warm',
      dreamy: 'Dreamy',
      grayscale: 'B&W',
      highcontrast: 'High contrast',
      vivid: 'Vivid',
      dark: 'Dark',
      sepia: 'Sepia',
      fresh: 'Fresh',
      pastel: 'Pastel',
      film: 'Film',
      neon: 'Neon',
      lomo: 'Lomo',
      cinematic: 'Cinematic',
      golden: 'Golden hour',
      moonlight: 'Moonlight',
      intense: 'Intense',
      soft: 'Soft',
    },
    framePreset: {
      none: 'None',
      polaroid: 'Polaroid',
      'gradient-line': 'Gradient',
      'film-perf': 'Film',
      round: 'Round',
      dotted: 'Dots',
      timestamp: 'Timestamp',
      'film-slide': 'Slide',
      magazine: 'Magazine',
      blackline: 'Black line',
      doubleline: 'Double line',
      'shadow-card': 'Shadow',
      'neon-glow': 'Neon',
      doodle: 'Doodle',
      ticket: 'Ticket',
      'sticky-note': 'Sticky',
    },
  },
  splash: {
    slogan: 'Your neighborhood, anywhere',
    welcomeSlogan: 'Your neighborhood, anywhere',
    start: 'Get started',
    haveAccount: 'I already have an account',
    browseGuest: 'Browse without signing up',
  },
  feature: {
    comingSoonToast: 'Opening soon!',
    preparing: 'Coming soon',
    notifyMe: 'Notify me',
    waitlistRegistered: 'Thanks — we will notify you.',
    adminSaved: 'Feature flags saved.',
    adminDbError: 'Could not sync to Supabase. Check that your account has admin rights.',
    adminNotifyStub: 'Bulk push notifications require a server job; flags are live for the app now.',
  },
  chatBlocked: {
    chatBlocked: 'This user is blocked.',
  },
  errors: {
    offlineBanner: 'You are offline.',
    offline: 'Please check your internet connection.',
    generic: 'Something went wrong. Please try again.',
    tryAgain: 'Please try again in a moment',
    retry: 'Try again',
  },
  errorBoundary: {
    title: 'Something went wrong',
    offline: 'Please check your internet connection.',
    generic: 'Please refresh or try again in a moment.',
    reload: 'Refresh',
  },
  auth: {
    tagline: 'For expats & travelers',
    tabLogin: 'Log in',
    tabSignup: 'Sign up',
    email: 'Email',
    password: 'Password',
    passwordConfirm: 'Confirm password',
    nickname: 'Nickname',
    signup: 'Sign up',
    emailPlaceholder: 'email@example.com',
    passwordPlaceholder: 'Password',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    login: 'Log in',
    signupSubmit: 'Create account',
    browse: 'Browse without account',
    kakaoContinue: 'Continue with Kakao',
    googleContinue: 'Continue with Google',
    appleContinue: 'Continue with Apple',
    oauthDivider: 'Or continue with',
    oauthGroupAria: 'Social sign-in',
    placeholderEmail: 'email@example.com',
    placeholderPassword: 'Password',
    placeholderPasswordConfirm: 'Re-enter your password',
    placeholderNickname: 'Choose a nickname',
    passwordMismatch: 'Passwords do not match.',
    checkEmail: 'Check your email to confirm your account, then sign in.',
    referralOptional: 'Referral code (optional)',
    referralPlaceholder: 'e.g. MG-A3K9',
    forgotPassword: 'Forgot password?',
    forgot: {
      title: 'Reset password',
      tabEmail: 'Via email',
      tabPhone: 'Via phone',
      sendResetLink: 'Send reset link',
      checkEmail: 'Please check your email',
      getOtp: 'Send verification code',
      otpLabel: 'Verification code',
      otpPlaceholder: '6-digit code',
      verify: 'Verify',
      phone: 'Phone number',
      countryCode: 'Country code',
      backLogin: 'Back to sign in',
      otpSent: 'Verification code sent',
      phoneInvalid: 'Please check your phone number',
      otpInvalid: 'Enter the 6-digit code',
      dialKR: 'Korea',
      dialVN: 'Vietnam',
      dialJP: 'Japan',
      dialUSCA: 'US/Canada',
      dialGB: 'UK',
      dialAU: 'Australia',
      dialSG: 'Singapore',
      dialMY: 'Malaysia',
      dialTH: 'Thailand',
      dialPH: 'Philippines',
      dialID: 'Indonesia',
      dialCN: 'China',
      dialRU: 'Russia',
      dialDE: 'Germany',
      dialFR: 'France',
    },
    reset: {
      title: 'Set new password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      submit: 'Update password',
      success: 'Your password has been updated ✅',
      needSession: 'Session expired. Please try password recovery again.',
      mismatch: 'Passwords do not match',
    },
    loginSuccess: 'Signed in',
    logoutSuccess: 'Signed out',
    signupSuccess: 'Sign-up complete',
    errors: {
      generic: 'Something went wrong. Please try again.',
      invalidCredentials: 'Invalid email or password.',
      emailTaken: 'This email is already registered.',
      emailNotConfirmed: 'Please confirm your email before signing in.',
      weakPassword: 'Password is too short or does not meet requirements.',
      network: 'Network error. Check your connection.',
      providerDisabled: 'This sign-in method is not available yet. Please use email.',
    },
    needLegalConsents: 'Please accept the terms of service and privacy policy separately, and enter your date of birth.',
    legalConsentTitle: 'We need your consent to continue',
    legalConsentSubmit: 'Agree and continue',
    legalReconsentTitle: 'Our terms were updated. Please agree again',
    legalReconsentSubmit: 'Agree and continue',
    agreeTerms: 'I agree to the terms of service (required)',
    agreePrivacy: 'I agree to the collection and use of personal data (required)',
    agreeMarketing: 'I agree to receive marketing information (optional)',
    agreeLocation: 'I agree to location-related features where applicable (optional)',
    agreeAge14: 'I am 14 years of age or older (required)',
    birthDateLabel: 'Date of birth (required)',
    needBirthDate: 'Please enter your date of birth.',
    underAgeBlocked: 'You must be at least 14 years old to sign up.',
    viewTerms: 'View',
    viewPrivacy: 'View',
  },
  onboarding: {
    languageTitle: 'Which language do you use?',
    languageSubtitle: 'Select your language',
    languageListAria: 'Language list',
    next: 'Next',
    selectLanguage: 'Select a language',
    selectRegion: 'Select a region',
    start: 'Get started',
    browse: 'Browse first',
    later: 'Not now',
    welcome: 'Welcome',
    slogan: 'Your neighborhood, anywhere',
    haveAccount: 'I already have an account',
    locationConfirmTitle: 'Confirm your area',
    locationLoading: 'Checking your location…',
    locationError: 'Could not get location.',
    locationQuestion: '📍 Do you live in {place}?',
    yesStart: 'Yes, get started',
    pickManually: 'I will choose manually',
    locationSelectTitle: 'Choose your city',
    countryLabel: 'Country',
    cityHint: 'Select up to 2 cities',
    maxHint: 'You can select up to 2 cities.',
    maxToast: 'You can select up to 2 cities.',
    locationManualToast: 'We could not detect your location. Please choose manually.',
    done: 'Done',
    wizardLangTitle: 'Choose your language',
    wizardRegionTitle: 'Choose your area',
    wizardDanang: 'Da Nang · start now',
    wizardOther: 'Ho Chi Minh, Hanoi & others (waitlist)',
    wizardBack: 'Back',
    interestTitle: 'What are you interested in?',
    interestSubtitle: "We'll personalize what you see",
    adminFeaturesTitle: 'Feature flags',
    adminLaunchAt: 'Go-live (optional)',
    adminNotifyAll: 'Send go-live notice (info)',
    nationalityTitle: 'Select your nationality',
    nationalityDesc: "We'll show relevant embassy and consulate info",
    nationalityKR: 'Korean',
    nationalityRU: 'Russian',
    nationalityEN: 'English',
    nationalityJP: 'Japanese',
    nationalityCN: 'Chinese',
    nationalityVN: 'Vietnamese',
    nationalityOther: 'Other',
    selectType: 'Who are you?',
    typeExpat: 'Expat',
    typeExpatDesc: 'Korean living\nabroad',
    typeTourist: 'Tourist',
    typeTouristDesc: 'Traveling or\nplanning a trip',
    typeNomad: 'Digital Nomad',
    typeNomadDesc: 'Working while\ntraveling',
    typeBusiness: 'Business',
    typeBusinessDesc: 'Running a business\nor business',
    selectInterests: 'Select your interests',
    selectInterestsDesc: 'We show personalized content',
  },
  guest: {
    loginRequiredTitle: 'Sign in required',
    loginRequiredMessage: 'Please log in to use this feature.',
    login: 'Log in',
    cancel: 'Cancel',
  },
  location: {
    selectRegion: 'Select a region',
    addRegion: 'Add Region',
    primaryRegion: 'Primary Region',
    secondaryRegion: 'Secondary Region',
    gpsAutoDetected: 'Auto-detected location',
    activeBasis: 'Viewing: {region}',
    switchedTo: 'Switched to {region}',
    editRegion: 'Edit',
    saveButton: 'Save',
    saved: 'Saved',
    currentViewing: 'Current region',
    none: 'No region selected',
    pickOne: 'Select at least one city',
    emptySelection: 'Please select a region',
    gpsUnmapped: 'We could not confirm your location. Please select a region.',
    gpsManualPickHint: 'GPS location unavailable. Please choose a city manually.',
    summary: 'Main: {main} | Sub: {sub}',
    summaryMainOnly: 'Main: {main}',
    badgeMain: 'Main',
    badgeSub: 'Sub',
    pickCountryTitle: 'Choose a country',
    pickCityTitle: 'Choose a city',
    backToCountries: 'Countries',
    searchPlaceholder: 'Search cities…',
    availableBadge: 'Available',
    preparingBadge: 'Opening soon',
    waitlistCount: 'Waitlist: {n}',
    popular: 'Popular',
    allCities: 'All cities',
    legendOpen: 'Open regions are ready to use.',
    suggestedLocaleNote: 'Tip: {lang} is often useful in this area (change anytime in settings).',
    radiusTitle: 'Location & Radius Settings',
    radiusMenuLabel: 'Location Radius',
    radiusDesc: 'Set how wide an area you want to see information for each location',
    selectRadius: 'Select Search Radius',
    addLocation: 'Add Location',
    selectCountry: 'Select Country',
    selectCity: 'Select City',
    selectCityPlaceholder: 'Select a city',
    labelOptional: 'Label (optional)',
    labelPlaceholder: 'e.g. My neighborhood, Near work',
    addBtn: 'Add',
    settingSaved: 'Location setting saved',
    settingFailed: 'Save failed',
    settingFailedDetail: 'Save failed: {detail}',
    radiusUpdated: 'Radius updated',
    primarySpotLabel: 'Primary location',
    gpsAuto: 'Current Location (Auto)',
    gpsDetecting: 'Detecting location...',
    gpsAutoDesc: 'Auto detected via GPS · No change needed',
    interestLocation: 'Interest Location (Manual)',
    viewByCurrentGps: '📍 View by current location',
    currentSelection: 'Current selection: {summary}',
    gpsCityTitle: 'Current GPS city',
    gpsBadge: 'GPS',
    removeInterest: 'Remove {region}',
    backToSearch: '← Back to search',
    searchAgain: '← Search again',
  },
  travelHub: {
    title: 'Travel',
    subtitle: 'How would you like to plan your {city} trip?',
    packageTitle: 'Package tour',
    packageDesc: 'Flight + stay + tours bundled into a set itinerary',
    freeTitle: 'Independent travel',
    freeDesc: 'Pick and combine stays, tours, and activities yourself',
    quoteTitle: 'Custom quote request',
    quoteDesc: 'Tell us headcount, budget, and dates — an expert will propose a quote',
    quoteHint: "Not sure what to choose? Start with a custom quote request.",
    quoteFormTitle: 'Custom quote request',
    fieldCity: 'Destination',
    fieldHeadcount: 'Headcount',
    headcountPh: 'Number of travelers',
    fieldBudget: 'Budget range',
    fieldDates: 'Preferred dates',
    fieldDatesPh: 'e.g. early September, not sure yet',
    fieldContact: 'Contact (optional)',
    fieldContactPh: 'Where should we reach you?',
    fieldNote: 'Additional notes',
    fieldNotePh: 'Traveling with kids, seniors, preferred stay, etc.',
    budgetUnder50: 'Under $500',
    budget50to100: '$500–1,000',
    budget100to200: '$1,000–2,000',
    budgetOver200: 'Over $2,000',
    submitBtn: 'Request a quote',
    submitting: 'Sending…',
    submitSuccess: "Your request is in. We'll be in touch.",
    submitError: "Couldn't send your request. Please try again.",
    loginRequired: 'Please log in to use this feature.',
    destStepTitle: 'Where are you headed?',
    destStepSubtitle: 'Pick a country, then a city — or skip and browse everything.',
    destCountryLabel: 'Country',
    destCityLabel: '{country} — pick a city',
    destNoCities: 'No cities listed yet.',
    destSkip: 'Skip for now',
    subtitleWithDest: 'What do you need for your {dest} trip?',
    browseTitle: 'Browse tours & activities',
    browseDesc: 'Single-day tours, activities, golf, car rental, and more',
    consultTitle: 'Independent travel / package — talk to an expert',
    consultDesc: 'Tell us your plans and get a custom quote',
    hubFab: 'Custom quote',
    adultsLabel: 'Adults',
    childrenLabel: 'Children',
    infantsLabel: 'Infants',
    fieldPurpose: 'Purpose of trip',
    purposeFamily: 'Family trip',
    purposeHoneymoon: 'Honeymoon',
    purposeParents: 'Trip for parents',
    purposeFriends: 'Friends trip',
    purposeGolf: 'Golf trip',
    fieldHotelGrade: 'Preferred hotel grade',
    hotelGuesthouse: 'Guesthouse',
    hotel3: '3-star',
    hotel4: '4-star',
    hotel5: '5-star',
    hotelResortVilla: 'Resort / pool villa',
    fieldRoomType: 'Room type',
    roomSingle: 'Single',
    roomDouble: 'Double',
    roomTwin: 'Twin',
    roomFamily: 'Family room',
    singleSupplementNote: 'A single room may include an extra single-supplement charge.',
    fieldMealPlan: 'Meals included',
    mealNone: 'No meals',
    mealBreakfast: 'Breakfast only',
    mealBreakfastDinner: 'Breakfast + dinner',
    fieldFlightIncluded: 'Flight',
    flightYes: 'Include flight',
    flightTourOnly: 'Tour/stay only',
    flightUnsure: 'Not sure yet',
    fieldActivities: 'Activities you want',
    actActivity: 'Activities',
    actMassage: 'Massage/spa',
    actGolf: 'Golf',
    actFood: 'Food tour',
    actShopping: 'Shopping',
    actSnap: 'Photo/snap',
  },
  interest: {
    food: 'Food',
    golf: 'Golf',
    realestate: 'Real Estate',
    medical: 'Medical',
    education: 'Education',
    shopping: 'Shopping',
    sports: 'Sports',
    culture: 'Culture',
    finance: 'Finance',
    parenting: 'Parenting',
    beauty: 'Beauty',
    travel: 'Travel',
  },
  mypage: {
    myInfo: 'My info',
    myTrades: 'My trades',
    favorites: 'Saved',
    points: 'Points',
    notifications: 'Notifications',
    settings: 'App settings',
    privacy: 'Privacy policy',
    terms: 'Terms of service',
    logout: 'Log out',
    withdrawal: 'Delete account',
    referralCode: 'My referral code',
    editProfile: 'Edit profile',
    mannerTemp: 'Manner score',
    reviews: 'Reviews received',
  },
  profile: {
    nickname: 'Nickname',
    bio: 'Bio',
    contact: 'Contact',
    kakao: 'KakaoTalk ID',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    phone: 'Phone',
    nationality: 'Nationality',
    residence: 'Residence',
    language: 'Language',
    editPhoto: 'Change photo',
    save: 'Save',
    follow: 'Follow',
    following: 'Following',
    receiveNotifications: 'Notifications',
    addChannel: 'Add channel',
    externalNotifications: 'External notifications',
    externalNotificationsHint: 'When on, we can reach you outside the app so you do not miss important updates.',
  },
  visa: {
    expiry: 'Visa expiry',
    dday: 'Time left',
    type: 'Visa type',
    reminder: 'Expiry reminder',
    expired: 'Expired',
    safe: 'Safe',
    warning: 'Warning',
    danger: 'Critical',
  },
  emergency: {
    police: 'Police',
    fire: 'Fire',
    ambulance: 'Ambulance',
    embassy: 'Embassy',
    community: 'Community',
    common: 'General',
    call: 'Call',
    disclaimer: 'Numbers may change',
    empty: 'No contacts found',
    category: {
      all: 'All',
      emergency: 'Emergency',
      embassy: 'Embassy',
      hospital: 'Hospital',
      community: 'Community',
    },
  },
  pwa: {
    bannerAria: 'Install app',
    bannerTitle: 'Add Mingo to your home screen',
    iosHint: 'Tap Share, then “Add to Home Screen”.',
    androidHint: 'Tap Install below, or use your browser menu → Install app.',
    install: 'Install',
    close: 'Close',
  },
  header: {
    pickRegion: 'Choose region',
    myNeighborhood: 'My area',
    regionPickerAria: 'Choose region',
    regionHint: 'Up to 2 regions.',
    regionLimit: 'You already selected 2. Deselect one to change.',
    closePanel: 'Close region picker',
    search: 'Search',
    notifications: 'Notifications',
    services: 'All services',
    visaDday: 'Visa D-{n}',
    visaExpired: 'Visa expired',
  },
  search: {
    placeholder: 'Search listings, posts & jobs',
    placeholderAll: 'Search all',
    placeholderHub: 'Search in {hub}',
    categoryAll: 'All categories',
    hint: 'Full-text search on marketplace, community, and jobs.',
    empty: 'No results.',
    products: 'Marketplace',
    catalogItems: 'Bookable items',
    posts: 'Community',
    jobs: 'Jobs',
    tabAll: 'All',
    tabBiz: 'Business',
    tabCatalogItems: 'Bookable items',
    tabProducts: 'Trade',
    tabStories: 'Shorts',
    tabPosts: 'Community',
    tabJobs: 'Jobs',
    adBadge: 'Ad',
    jobHireBadge: 'Hire',
    jobSeekBadge: 'Seek',
    jobsMoreInTab: 'Open the Jobs tab for more listings.',
    recentTitle: 'Recent searches',
    popularTitle: 'Popular',
    popularTerm1: 'Da Nang studio',
    popularTerm2: 'Visa extension',
    popularTerm3: 'Motorbike rental',
    popularTerm4: 'Korean groceries',
    popularTerm5: 'Part-time jobs',
  },
  feed: {
    interested: 'Interested',
    notInterested: 'Not interested',
    hidePost: 'Hide post',
    whySeeing: 'Why am I seeing this?',
    report: 'Report',
  },
  shorts: {
    discover: 'Neighbor',
    storyHome: 'Mingle',
    neighbor: 'Neighbor',
    mingle: 'Mingle',
    adBadge: 'Ad',
    adCta: 'Learn more',
    adHint: 'Sponsored',
    storyTabNearby: '📍 Near me',
    storyTabWebtoon: '🎨 Webtoon',
    storyTabPopular: '⭐ Popular',
    filterAll: 'All',
    filterVideo: 'Video',
    filterWebtoon: 'Webtoon',
    filterBlog: 'Blog',
    filterBusiness: 'Business',
    filterNews: 'News',
    filterLife: 'Life',
    filterSettle: 'Settling in',
    tabEmptyNews: 'No news to show yet',
    tabEmptySettle: 'No settling-in guides yet',
    tabEmptyLife: 'No life posts yet',
    tabEmptyMingle: 'No mingle stories yet',
    pullHint: '↓ Pull to refresh',
    pullRelease: 'Release to refresh',
    webtoonEmpty: 'No webtoons yet',
    webtoonStartSeries: 'Start a series',
    webtoonEpisodeSuffix: ' ep.',
    webtoonPremiumBadge: '💎 Premium',
  },
  translation: {
    insufficientPoints: 'Insufficient points. Please charge first',
    pointsBalance: 'Current Points',
    costPerUse: 'Cost per translation',
    premiumFree: 'Premium members: 20 free/month',
    dashboardTitle: 'Translation Manager',
    menuLabel: 'Content Translations',
    dashboardDesc:
      'Translate your shorts/stories to reach more expats. AI will help with automatic translation.',
    noStories: 'No stories found',
    autoBtn: '✨ Auto Translate with AI',
    translating: 'AI is translating...',
    autoComplete: 'AI translation complete. Please review and save',
    autoFailed: 'Auto translation failed. Please enter manually',
    saved: 'Translations saved',
    saveFailed: 'Save failed',
    saveBtn: 'Save Translations',
    loadingStories: 'Loading…',
    statusDone: '✅ Translated',
    statusNeed: '⚠️ Needs translation',
    sourceTag: 'Original',
    fieldTitle: 'Title',
    fieldCaption: 'Caption',
    chargePack500Tag: '🌐 ~10 translation runs',
    dashboardHint: 'Translate your story title and caption to EN/VI/RU and save.',
    pickStory: 'Choose a story',
    selectPlaceholder: 'Select…',
    previewTitle: 'Title',
    previewCaption: 'Caption',
    runAuto: 'AI translate',
    saveOk: 'Translations saved.',
  },
  points: {
    toastAwarded: '🎉 +{amount}P added to your balance!',
    insufficientToast: 'Not enough points.',
    homeLowBanner: 'Your point balance is low.',
    homeLowCta: 'Top up / earn',
    chargeTitle: 'Charge Points',
    currentBalance: 'Current Balance',
    selectPackage: 'Select Package',
    popular: 'Popular',
    bonus: 'Bonus',
    total: 'Total',
    chargeNotice: 'Notice',
    noticeItem1: 'Points are credited after admin approval',
    noticeItem2: 'Points can be used for ads and premium features',
    noticeItem3: 'Charged points are non-refundable',
    chargeRequested: 'Charge requested. Points will be credited after review',
    chargeFailed: 'Charge request failed',
    chargeBtn: 'Request Payment',
    selectFirst: 'Please select a package',
    charge: 'Charge',
    insufficient: 'Insufficient points. Please charge first',
  },
  share: {
    open: 'Share',
    system: 'Share via…',
    kakao: 'KakaoTalk',
    copy: 'Copy link',
    copied: 'Link copied to clipboard.',
    copyFailed: 'Could not copy.',
    kakaoHint: 'Link copied. Open KakaoTalk to paste if needed.',
    promoFooter: '🏝️ See more Da Nang life info on the Mingo app',
  },
  rateLimit: {
    toast: 'Please try again in a moment.',
  },
  privacyPage: {
    title: 'Privacy policy',
    collected: 'Information we collect',
    collectedBody:
      'We may process: (1) Account — email, password (hashed at the auth provider), nickname, profile and settings; (2) Location — region/city you choose, optional device location if you allow it; (3) User content — posts, comments, images, chat messages, listings, reviews; (4) Activity — app interactions, logs, device/browser type, and similar technical data to operate and protect the service.',
    purpose: 'Purpose',
    purposeBody:
      'To run and improve the service, show relevant local content, keep accounts secure, meet legal duties, and communicate with you (including optional marketing if you opt in).',
    retention: 'Retention',
    retentionBody: 'Until you delete your account or the data is no longer needed, except where a longer period is required by law.',
    thirdParty: 'Third-party sharing',
    thirdPartyBody:
      'We do not sell your data. We use infrastructure providers (e.g. cloud hosting) who process data only to provide the service. We do not share for unrelated third-party marketing without consent.',
    gdpr: 'GDPR & EEA/UK',
    gdprBody:
      'If applicable, you may have rights to access, rectify, delete, restrict or object to processing, and to port data. You may lodge a complaint with your supervisory authority.',
    deletion: 'Deletion requests',
    deletionBody: 'To delete your account: App settings → Delete account. You can also contact us by email. Some records may be retained as required by law or for dispute resolution.',
    security: 'Security',
    securityBody: 'We use industry-standard practices (e.g. encryption in transit, access control). No method is 100% secure; use a strong, unique password.',
    contact: 'Contact',
    cookies: 'Cookies & similar technologies',
    cookiesBody:
      'We use cookies, local storage, and similar technologies to keep you signed in, remember preferences, measure basic usage, and reduce abuse. You can clear app storage or use browser controls where applicable.',
    minors: 'Children and teens',
    minorsBody:
      'The service is not directed at children under the age where parental consent is required in your country. If you believe a minor has provided personal data, contact us and we will take appropriate steps.',
    transfers: 'International transfers',
    transfersBody:
      'We may process data in countries where our providers operate (including outside your residence). Where required, we rely on appropriate safeguards such as standard contractual clauses or equivalent mechanisms.',
    regulatory: 'Regulatory disclosures',
    regulatoryBody:
      'Depending on your location, additional rights or disclosures may apply. Nothing in this policy limits non-waivable rights under local law.',
    disputePrivacy: 'Privacy complaints',
    disputePrivacyBody:
      'Contact us first for privacy-related concerns. You may also lodge a complaint with your local data protection authority where applicable law allows.',
  },
  termsPage: {
    title: 'Terms of service',
    intro: 'About the service',
    introBody:
      'Mingo is an information and community platform that connects people and content. We are not a party to your offline deals, rentals, or employment.',
    role: 'Role of the platform',
    roleBody:
      'Mingo helps you discover and share information. We are not a broker, agent, job agency, bank, or escrow provider unless a separate contract says otherwise. Users contract directly with each other.',
    rules: 'Rules of use',
    rulesBody: 'You must not post deceptive identity or contact information, and you should follow safe trading and community guidelines.',
    prohibited: 'Prohibited conduct',
    prohibit1: 'Fraud, fake listings, or attempts to steal money',
    prohibit2: 'Harassment, hate speech, or abusive language',
    prohibit3: 'Illegal content; misrepresenting who you are',
    prohibit4: 'Spam, flooding, or abusive automation',
    disclaimer: 'Disclaimer',
    disclaimerBody:
      'The service and all content are provided “as is”. We do not guarantee accuracy of user content or third-party information. We are not liable for losses from user-to-user dealings; use your own judgment and meet locally and safely for trades.',
    dispute: 'Disputes',
    disputeBody: 'For disputes with other users, try in-app report/block first. You may also use the courts. Contact us for good-faith cooperation.',
    law: 'Governing law and jurisdiction',
    lawBody: 'These terms are governed by the laws of the Republic of Korea. Courts of the Republic of Korea have exclusive jurisdiction, unless applicable law provides otherwise and cannot be waived.',
    modifications: 'Changes to these terms',
    modificationsBody:
      'We may update these terms to reflect product, legal, or security changes. Material updates will be communicated in-app or by email where appropriate. Continued use after the effective date constitutes acceptance of the updated terms.',
    indemnity: 'Indemnity',
    indemnityBody:
      'To the extent permitted by law, you agree to indemnify and hold harmless Mingo and its affiliates, officers, and employees from claims, losses, and expenses (including reasonable legal fees) arising from your misuse of the service, your content, or your violation of these terms or applicable law.',
    userContent: 'User content & license',
    userContentBody:
      'You retain rights to content you post, but you grant Mingo a worldwide, non-exclusive, royalty-free license to host, store, reproduce, modify (for formatting/translation), display, and distribute your content solely to operate, promote, and improve the service, including safety and moderation.',
    aiDisclaimer: 'AI, translation, and fortune features',
    aiDisclaimerBody:
      'Automated translation, recommendations, and fortune-style features are for entertainment and convenience only. They are not professional advice (legal, medical, financial, immigration, or otherwise). Do not rely on them as a substitute for qualified professionals.',
    marketplaceRisk: 'Peer-to-peer transactions',
    marketplaceRiskBody:
      'Listings, chats, and meet-ups are between users. Mingo does not guarantee identity, quality, or delivery. Meet in safe public places, verify documents independently, and use payment methods you understand. Report suspected scams using in-app tools.',
    arbitration: 'Informal dispute resolution',
    arbitrationBody:
      'Before filing a claim, you agree to contact us in good faith so we can try to resolve the issue. Nothing here prevents either party from seeking urgent injunctive relief where permitted by law.',
    severability: 'Severability',
    severabilityBody:
      'If any provision is held invalid or unenforceable, the remaining provisions remain in full force and effect.',
    accessibility: 'Accessibility',
    accessibilityBody:
      'We aim to improve readability and mobile usability. If you encounter barriers, please contact us with details so we can consider reasonable improvements.',
  },
  notificationCenter: {
    title: 'Notifications',
    markAll: 'Mark all read',
    unread: 'Unread',
    loading: 'Loading notifications…',
    emptyRemote: 'No notifications yet.',
    delete: 'Delete',
    tab: {
      all: 'All',
      unread: 'Unread',
      read: 'Read',
    },
  },
  detailPages: {
    loading: 'Loading…',
    error: 'Could not load.',
    retry: 'Retry',
    notFound: 'This page is not available.',
    translate: '🌐 Translate',
    original: 'Show original',
    translateFail: 'Translation failed. Try again later.',
    translatedBlock: 'Translated text',
    report: 'Report',
    userProfile: 'Profile',
    manner: 'Manner score',
    followers: 'Followers',
    following: 'Following',
    follow: 'Follow',
    followingBtn: 'Following',
    followSaved: 'Updated.',
    message: 'Message',
    chat: 'Chat',
    anonymous: 'Anonymous',
    block: 'Block',
    blocked: 'User blocked.',
    profileEmpty: 'No content to show yet.',
    profileTab: { sell: 'For sale', reviews: 'Reviews', activity: 'Activity' },
    workType: 'Work type',
    deadline: 'Deadline',
    description: 'Description',
    qualifications: 'Requirements',
    applySoon: 'Apply (coming soon)',
    save: 'Save',
    similarJobs: 'Similar jobs',
    experience: 'Experience',
    expCat: { tour: 'Tour', culture: 'Culture' },
    maxPeople: 'Max guests',
    included: 'Included',
    excluded: 'Not included',
    meet: 'Meet-up',
    host: 'Host',
    reviews: 'Reviews',
    bookSoon: 'Book (coming soon)',
    participantFlags: 'Participants',
    comments: 'Comments',
    commentPlaceholder: 'Write a comment',
    postComment: 'Post',
    commentSoon: 'Comments will be available soon.',
    joinToast: 'Joined.',
    back: 'Back',
    share: 'Share',
    more: 'More',
    review: 'Review',
    noReviews: 'No reviews yet.',
    bookNow: 'Book now',
    visitBooking: 'Visit / call',
    contactUs: 'Contact us',
    callNow: 'Call now',
    chatNow: 'Chat now',
    directions: 'Directions',
    hours: 'Hours',
    location: 'Location',
    menu: 'Menu',
    price: 'Price',
    organizer: 'Organizer',
    businessReviews: 'All reviews',
    starDistribution: 'Star breakdown',
    photoReviews: 'Photo reviews',
    reviewSort: { new: 'Newest', high: 'Highest', low: 'Lowest' },
    ownerReply: 'Owner reply',
    writeReview: 'Write a review',
    region: 'Region',
    expatEstimate: 'Est. community size',
    emergency: 'Emergency numbers',
    recentPosts: 'Recent posts',
    topBusinesses: 'Featured listings',
    emptyBusinesses: 'No listings yet.',
    course: 'Course',
    instructor: 'Instructor',
    curriculum: 'Curriculum',
    studentReviews: 'Student reviews',
    enrollSoon: 'Enroll (coming soon)',
    relatedCourses: 'Related courses',
    rentalList: 'Vehicle rental',
    rental: 'Rental',
    rentalKind: {
      all: 'All',
      motorcycle: 'Motorcycle',
      scooter: 'Scooter',
      car: 'Car',
      bicycle: 'Bicycle',
    },
    maxPriceDay: 'Max price / day (VND)',
    regionFilter: 'Area',
    priceDay: 'Day',
    priceWeek: 'Week',
    priceMonth: 'Month',
    deposit: 'Deposit',
    insurance: 'Insurance',
    features: 'Highlights',
    pickup: 'Pick-up spots',
    datePick: 'Date',
    contact: 'Contact',
    contactChat: 'Opening chat…',
    similarVehicles: 'Similar vehicles',
    visaServiceList: 'Visa agencies',
    visaService: 'Visa service',
    koreanOk: 'Korean OK',
    successRate: 'Success rate',
    from: 'From',
    processing: 'Processing time',
    express: 'Express',
    professionalList: 'Professional services',
    professional: 'Professional',
    proCat: {
      all: 'All',
      tax: 'Tax',
      accounting: 'Accounting',
      legal: 'Legal',
      admin: 'Admin',
      translate: 'Translation / notary',
      insurance: 'Insurance',
      finance: 'Finance',
    },
    serviceMenu: 'Services',
    consultSoon: 'Request consult (coming soon)',
    similarPros: 'Similar professionals',
    academyList: 'Academies & classes',
    academy: 'Academy',
    academyCat: {
      all: 'All',
      language: 'Language',
      study: 'Tutoring',
      arts: 'Arts',
      sports: 'Sports',
      cooking: 'Cooking',
    },
    online: 'Online',
    offline: 'Offline',
    classInfo: 'Classes',
    tuition: 'Tuition',
    capacity: 'Enrollment',
    schedule: 'Schedule',
    trialYes: 'Trial class available',
    trialNo: 'No trial',
    teachers: 'Teachers',
    expYears: 'Experience',
    langs: 'Languages',
    facilities: 'Facilities',
    enroll: 'Sign up',
    pickClass: 'Choose a class',
    select: 'Select',
    trialApplySoon: 'Book trial (coming soon)',
    similarAcademy: 'Similar academies',
    hospitalType: {
      general: 'General / clinic',
      pharmacy: 'Pharmacy',
    },
    clinicInfo: 'Clinic info',
    needAppt: 'Appointment required',
    boolYes: 'Yes',
    boolNo: 'No',
    waitEst: 'Est. wait',
    doctors: 'Doctors',
    noDoctors: 'No doctor list for this listing.',
    costs: 'Fees',
    costFirst: 'First visit',
    costFollow: 'Follow-up',
    receipt: 'Receipt for insurance',
    booking: 'Booking',
    timePick: 'Time',
    open24: '24h',
    er: 'ER',
    activityList: 'Activities & leisure',
    activity: 'Activity',
    activityCat: {
      all: 'All',
      water: 'Water sports',
      golf: 'Golf',
      spa: 'Spa',
      photo: 'Photo',
      tour: 'Tours',
      culture: 'Culture',
    },
    schedulePick: 'Pick a date',
    similarActivity: 'Similar activities',
  },
  home: {
    feedLabel: 'Local listings',
    categories: { all: 'All', used: 'Used', rent: 'Rent', job: 'Jobs' },
    loadingFeed: 'Loading feed…',
    pullRelease: 'Release to refresh',
    productCategoryFilter: 'Category',
    sectionCategoryServices: 'Services',
    sectionTrade: 'Recent trade',
    sectionMingoStory: 'Mingo Story',
    sectionFeedAds: 'Featured',
    sectionHotCommunity: 'Popular posts',
    sectionLostFound: 'Lost & missing news',
    lostFoundUrgent: 'Urgent',
    sectionEvents: 'Events & markets',
    ariaEvents: 'Events and markets',
    sectionNearbyBiz: 'Nearby businesses',
    adRailTitle: 'Recommended places',
    sponsored: 'Sponsored',
    sectionLife: 'Local & living',
    sectionCommunity: 'Community',
    sectionVnNews: 'Vietnam news',
    ariaVnNews: 'Vietnam news',
    sectionCountryNews: '{country} News',
    ariaCountryNews: '{country} News',
    sectionDiscover: 'Discover',
    ariaDiscover: 'Discover feed',
    discoverLoadMore: 'Load more',
    newsAgo: {
      justNow: 'Just now',
      minutes: '{n}m ago',
      hours: '{n}h ago',
      days: '{n}d ago',
      weeks: '{n}w ago',
      months: '{n}mo ago',
      years: '{n}y ago',
    },
    newsSource: {
      embassy: 'Embassy',
      local: 'Local',
      exchange: 'FX',
      general: 'News',
      insidevina: 'InsideVina',
      default: 'News',
    },
    newsCategory: {
      politics: 'Politics',
      society: 'Society',
      economy: 'Economy',
      sports: 'Sports',
      general: 'General',
    },
    newsCategoryAll: 'All',
    more: 'More',
    visaRun: 'Visa run',
    noVisaRun: 'None scheduled',
    emptySection: 'No items to show yet.',
    regionChange: 'Change region',
    noBizInRegion: 'No businesses in this area yet.',
    showAllBiz: 'Show all',
    tradeAllRegion: 'All areas',
    eventAriaLabel: 'Mingo events',
    eventTitle: '🎯 Mingo events',
    eventEmptyHint: 'Browse meetups and events and join the community.',
    eventSeeAll: 'See all events',
    interestAds: 'For You',
    shortsPromo: 'Mingo Story',
    shortsPromoTitle: 'Discover expat life in Da Nang\nthrough Shorts',
    shortsPromoBtn: 'Watch Shorts',
    interestAdsSub: 'Based on your interests',
    communityEmpty: 'No posts yet. Be the first to write!',
    communityWriteBtn: 'Write Post',
    sampleBiz: 'Sample',
    dealTitle: "Today's deals",
    globalServices: 'Global Services',
    globalServicesSub: 'Services available anywhere',
    onlineServices: 'Online Services',
    onlineServicesSub: 'Services available online',
    badgeGlobal: 'Global',
    badgeOnline: 'Online',
    recTitleTourist: '🎯 Tourist Picks',
    recTitleNomad: '💻 Nomad Picks',
  },
  trade: {
    title: 'Trade',
    openVehiclesPage: 'Used cars & bikes',
    vehiclesHint: 'Cars, bikes & scooters — filter by brand, year, and mileage.',
    empty: 'No listings in this category.',
    selling: 'Selling',
    reserved: 'Reserved',
    done: 'Done',
    laneAll: 'All',
    laneFeed: 'Feed',
    laneUsed: 'Used',
    laneRent: 'Rent',
    laneJobs: 'Jobs',
    laneGroup: 'Group buy',
    lanesAria: 'Trade type',
    categoryFilter: 'Category',
    searchPlaceholder: 'Search items / location',
    shortcuts: {
      aria: 'Shortcuts',
      realEstate: 'Real estate',
      jobs: 'Jobs',
      moving: 'Moving',
      rental: 'Rental',
      groupBuy: 'Group buy',
      vehicle: 'Vehicles',
    },
    jobsInlineHint: 'Job listings preview — open the Jobs page to post and filter.',
    openJobsPage: 'Open Jobs',
    openGroupBuyPage: 'All group buys',
    price: 'Price',
    region: 'Area',
    category: 'Category',
    description: 'Describe your item',
    priceInput: 'Enter price',
    addPhoto: 'Add photo',
    currency: 'Currency',
    condition: 'Condition',
    new: 'New',
    used: 'Used',
    sold: 'Sold',
    auctionLink: 'Used-goods auction',
    auctionHint: 'Timed auctions for verified listings — bid safely inside Mingo.',
  },
  valueAdd: {
    nlPageTitle: 'Newsletters & premium',
    nlPageIntro: 'Curated deep dives from trusted creators. Paid tiers unlock archives.',
    nlSubscribe: 'Subscribe',
    nlSubSoon: 'Subscriptions will open in a future billing update.',
    nlPaid: 'Paid',
    nlFree: 'Free',
    nlSubs: '{n} subscribers',
    nlAuthor1: 'DN Weekly Ed.',
    nlAuthor2: 'Biz Desk',
    nlAuthor3: 'Mingo Tips',
    nlTitle1: 'Da Nang real estate weekly',
    nlDesc1: 'Listings, rent trends, and zoning notes — not legal advice.',
    nlCatRe: 'Real estate',
    nlTitle2: 'Vietnam business insights',
    nlDesc2: 'Tax reminders, entity types, and hiring basics for SMEs.',
    nlCatBiz: 'Business',
    nlTitle3: 'Expat life hacks',
    nlDesc3: 'Groceries, schools, and weekend trips — community sourced.',
    nlCatLife: 'Lifestyle',
    consultSection: 'Book a consultation slot',
    consultPickDate: 'Pick a date',
    consultPickTime: 'Pick a time slot',
    consultMethod: 'How should we meet?',
    consultVideo: 'Video call',
    consultVoice: 'Voice call',
    consultInPerson: 'In person (Da Nang)',
    consultConfirm: 'Confirm booking',
    consultConfirmSoon: 'Calendar booking will sync after payments go live.',
    paPageTitle: 'Used-goods auction',
    paPageIntro: 'Auctions for marketplace items — escrow & shipping rules ship later.',
    paEndsIn: 'Ends in',
    paHigh: 'Current high bid',
    paOpen: 'Opening bid',
    paBids: '{n} bids',
    paBidSoon: 'Place bid (soon)',
    paBuyNowSoon: 'Buy now (soon)',
    paBuyNowHint: 'Instant price about {p} USD while listed.',
    paBidList: 'Recent bids',
    paTitle1: 'iPhone 15 Pro — mint, boxed',
    riderTitle: 'Delivery rider hub',
    riderIntro: 'Partner with Mingo delivery — earn on flexible shifts.',
    riderRegister: 'Become a rider',
    riderRegisterHint: 'Background check and gear checklist will appear in onboarding v2.',
    riderCta: 'Start rider signup',
    riderRegisterSoon: 'Rider signup opens soon — you are on the interest list.',
    riderCalc: 'Income calculator (demo)',
    riderHours: 'Active hours / day',
    riderDrops: 'Completed drops / day',
    riderPerDrop: 'Avg. payout per drop (₫)',
    riderEst: 'Estimated day',
    riderEstNote: '(before platform fee; illustrative only)',
    riderStatus: 'Live delivery map',
    riderStatusSoon: 'Live map — coming soon',
    petHotelSection: 'Pet hotels & boarding',
    petHotelPerNight: '/ night from',
    petHotelBookSoon: 'Reserve stay (soon)',
    ph1Name: 'Paw Beach Resort',
    ph2Name: 'Son Tra Pet Lodge',
    ph3Name: 'An Thuong Cat Hotel',
    petDog: 'Dogs',
    petCat: 'Cats',
    petSmall: 'Small pets',
    finTitle: 'Financial planner',
    finIntro: 'Private draft — numbers stay on this device until cloud sync ships.',
    finCashflow: 'Monthly cashflow',
    finIncome: 'Income',
    finExpense: 'Expenses',
    finSurplus: 'Surplus',
    finGoal: 'Savings goal',
    finGoalMonthly: 'Target monthly save',
    finGoalOk: 'Surplus meets your monthly savings target.',
    finGoalGap: 'You are about {gap} USD short vs your monthly savings target.',
    finAssets: 'Assets',
    finAssetsTotal: 'Total assets',
    finFx: 'FX snapshot',
    finFxHint: 'Rates from Open Exchange Rates (USD base). For decisions, verify with your bank.',
    finConvAssets: 'Assets in VND (indicative)',
    pmTitle: 'Point market',
    pmIntro: 'Redeem points for perks — inventory syncs with the rewards program.',
    pmRedeem: 'Redeem',
    pmRedeemSoon: 'Redemptions will debit points when checkout is live.',
    pmCoffee: 'Café coupon (partner)',
    pmDelivery: 'Delivery fee waiver',
    pmCredit: 'Ad credit (small)',
    pmPremium: 'Premium week pass',
    botFab: 'Open Mingo assistant',
    botTitle: 'Mingo assistant',
    botLead: 'Curious about Mingo, visas, or which service to open?',
    botChipVisa: 'Explain tourist visa extensions in Vietnam',
    botChipServices: 'Recommend services for a new arrival in Da Nang',
    botChipSafety: 'How does Mingo help avoid scams?',
    botPh: 'Ask anything…',
    botSend: 'Send',
    botTyping: 'Thinking…',
    botNoKey: 'AI chat needs a signed-in session and server ANTHROPIC_API_KEY. Meanwhile: try Local info → Visa, or Community for peer tips.',
    botErr: 'Could not reach AI. Try again or use the FAQ chips.',
    botDisclaimer: 'AI answers are informational, not legal advice. Always confirm with official sources.',
    botFaq1q: 'What is Mingo?',
    botFaq1a: 'Mingo is an expat-focused safety and life-info app: verified listings, community, and local services in Da Nang and beyond.',
    botFaq2q: 'Where do I set visa reminders?',
    botFaq2a: 'Profile → Visa expiry date, or Visa & admin guide from the menu.',
    botFaq3q: 'How do I report a scam listing?',
    botFaq3a: 'Open the listing → Report, or use SOS → Scam / fraud for quick guidance.',
  },
  life: {
    title: 'Local info',
    localIntro: 'Search or pick a category for nearby life services.',
    exchangeInSettings: 'Exchange rates: find them in App settings →',
    koreanOk: 'Korean speaking',
    koreanLimited: 'Korean limited',
    signature: 'Signature',
    categorySectionTitle: 'Categories',
    listingsDbIntro:
      '“Unified listings (DB)” opens posts stored in Supabase by category (hospitals, food, etc.) in one place. Ops can turn categories on/off without an app store update.',
    searchPlaceholder: 'Hospitals, food, beauty…',
    registeredListTitle: 'Listed places',
    viewMap: 'Map',
    viewList: 'List',
    mapListToggle: 'View mode',
    openInGoogleMaps: 'Open in Google Maps',
    mapMiniHint: 'Tap a pin to select a place.',
    mapMiniDetail: 'View details',
    favoritesSection: 'Favorites',
    safepathScopeCaption: 'Region',
    safepathFallbackNote: 'No pack for this city yet; showing the default (Da Nang) guide.',
    safepathComingSoonByRegion: '🚧 Regional information for {region} is coming soon.',
    safepathInheritedNote: 'Based on a nearby-city template; always verify with official sources.',
    safepathOfficialDisclaimer: 'For real procedures and documents, follow your competent authority and embassy notices first.',
    safepathNotFound: 'This topic could not be loaded.',
    safepathSectionTasks: 'Key tasks',
    safepathSectionDetails: 'Checklist',
    safepathSectionAgencies: 'Relevant bodies',
    safepathSectionPartners: 'Partner types (reference)',
    safepathSectionTrust: 'Review & sources',
    safepathRiskHigh: 'Sensitivity: high',
    safepathRiskMedium: 'Sensitivity: medium',
    favorite: 'Add to favorites',
    unfavorite: 'Remove from favorites',
    emptyList: 'No places match.',
    searchNoMatch: 'No search results. Try a different word.',
    searchOnMain: 'This page is a guide. Search listed businesses on Local info home.',
    registerBannerQ: 'Run a business in this field?',
    registerBannerA: 'List for free on Mingo!',
    registerBannerBtn: 'Register a business',
    registerFromEmpty: 'Register a business',
    pageHospital: 'Hospital / pharmacy',
    hospitalMedicalDisclaimer:
      'This information is for reference only. For medical decisions, always consult a qualified doctor or clinic.',
    pageRestaurant: 'Food & drink',
    pageVisa: 'Visa & admin',
    visaPageNote: 'Visa rules vary by case. Use official government and embassy pages as the source of truth.',
    pageBeauty: 'Beauty & massage',
    pageCleaning: 'Cleaning & moving',
    pageReturn: 'Repatriation',
    pageRental: 'Vehicle rental',
    pageVisaAgency: 'Visa agencies',
    pageProfessional: 'Professional services',
    pageAcademy: 'Academies & classes',
    pageActivity: 'Activities & leisure',
    pagePet: 'Pet services',
    pageKoreanShop: 'Korean products',
    pageWedding: 'Wedding',
    pageMentoring: 'Mentoring',
    pageNews: 'News & info',
    call: 'Call',
    map: 'Map',
    vnEmergency: 'Vietnam emergency (police / ambulance)',
    emergencyCall: 'Call 115',
    vnEmergencyLine: ' · 115. Also check embassy/insurance guidance as needed.',
    hospitalKoreanHint: 'Hospitals/clinics with Korean support in Da Nang (reference only; call ahead).',
    hospitalSections: 'Quick tips',
    hospitalKoreanList: 'Korean available — call ahead to confirm languages',
    hospitalER: '24h emergency — 115, or the nearest international ER for serious cases',
    hospitalPharmacy: 'Pharmacy — have prescriptions/English med names if possible',
    restFilterAll: 'All',
    restFilterKorean: 'Korean',
    restFilterLocal: 'Local',
    restFilterWestern: 'Western',
    restFilterCafe: 'Cafe',
    foodExploreTitle: 'Restaurants & food',
    foodExploreHint: 'Browse registered businesses and curated picks in one place — all areas, with sort and search.',
    foodExploreCta: 'Browse all restaurants & food',
    foodExploreSortLabel: 'Sort',
    foodExploreSortRecommended: 'Recommended',
    foodExploreSortRating: 'Highest rating',
    foodExploreSortReviews: 'Most reviews',
    foodExploreDeliveryBadge: 'Delivery',
    openNow: 'Open',
    closed: 'Closed',
    reviewsCount: 'reviews',
    priceTier: 'Price',
    bookVia: 'Book',
    bookPhone: 'Phone',
    bookKakao: 'Kakao',
    cleaningTipsTitle: 'Tips',
    cleaningCheck: 'Moving: contract, building access, elevator/stairs ahead of the day',
    cleaningPrice: 'Prices depend on m², distance, floor work — get 2–3 quotes',
    cleaningQuote: 'Request a quote',
    returnD30: 'D-30: banks/rent, flight date, how much to ship',
    returnD7: 'D-7: baggage rules, cash/goods to declare, prohibited items',
    returnD0: 'D-day: tickets, passport, any health/entry forms',
    movingAndBaggage: 'Moving, shipping & baggage',
    returnCheckTitle: 'Repatriation checklist',
    returnPageNote: 'Air/entry/customs/health rules change. Always read official pages.',
    typeClean: 'Cleaning',
    typeMove: 'Moving',
    customs: 'Customs / duty-free',
    customsLine: 'Check limits (e.g. ~USD 800) and restricted items (food, large cash)',
    returnShip: 'Shipping: compare sea/air, packing list, customs',
    returnBaggage: 'Airline baggage: checked & carry-on limits, spare batteries in cabin only',
    nhisAndLicense: 'Health insurance & driver’s license',
    returnNhis: 'Korean NHIS: catch-up on coverage rules after your stay abroad',
    returnLicense: "Driver’s license: renewal/인적사항 changes per police guidance",
    usefulLinks: 'Useful links',
    visaTypes: 'Visa types',
    visaTypesLine: 'Tourist · work (work permit+visa) · business/invest — rules differ',
    visaHow: 'Apply/extend: documents differ by case (employer, invitation, etc.)',
    visaDocs: 'Passport copy, photos, purpose, contracts where applicable',
    consulate: 'Da Nang ROK consulate: check hours/appointments; holidays apply',
    visaExtendSection: 'Stay & extension',
    visaExtend: 'Extensions: apply before expiry (often ~15 days) to avoid fines',
    vnImmigration: 'Vietnam immigration (reference)',
    krEmbassy: 'ROK embassy/consulate (booking)',
    visaRun: 'Visa/entry information (reference)',
    koreaCustoms: 'Korea Customs (UniPass)',
    nhis: 'NHIS (re-enrollment)',
    driverLicense: 'Driver license (renewal)',
    visaHowApply: 'Visa application: e-Visa (tourist) or consulate/immigration routes. Employment needs permits first.',
    visaChecklistTitle: 'Checklist (examples)',
    consulateCallout: 'Consulate/embassy hours, phone, and appointment rules — follow the official site.',
    visaRunExplainer: '“Visa run” border trips may be limited or risky. Rely on official immigration notices only.',
    beautyFilterAll: 'All',
    beautyFilterHair: 'Hair',
    beautyFilterNail: 'Nail',
    beautyFilterMassage: 'Massage',
    beautyFilterSpa: 'Spa',
  },
  community: {
    title: 'Community',
    tabFeed: 'Board',
    tabGroup: 'Groups',
    recommendGroups: 'Popular groups',
    seeAll: 'See All',
    empty: 'No posts yet.',
    writeFab: 'New post',
    writeFabLabel: 'Write',
    sortNew: 'Latest',
    sortHot: 'Popular',
    sortUpcoming: 'Upcoming',
    sortLabel: 'Sort',
    dataEmpty: 'No data to show',
    dataError: 'Could not load. Try again.',
    categoryGroupInfo: 'Structured posts',
    categoryGroupFree: 'Free posts',
    category: {
      lostFound: 'Lost & missing',
    },
    categories: {
      near: 'My area',
      all: 'All',
      event: 'Events & markets',
      visarun: 'Visa run',
      travel: 'Travel together',
      flash: 'Meetup',
      general: 'General',
      free: 'Free',
      qna: 'Questions',
      share: 'Share & Reports',
      food: 'Food',
      together: 'Together',
      info: 'Info',
      humor: 'Humor',
      pet: 'Pets',
      realestate: 'Real Estate',
      jobs: 'Job Talk',
      jobtalk: 'Job Talk',
      review: 'Reviews',
      incident: 'Incidents',
      scam: 'Scam Alert',
      notice: 'Notice',
      lost: 'Lost & missing',
      question: 'Q&A',
      meet: 'Meet',
      emergency: 'Safety & tips',
      education: 'Parenting & education',
      medical: 'Health & Medical',
      suggestion: 'Suggestions',
    },
    languageFilterLabel: 'Language filter',
    languageOptions: {
      all: 'All',
      ko: 'Korean',
      en: 'English',
      vi: 'Vietnamese',
      ru: 'Russian',
    },
    surveysLink: 'Surveys — earn points',
    newsLink: 'News & guides',
    groupsLink: 'Group chats',
    recipesLink: 'Recipes & cooking',
    extrasNavLabel: 'More community tools',
    emptyDesc: 'Write the first post.',
    emptyAction: '✏️ Write first post',
    eventEmpty: 'No events yet',
    eventEmptyDesc: 'Upcoming events and night markets will show here.',
    eventBadgeAlways: 'Always',
    eventBadgeRecurring: 'Weekly',
    eventBadgeDday: 'D-{n}',
    allLoaded: 'All posts have been loaded.',
  },
  finalExp: {
    tourListTitle: 'Tours & packages',
    tourListIntro: 'Curated Da Nang & Central Vietnam experiences. Booking opens soon — chat a guide today.',
    tourDetailTitle: 'Tour',
    catAll: 'All',
    tourCatHalf: 'Half day',
    tourCatDay: '1 day',
    tourCatMulti: '2+ days',
    tourCatCulture: 'Culture',
    tourCatNature: 'Nature',
    tourCatFood: 'Food',
    tourCatGolf: 'Golf',
    tourDays: '{n} days',
    tourHours: '{n} hrs',
    tourDayTrip: 'Day trip',
    tourPax: '{min}–{max} guests',
    departure: 'Departure',
    priceFrom: 'From',
    includes: 'Included',
    excludes: 'Not included',
    itinerary: 'Itinerary',
    meeting: 'Meeting point',
    guide: 'Guide',
    bookSoon: 'Book (coming soon)',
    reviews: 'Reviews',
    backToTours: 'All tours',
    tourDnHalfTitle: 'Da Nang half-day highlights',
    tourHoiTitle: 'Hoi An full-day heritage walk',
    tourBanaTitle: 'Ba Na Hills & Golden Bridge',
    tourMysonTitle: 'My Son sanctuary morning',
    tourHueTitle: 'Hue imperial city (2 days)',
    tourDnHalfDesc: 'Marble Mountains, beach road, and local coffee stops with a Korean-speaking guide.',
    tourHoiDesc: 'Ancient town lanes, river boat, and lantern quarter with flexible photo time.',
    tourBanaDesc: 'Cable car, French village, and gardens — start early to beat heat and crowds.',
    tourMysonDesc: 'UNESCO Cham towers with history briefing and return before lunch.',
    tourHueDesc: 'Citadel, tombs, and Perfume River cruise with overnight in Hue.',
    tourMeetingDn: 'Hotel lobby in Da Nang city (beach side) — exact hotel confirmed night before.',
    inc1: 'A/C van & licensed driver',
    inc2: 'English-speaking guide',
    incWater: 'Bottled water',
    incVan: 'Round-trip transfer',
    incBoat: 'River boat ticket (where applicable)',
    incCable: 'Cable car ticket (Ba Na)',
    incHotel: '1 night hotel in Hue (twin share)',
    excLunch: 'Lunch (free time or add-on)',
    excTips: 'Personal shopping & tips',
    excPersonal: 'Single room upgrade (optional)',
    itPick: 'Pickup',
    itPickDn: 'Beach hotels / An Thuong area',
    itPickHotel: 'Your hotel lobby',
    itPickEarly: 'Early start for cooler ruins visit',
    itMarble: 'Marble Mountains',
    itMarbleDesc: 'Elevator or steps — panoramic sea view.',
    itLunch: 'Lunch break',
    itLunchFree: 'Choose local pho or Korean-friendly café.',
    itBeach: 'My Khe beach drive',
    itBeachDesc: 'Photo stop and sea breeze.',
    itHoi: 'Hoi An old town',
    itHoiDesc: 'Japanese bridge, assembly halls, craft streets.',
    itLantern: 'Lantern quarter',
    itLanternDesc: 'Sunset glow and optional lantern release.',
    itCable: 'Ba Na cable car',
    itCableDesc: 'Mountain climate — bring light jacket.',
    itGarden: 'Le Jardin D’Amour',
    itGardenDesc: 'Garden photo walk and free time.',
    itMyson: 'My Son ruins',
    itMysonDesc: 'Cham architecture and jungle setting.',
    itDepart: 'Depart for Hue',
    itDepartHue: 'Highway transfer with rest stop.',
    itCitadel: 'Hue Citadel',
    itCitadelDesc: 'Imperial gates and palace ruins.',
    itDinner: 'Local dinner',
    itDinnerHue: 'Royal-style small dishes (demo menu).',
    guideKim: 'Lead guide Kim — 6 yrs in Da Nang, KO/EN.',
    guideLee: 'Lead guide Lee — Hoi An specialist, KO/EN.',
    guidePark: 'Lead guide Park — mountain routes, KO/EN/VI.',
    guideTran: 'Local expert Tran — EN/VI, history focus.',
    guideHueTeam: 'Two-day team: Kim + local Hue historian.',
    rev1: 'Punctual and fun — kids loved the beach stop.',
    rev2: 'Clear explanations, small group felt VIP.',
    rev3: 'Perfect pacing for photos and food.',
    rev4: 'Bring jacket for Ba Na — guide warned us, saved the day.',
    rev5: 'Worth the early wake-up; ruins almost empty.',
    rev6: 'Hue hotel was clean; driver felt safe.',
    interiorTitle: 'Interior & renovation',
    interiorIntro: 'Before/after portfolios from verified contractors. Quote flow launches soon.',
    intTypeFull: 'Full package',
    intTypePartial: 'Partial remodel',
    intTypeFurniture: 'Furniture',
    intTypePaint: 'Paint & walls',
    before: 'Before',
    after: 'After',
    durationDays: '{n} days est.',
    priceRange: 'From–to',
    quoteCta: 'Request quote',
    quoteSoon: 'Quotes: coming soon — we saved your interest.',
    int1Name: 'Apartment full remodel (An Thuong)',
    int1Desc: 'Open kitchen, hidden storage, LED strips.',
    int2Name: 'Bathroom & wet area refresh',
    int2Desc: 'Waterproofing, rain shower, vanity swap.',
    int3Name: 'Furniture package — two-bed expat flat',
    int3Desc: 'Sofa, beds, desk — install in 1 week.',
    talentTitle: 'Talent market',
    talentIntro: 'Freelance help from the community: translation, design, lessons, and more.',
    talCatTranslate: 'Translation',
    talCatDesign: 'Design',
    talCatDev: 'Development',
    talCatLesson: 'Lessons',
    talCatWriting: 'Writing',
    talCatVideo: 'Video',
    talCatOther: 'Other',
    deliveryIn: '{n}-day delivery',
    orders: '{n} orders',
    orderSoon: 'Order (coming soon)',
    tal1Title: 'Korean ↔ Vietnamese document translation',
    tal1Desc: 'Contracts, housing, hospital forms — certified partner on request.',
    tal2Title: 'Logo & brand kit for small business',
    tal2Desc: '3 concepts, vector files, palette guide.',
    tal3Title: 'Korean conversation lesson (online)',
    tal3Desc: '50 min sessions, beginner to intermediate.',
    tal4Title: 'Vietnamese survival Vietnamese',
    tal4Desc: 'Market phrases, taxi, landlord talk.',
    tal5Title: 'Short-form video editing',
    tal5Desc: 'Reels/TikTok captions and color grade.',
    tal6Title: 'SNS marketing monthly pack',
    tal6Desc: '4 posts + 8 stories templates + ad copy.',
    tal7Title: 'Landing page (React-ready handoff)',
    tal7Desc: 'Mobile-first, contact form, analytics hook.',
    tal8Title: 'Korean blog / newsletter ghostwriting',
    tal8Desc: 'Tone-matched articles for expat services.',
    subTitle: 'Subscription boxes',
    subIntro: 'Korean snacks and wellness — recurring revenue for sellers, convenience for you.',
    subIncludes: 'Typical items',
    subMonthly: 'Monthly',
    subSoon: 'Subscribe (coming soon)',
    subNotify: 'We will notify you when checkout is live.',
    subKfoodName: 'Korean grocery box',
    subKfoodDesc: 'Snacks, ramen, sauces — curated monthly.',
    subItemSnacks: '2 snack packs',
    subItemRamen: '4 ramen varieties',
    subItemSauce: '1 premium sauce / condiment',
    subBeautyName: 'Beauty & wellness box',
    subBeautyDesc: 'Sheet masks, vitamins, herbal tea.',
    subItemMask: '5 sheet masks',
    subItemVit: '1 vitamin bundle',
    subItemTea: 'Wellness tea set',
    groupsTitle: 'Group chats',
    groupsIntro: 'Join topic groups for Da Nang — messaging opens in a future update.',
    grpCatRegion: 'Area',
    grpCatInterest: 'Interests',
    grpCatJob: 'Jobs',
    grpCatParent: 'Parenting',
    grpCatRe: 'Real estate',
    grpCatInvest: 'Investing',
    members: 'Members',
    join: 'Join',
    joinSoon: 'Join request saved — chat coming soon.',
    grp1Name: 'Da Nang Koreans (general)',
    grp1Desc: 'Announcements, Q&A, meetups.',
    grp2Name: 'Da Nang food hunters',
    grp2Desc: 'New openings, brunch crews, delivery tips.',
    grp3Name: 'Da Nang real estate desk',
    grp3Desc: 'Rent/buy threads — verify listings yourself.',
    grp4Name: 'Da Nang parenting',
    grp4Desc: 'Schools, pediatricians, playdates.',
    grp5Name: 'Da Nang golf crew',
    grp5Desc: 'Weekend tee times and ride shares.',
    luxuryTitle: 'Pre-owned luxury',
    luxuryIntro: 'Authenticated listings where noted — always chat before payment.',
    brandChanel: 'Chanel',
    brandLv: 'Louis Vuitton',
    brandGucci: 'Gucci',
    brandHermes: 'Hermès',
    authBadge: 'Authenticated',
    lux1Name: 'Classic flap medium (black)',
    lux2Name: 'Speedy 30 monogram',
    lux3Name: 'Ace sneakers (EU 42)',
    lux4Name: '90×90 silk scarf',
    lux5Name: 'Initiales reversible belt',
    condExc: 'Excellent',
    condVgood: 'Very good',
    condGood: 'Good',
    condNew: 'Like new',
    flightTitle: 'Flight search',
    flightIntro: 'Compare fares on Skyscanner — Mingo earns a partner fee when you book from our link.',
    flightFrom: 'From (IATA)',
    flightTo: 'To (IATA)',
    flightDepart: 'Departure date',
    flightReturn: 'Return (optional)',
    flightPax: 'Passengers',
    flightClass: 'Cabin',
    flightSearch: 'Search on Skyscanner',
    flightNeedDate: 'Pick a departure date first.',
    flightOpened: 'Opening Skyscanner in a new tab.',
    flightAffiliateHint: 'Prices and rules are set by airlines and OTAs. Always double-check baggage and visa rules.',
    cabinEco: 'Economy',
    cabinPremEco: 'Premium economy',
    cabinBiz: 'Business',
    cabinFirst: 'First',
  },
  fffExp: {
    liveTitle: 'Live commerce',
    liveIntro: 'Shop during live shows — checkout connects in a future release.',
    liveTabLive: 'Live now',
    liveTabUp: 'Scheduled',
    liveTabPast: 'Past',
    liveEnter: 'Enter room',
    liveEnterSoon: 'Live player is coming soon.',
    liveViewers: '{n} watching',
    liveStarts: 'Starts {d}',
    livePeak: 'Peak {n} viewers',
    liveEnded: 'Replay & highlights soon',
    liveKfoodTitle: 'Korean grocery live — snacks & ramen',
    liveReTitle: 'Da Nang real estate walk-through',
    liveLocalFoodTitle: 'Local food tour — night market picks',
    catGrocery: 'Grocery',
    catRealEstate: 'Real estate',
    catFood: 'Food',
    hostKim: 'Host Kim',
    hostLan: 'Host Lan',
    hostPark: 'Host Park',
    cfTitle: 'Crowdfunding',
    cfIntro: 'Back expat-led projects safely — payments escrow in a future update.',
    cfEnds: 'Ends {d}',
    cfBack: 'Back this project',
    cfBackSoon: 'Backing checkout is coming soon.',
    cf1Title: 'Open a Korean restaurant in Da Nang',
    cfCatRestaurant: 'Restaurant',
    cf2Title: 'Korean food import micro-business',
    cfCatImport: 'Import / retail',
    cf3Title: 'Mingo app feature expansion',
    cfCatTech: 'Product / tech',
    cwTitle: 'Coworking & shared office',
    cwIntro: 'Hot desks and meeting rooms for remote workers.',
    cw1Name: 'Beach Hub Coworking',
    cw2Name: 'An Thuong Work Lounge',
    cw3Name: 'Han River Studio',
    cwCap: 'Capacity ~{n}',
    cwBookSoon: 'Book desk (soon)',
    amWifi: 'Wi‑Fi',
    amCoffee: 'Coffee',
    amMeeting: 'Meeting room',
    amPrint: 'Printer',
    am24: '24/7 access',
    amPhone: 'Phone booths',
    recipeTitle: 'Recipes & cooking',
    recipeIntro: 'Community recipes plus in-person classes in Da Nang.',
    catAll: 'All',
    recipeKorean: 'Korean',
    recipeViet: 'Vietnamese',
    recipeSnack: 'Snacks',
    recipeTime: '{n} min',
    recipeServings: '{n} servings',
    recipeIngredients: 'Ingredients',
    recipeSteps: 'Steps',
    recipeLike: 'Like',
    recipeSave: 'Save',
    recipeLikeToast: 'Saved like (demo).',
    recipeSaveToast: 'Saved to your list (demo).',
    rpPhoTitle: 'Homestyle phở broth',
    rpPhoDesc: 'Rich beef broth with spices — weekend project.',
    rpKimchiTitle: 'Kimchi jjigae',
    rpKimchiDesc: 'Comfort stew with aged kimchi.',
    rpBanhmiTitle: 'Bánh mì at home',
    rpBanhmiDesc: 'Crispy baguette, pickles, and fillings.',
    rpTteokTitle: 'Quick tteokbokki',
    rpTteokDesc: 'Street-style spicy rice cakes.',
    rpSpringTitle: 'Fresh spring rolls',
    rpSpringDesc: 'Gỏi cuốn with peanut dipping sauce.',
    diffEasy: 'Easy',
    diffMed: 'Medium',
    ccSection: 'Cooking classes',
    cc1Title: 'Crispy bánh xèo class',
    cc1Desc: 'Make batter, fillings, and dipping sauce.',
    cc1When: 'Sat 10:00 · My Khe area',
    cc2Title: 'Korean banchan basics',
    cc2Desc: '3 side dishes + rice pairing tips.',
    cc2When: 'Sun 14:00 · City center kitchen lab',
    ccMax: 'Max {n} people',
    ccBookSoon: 'Reserve (soon)',
    aucTitle: 'Property auctions',
    aucIntro: 'Transparent bidding for selected listings — always verify title and taxes.',
    aucEndsIn: 'Time left',
    aucCurrent: 'Current bid',
    aucStart: 'Opening bid',
    aucBuyout: 'Buy now',
    aucBids: '{n} bids',
    aucBidSoon: 'Place bid (coming soon)',
    aucHistory: 'Bid history',
    auc1Title: 'Sea-view condo (My Khe)',
    aucRegion: 'Da Nang · Sơn Trà',
    bidderA: 'Bidder A',
    bidderB: 'Bidder B',
    bidderC: 'Bidder C',
    rewTitle: 'Rewards & streaks',
    rewCheckin: 'Daily check-in',
    rewStreakLine: 'Current streak: {n} days',
    rewCheckinBtn: 'Check in today',
    rewDoneToday: 'Checked in today',
    rewAlready: 'You already checked in today.',
    rewCheckinOk: '+{pts} points (demo). Keep your streak!',
    rewMissions: 'Missions',
    rewBadges: 'Badges',
    rewLeader: 'Leaderboard (demo)',
    rewPointsHint: 'Points history',
    mis1: 'Post a verified safety tip in Community',
    mis2: 'Complete your visa expiry reminder',
    mis3: 'Save 3 favorite businesses',
    badgeSafe: 'SafePath supporter',
    badgeFirstTrade: 'First completed trade',
    badgeStreak: '7-day streak',
    mapTitle: 'Map search',
    mapIntro: 'Explore nearby services on the map. Native Kakao/Google maps can replace the embed when API keys are set.',
    mapFrameTitle: 'Da Nang map preview',
    mapSdkHint: 'Kakao Map / Google Maps SDK: add keys in env for turn-by-turn and richer markers.',
    mapNearby: 'Nearby (demo)',
    mapSelected: 'Selected: {name}',
    mapP1: 'Korean BBQ alley (An Thuong)',
    mapP2: 'Family clinic (English desk)',
    mapP3: 'Specialty café & workspace',
    mapCatFood: 'Food',
    mapCatHospital: 'Clinic',
    mapCatCafe: 'Café',
  },
  contactSetup: {
    title: 'Add your contacts',
    desc: 'Connect with expats via KakaoTalk, WhatsApp, or Zalo',
    registerBtn: 'Add now',
    later: 'Later',
  },
  myPage: {
    title: 'My profile',
    tagline: 'Stay safe together',
    menuNavAria: 'Settings menu',
    logout: 'Log out',
    manner: 'Manner temperature',
    mannerAria: 'Trust manner temperature',
    changeAvatarAria: 'Change profile photo',
    avatarBusy: 'Updating profile photo…',
    menu: {
      realEstateBrowse: 'Real estate & rental listings',
      myProperties: 'My listings (landlord / tenant)',
      trades: 'My trades',
      favorites: 'Saved',
      premium: 'Premium membership',
      visaAlerts: 'Visa & admin guide',
      visaExpirySetup: 'Visa expiry date',
      language: 'Language',
      region: 'Region',
      appSettings: 'App settings',
      notificationSettings: 'Notification settings',
      mingoEvents: 'Mingo events',
      exchangeRates: 'Exchange rates',
      blockedUsers: 'Blocked accounts',
      orders: 'Order history',
      businessDashboard: 'Store dashboard',
      manageAds: 'Manage ads',
      pointHistory: 'Point history',
      accountSettings: 'Account settings',
      advertiser: 'Ad manager',
      rewards: 'Rewards & check-in',
      financial: 'Financial planner',
      pointMarket: 'Point shop',
    },
    settings: { languageValue: 'Language', regionValue: 'Region' },
    pointsTitle: 'Points',
    pointsBalance: 'Balance',
    pointsUnit: 'P',
    referralCode: 'My referral code',
    copyReferral: 'Copy',
    copied: 'Copied.',
    pointsHistory: 'History',
    pointsHistoryPage: 'Full history',
    pointsPageTitle: 'Point history',
    pointsPageHint: 'Credits and debits with date, amount, and reason.',
    pointsEmpty: 'No history yet.',
    pointsHow: 'Points can be used for premium features later (beta).',
    languageModalTitle: 'Display language',
    languageUpdated: 'Language updated',
    premiumUntil: 'Premium perk (referral) until {date}',
    paymentHistory: 'Payment history',
    paymentsEmpty: 'No payments yet.',
    receiptDownload: 'Receipt',
    receiptSoon: 'Receipt download is coming soon.',
    editProfile: 'Edit Profile',
    following: 'Following',
    followers: 'Followers',
    activityScore: 'Activity Score',
    mannerTier: 'Tier',
    mannerNew: 'New',
    mannerNewDesc: 'No no-show, report, or review history yet. A tier will be assigned as activity builds up.',
    statsPoints: 'Points',
    statsTrades: 'Trades',
    statsReviews: 'Reviews',
    statsNoShow: 'No-shows',
    myTrades: 'My Trades',
    myFavorites: 'Favorites',
    myReviews: 'My Reviews',
    myCommunityPosts: 'My community posts',
    myCommunityPostsEmpty: 'You have no posts yet.',
    myCommunityPostsHint: 'Write in Community and your posts will show up here.',
    myGroups: 'My groups',
    myGroupsEmpty: 'You have not joined any groups yet.',
    myGroupsHint: 'Find groups in Community or create your own.',
    invite: 'Invite Friends',
    inviteCopied: 'Invite link copied!',
    inviteShareText: 'Join me on Mingo for Da Nang life tips! Sign up and get points 🎁',
    noShowRecovery: 'Under restriction - Recover',
    referralTitle: 'Referral Code',
    referralInviteBtn: 'Invite',
    referralCount: '{n} friends invited',
    adCta: 'Advertise your business!',
    expiryUrgentTitle: 'Urgent Expiry Alerts',
    expiryUrgentToday: 'Today',
    resSection: 'My bookings',
    resRental: 'Vehicle rental',
    resGolf: 'Golf tee times',
    resExperience: 'Experiences',
    resHospital: 'Hospital / clinic',
    resTours: 'Tours & packages',
    resOpen: 'View',
    actSection: 'Activity snapshot',
    actTrades: 'Completed trades',
    actReviews: 'Reviews received',
    actPoints: 'Points balance',
    actCredit: 'Store credit',
    actSeeTrades: 'Open my trades',
    actDemoHint: 'Some stats are demo until full account sync.',
  },
  payments: {
    modalTitle: 'Checkout',
    product: 'Item',
    amount: 'Amount',
    card: 'Card',
    pay: 'Pay now',
    success: 'Payment completed.',
    disabledLead: 'Payments are not available yet.',
    contact: 'Contact',
    invalidKey: 'Stripe publishable key is missing or invalid.',
    stripeNotReady: 'Stripe is still loading. Try again in a moment.',
    receiptLater: 'Email receipts will be sent in a future update.',
    comingShort: 'Coming soon.',
    paid: 'Paid',
    adTitle: 'Advertising payment',
    adLead: 'Pricing depends on reach. We recommend contacting us before paying.',
    selected: 'Selected',
    inquiryLink: 'Contact / inquiry',
    adActivatedHint: 'Payment received. Our team will connect your slot.',
    premiumTitle: 'Premium membership',
    premiumPrice: '{price} USD / month',
    premiumProductName: 'Mingo Premium (monthly)',
    benefit1: 'Ad-free experience',
    benefit2: 'One community pin per week',
    benefit3: 'Unlimited visa reminders',
    benefit4: 'Premium badge',
    premiumExtended: 'Your premium period was extended.',
    errors: {
      noApiUrl: 'Set REACT_APP_STRIPE_PAYMENT_API_URL to your PaymentIntent endpoint.',
      network: 'Could not reach the payment server.',
      intentFailed: 'Could not start checkout.',
      card: 'Card was declined or invalid.',
      notSucceeded: 'Payment did not complete.',
      noUser: 'Could not resolve your account.',
      recordFailed: 'Could not save payment record.',
      generic: 'Something went wrong during payment.',
    },
  },
  service: {
    title: 'All services',
    sections: {
      fortune: 'Fortune/Tarot',
      trade: 'Local trade',
      life: 'Life services',
      expat: 'Expat info',
      biz: 'Business',
    },
    items: {
      fortune: 'Fortune/Tarot',
      used: 'Marketplace',
      rent: 'Rent / lease',
      realestate: 'Real estate',
      jobs: 'Jobs',
      car: 'Used cars',
      hospital: 'Hospital / pharmacy',
      food: 'Food',
      beauty: 'Beauty / massage',
      move: 'Cleaning / moving',
      visa: 'Visa / admin',
      meetup: 'Events & meetups',
      emergency: 'Emergency contacts',
      lost: 'Lost & found',
      ads: 'Post an ad',
      bizProfile: 'Business profile',
      groupBuy: 'Group buy',
      languageExchange: 'Language exchange',
      currencyExchange: 'P2P exchange',
    },
  },
  serviceV2: {
    secTrade: '🛍️ Trade & Shopping',
    secLife: '🏠 Life & Services',
    secTravel: '✈️ Bookings & Travel',
    secSports: '🏃 Sports & Leisure',
    secBooking: '🎫 Booking & Tickets',
    secMedical: '🏥 Medical & Education',
    secPro: '💼 Professional & Legal',
    secFreelance: '✨ Freelance & Talent',
    secBusiness: '💼 Business & Pro',
    secCreator: '🎬 Creator & Content',
    secCommunity: '👥 Community & Info',
    guideText: 'Find services here. For expat guides, use the Life tab.',
    items: {
      used: 'Used marketplace',
      vehicles: 'Used vehicles',
      groupBuy: 'Group buy',
      currencyExchange: 'Currency exchange',
      talentMarket: 'Talent market',
      luxuryUsed: 'Luxury used',
      booking: 'Booking Hub',
      flights: 'Flights',
      poolVilla: 'Pool Villa',
      hotel: 'Hotels & stays',
      webtoon: 'Webtoon',
      shorts: 'Shorts',
      insurance: 'Insurance',
      remittance: 'Remittance',
      community: 'Community',
      news: 'News / info',
      fortune: 'Fortune',
      restaurant: 'Restaurants',
      supermarket: 'Supermarket',
      dental: 'Dental',
      laundry: 'Laundry',
      repair: 'A/C & repair',
      babysitter: 'Babysitter',
      translation: 'Interpret / translate',
      guideMarket: 'Guide market',
      sos: 'SOS emergency help',
      groupDelivery: 'Korea direct group shipping',
      interpreter: 'Interpreter service',
      realestate: 'Real estate',
      rental: 'Rental',
      koreanShop: 'Korean mart',
      wedding: 'Wedding',
      deals: 'Deals / coupons',
      settlement: 'Settlement package',
      golf: 'Golf',
      medicalTourism: 'Medical tourism',
      boat: 'Yacht / boat',
      photo: 'Photo / video',
      eventPlanner: 'Event planner',
      digital: 'IT / digital',
      professional: 'Professional services',
      visaAgency: 'Visa agency',
      mentoring: 'Mentoring',
      academy: 'Academy / education',
      schools: 'International schools',
      educationConsult: 'Study abroad consulting',
      experiences: 'Experiences',
      activity: 'Activities',
      languageExchange: 'Language exchange',
      hospital: 'Hospital / pharmacy',
      pet: 'Pet services',
      fitness: 'Health / fitness',
      groupChats: 'Group chat',
      meetup: 'Events / meetup',
      surveys: 'Surveys',
      emergency: 'Emergency contacts',
      visa: 'Visa alerts',
      carpool: 'Carpool',
      rider: 'Rider',
      airportPickup: 'Airport pickup',
      liveCommerce: 'Live shopping',
      crowdfunding: 'Crowdfunding',
      propertyAuction: 'Property auctions',
      mapSearch: 'Map search',
      bizProfile: 'My business',
      ads: 'Ad management',
      jobs: 'Jobs',
      expatInfo: 'Expat Guide',
    },
  },
  booking: {
    title: 'Booking & Tickets',
    heroTitle: 'Expat-Recommended Booking Services',
    heroDesc: 'Experiences, hotels, flights, guides\nBook in Korean',
    catExperiences: '🎫 Experiences & Classes',
    catExperiencesDesc: 'Cooking, surfing, tours, shows, yoga',
    catHotel: '🏨 Hotels & Resorts',
    catHotelDesc: 'Compare and book hotels in Da Nang',
    catPoolVilla: '🏡 Pool Villas',
    catPoolVillaDesc: 'Private pool villas · Expat deals',
    catFlights: '✈️ Flights',
    catFlightsDesc: 'Search Korea ↔ Vietnam flights',
    catGuides: '🧭 Guide Market',
    catGuidesDesc: 'Book local Korean-speaking guides',
    catMedical: '🏥 Medical Tourism',
    catMedicalDesc: 'Medical tourism · Cosmetic · Checkup',
    catAirport: '🚐 Airport Pickup',
    catAirportDesc: 'Da Nang airport pickup & drop-off',
    featuredExp: 'Popular Experiences',
  },
  hotel: {
    title: 'Hotels & stays',
    all: 'All',
    search: 'Search',
    categories: 'Types',
    sortRecommended: 'Recommended',
    sortPriceLow: 'Price: low to high',
    sortRatingHigh: 'Rating: high to low',
    listDestinationPh: 'Destination (city)',
    villaBannerTitle: 'Pool Villa Special',
    villaBannerDesc: 'Private pool villa · Expat deals',
    registerCta: 'List your property',
    badgePopular: 'Popular',
    favorite: 'Save',
    perNightFrom: 'per night',
    totalForNights: 'Total for {nights} nights',
    taxesIncluded: 'Taxes included',
    beachMinutes: 'Beach {n} min',
    gallerySeeAll: 'See all {n} photos',
    galleryTitle: 'All photos',
    openMap: 'Open map',
    amenitiesGridTitle: 'Amenities',
    roomsPick: 'Choose a room',
    maxGuests: 'Up to {n} guests',
    breakfastIn: 'Breakfast included',
    breakfastOut: 'Breakfast not included',
    pay: { now: 'Pay now (discount)', later: 'Pay later', onsite: 'Pay at property' },
    selectThisRoom: 'Select this room',
    locationSection: 'Location',
    mapPreview: 'View on Google Maps',
    distBeach: 'Beach {n} min',
    distAirport: 'Airport {n} min',
    distHospital: 'Hospital {n} min',
    distFood: 'Dining {n} min',
    revClean: 'Cleanliness',
    revLocation: 'Location',
    revService: 'Service',
    revValue: 'Value',
    pickDates: 'Dates',
    footerTotal: 'Total',
    amenityAc: 'Air conditioning',
    amenityWifi: 'Wi‑Fi',
    amenityPool: 'Pool',
    amenityGym: 'Gym',
    amenityParking: 'Parking',
    amenityElevator: 'Elevator',
    amenityBreakfast: 'Breakfast',
    amenityHousekeeping: 'Housekeeping',
    amenitySafe: 'Safe',
    amenityPets: 'Pets allowed',
    amenityNosmoking: 'Non-smoking',
    amenityAccessible: 'Accessibility',
    register: {
      title: 'List a hotel',
      next: 'Next',
      back: 'Back',
      submit: 'Submit for review',
      step1: 'Stay type',
      step2: 'Basic info',
      step3: 'Location',
      step4: 'Pricing',
      step5: 'Amenities',
      step6: 'Room info',
      step7: 'Photos',
      step8: 'House rules',
      step9: 'Visibility',
      typeGuesthouse: 'Guesthouse',
      typeVilla: 'Villa',
      stepRoomInfo: 'Room Info',
      stepPricing: 'Pricing',
      stepAmenities: 'Amenities',
      stepRules: 'House Rules',
      amenityPool: 'Pool',
      amenityBreakfast: 'Breakfast',
      amenityParking: 'Parking',
      peakSeason: 'Peak Season',
      offSeason: 'Off Season',
      hotelName: 'Property name',
      desc: 'Description',
      country: 'Country',
      city: 'City',
      address: 'Address',
      beachMin: 'Minutes to beach',
      airportMin: 'Minutes to airport',
      centerMin: 'Minutes to city center',
      landmark: 'Nearby landmark',
      priceNight: 'Price per night',
      currency: 'Currency',
      minNights: 'Minimum stay (nights)',
      roomType: 'Room type',
      roomGuests: 'Max guests',
      bedType: 'Bed type',
      roomPrice: 'Room price / night',
      addRoom: 'Add room',
      heroUrl: 'Cover image URL',
      galleryUrls: 'More image URLs (one per line)',
      cancelPolicy: 'Cancellation policy',
      cancelFree: 'Free cancellation',
      cancelPartial: 'Partial refund',
      cancelNone: 'Non-refundable',
      checkinMethod: 'Check-in method',
      houseRules: 'House rules',
      languages: 'Languages (comma-separated)',
      exposure: 'Listing tier',
      perks: 'Special perks',
      doneMsg: 'Submitted. It will appear after review.',
      amenityBasic: 'Basics',
      amenityBath: 'Bathroom',
      amenityBuilding: 'Building',
      amenityService: 'Services',
      amenityOther: 'Other',
      amenityTv: 'TV',
      amenityFridge: 'Fridge',
      amenityBathtub: 'Bathtub',
      amenityShower: 'Shower',
      amenityHairdryer: 'Hair dryer',
      amenityRestaurant: 'Restaurant',
      amenityBar: 'Bar',
      amenityRoomService: 'Room service',
      amenityLaundry: 'Laundry',
      amenityAirportPickup: 'Airport pickup',
      roomInvalid: 'Enter a room name and valid price.',
      roomName: 'Room name',
      roomImageUrl: 'Room image URL',
      photoCatsHint: 'Category URLs are merged without duplicates (max 20).',
      catExterior: 'Exterior',
      catLobby: 'Lobby',
      catRoom: 'Rooms',
      catPool: 'Pool',
    },
    reviewsLabel: '{n} reviews',
    reviewsTab: 'Reviews',
    noRooms: 'No rooms listed yet',
    noReviews: 'No reviews yet',
    bookOk: 'Your booking request was received',
    type: {
      hotel: 'Hotel',
      resort: 'Resort',
      guesthouse: 'Guesthouse',
      villa: 'Villa',
      hostel: 'Hostel',
    },
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    perNight: 'per night',
    book: 'Book now',
    rooms: 'Rooms',
    amenities: 'Amenities',
    noHotels: 'No hotels available yet',
    adminTitle: 'Hotels (admin)',
    adminTotal: 'All hotels',
    adminPending: 'Pending approval',
    adminReported: 'Reported',
    adminApprove: 'Approve',
    adminHide: 'Hide',
    adminDelete: 'Delete',
    adminName: 'Name',
    adminCity: 'City',
    adminStatus: 'Active',
    adminModeration: 'Moderation',
  },
  rental: {
    title: 'Rentals',
    allTypes: 'All',
    car: 'Car',
    motorbike: 'Motorbike',
    scooter: 'Scooter',
    bicycle: 'Bicycle',
    van: 'Van / SUV',
    truck: 'Truck',
    type_car: 'Sedan',
    type_suv_van: 'SUV / Van',
    type_motorbike: 'Motorbike',
    type_scooter: 'Scooter',
    type_bicycle: 'Bicycle',
    type_truck: 'Truck',
    type_e_scooter: 'E-scooter',
    type_tuk_tuk: 'Tuk-tuk',
    type_boat: 'Boat',
    automatic: 'Automatic',
    manual: 'Manual',
    seatsUnit: ' seats',
    perDay: 'Daily',
    perWeek: '7 days',
    perMonth: '30 days',
    weekDiscountBadge: '7d {n}% off',
    pricePolicy: 'Pricing',
    discountDown: 'off',
    perDaySuffix: '/day',
    mileagePolicy: 'Mileage',
    mileageLimitKm: '{n} km/day · overage {fee}/km',
    fuelPolicy: 'Fuel policy',
    insurancePick: 'Insurance',
    driverOption: 'Driving',
    withDriverDaily: 'With driver (+{fee}/day)',
    withDriverIncluded: 'With driver (included)',
    insuranceFullDaily: 'Full cover (+{fee}/day)',
    included: 'Included',
    cityAll: 'All cities',
    cityHcmc: 'Ho Chi Minh City',
    cityDaNang: 'Da Nang',
    cityHanoi: 'Hanoi',
    cityTokyo: 'Tokyo',
    cityOsaka: 'Osaka',
    cityBangkok: 'Bangkok',
    cityChiangMai: 'Chiang Mai',
    eScooter: 'E-scooter',
    suv: 'SUV / Van',
    tukTuk: 'Tuk-tuk',
    boat: 'Boat',
    semiAuto: 'Semi-auto',
    gasoline: 'Gasoline',
    diesel: 'Diesel',
    electric: 'Electric',
    hybrid: 'Hybrid',
    withDriver: 'With driver',
    selfDrive: 'Self-drive',
    licenseIntl: 'International license',
    fuelFullToFull: 'Full to full',
    fuelSameLevel: 'Same level return',
    fuelIncluded: 'Fuel included',
    mileageUnlimited: 'Unlimited mileage',
    insuranceBasic: 'Basic insurance',
    insuranceFull: 'Full cover',
    chipWithDriver: 'With driver',
    currencyLabel: 'Currency',
    discount7Toggle: 'Apply 7-day discount (%)',
    discount7Pct: '7-day discount (%)',
    discount30Toggle: 'Apply 30-day discount (%)',
    discount30Pct: '30-day discount (%)',
    offersDriverToggle: 'Offer driver option',
    driverPerDayLabel: 'Driver add-on (/day)',
    insuranceFullDailyHost: 'Full insurance add-on (/day, at booking)',
    estTwentyDays: '~20 rental days / month: {amount}',
    incToolsLabel: 'Tools',
    incChildSeatLabel: 'Child seat',
    incPhoneMountLabel: 'Phone mount',
    fuelPolicyPickTitle: 'Fuel policy',
    mileageKmDayLabel: 'Daily km cap',
    mileageOverageLabel: 'Overage per km',
    registerLangs: 'Languages',
    registerExposure: 'Exposure tier',
    deposit: 'Deposit',
    depositRefund: 'Fully refunded after return',
    licenseRequired: 'License',
    licenseInternational: 'International license',
    licenseLocal: 'Local license',
    licenseNone: 'No license required',
    minAge: 'Minimum age',
    ageUnit: ' yrs',
    delivery: 'Delivery',
    deliveryAvailable: 'Delivery available',
    deliveryNo: 'Pickup only',
    deliveryFee: 'Delivery fee',
    pickup: 'Pickup',
    pickupDay: 'Pickup date',
    returnDay: 'Return date',
    pickupLocation: 'Pickup location',
    pickupCity: 'City',
    pickupLocationPh: 'e.g. Da Nang Airport',
    pickupHours: 'Pickup hours',
    pickupInfo: 'Pickup & return',
    pickupMethod: 'Pickup method',
    pickupSelf: 'Self pickup',
    pickupDelivery: 'Delivery (+{fee})',
    returnLocation: 'Return location',
    includes: "What's included",
    excludesTitle: 'Not included',
    excludeFuel: 'Fuel',
    excludeRepair: 'Repairs',
    includesNone: 'No extras listed',
    helmet: 'Helmet',
    insurance: 'Basic insurance',
    gps: 'GPS',
    bookNow: 'Book',
    selectDates: 'Dates',
    cardChat: 'Chat',
    cardRent: 'Rent',
    applyRent: 'Request rental',
    applyRentNeedDates: 'Select pickup and return dates first',
    search: 'Search',
    totalDays: '{n} days total',
    totalAmount: 'Total',
    registerCta: 'List your vehicle',
    myRentals: 'My vehicles',
    myBookings: 'My bookings',
    noRentals: 'No vehicles yet',
    noBookings: 'No bookings yet',
    hostInfo: 'Host',
    responseRate: 'Response rate',
    responseTime: 'Avg. response',
    activityBadge: 'Activity {n}',
    hostLangs: 'Languages',
    reviewCar: 'Vehicle condition',
    reviewClean: 'Cleanliness',
    reviewPickup: 'Pickup ease',
    reviewValue: 'Value',
    reviewsTitle: 'Reviews',
    reviewCount: '{n} reviews',
    noReviews: 'No reviews yet',
    verifiedVehicle: 'Verified',
    badgeNew: 'New',
    favorite: 'Save',
    demoBadge: 'Demo',
    demoFavorite: 'Demo listings cannot be saved.',
    demoBooked: 'Demo booking complete (no charge)',
    bookingSuccess: 'Booking confirmed!',
    needDates: 'Please select dates.',
    notFound: 'Vehicle not found.',
    sortPrice: 'Price',
    sortRating: 'Rating',
    noIntlLicense: 'No intl. license',
    specTitle: 'Specs',
    specType: 'Type',
    specTrans: 'Transmission',
    specSeats: 'Seats',
    specFuel: 'Fuel',
    specCc: 'Engine',
    specYear: 'Year',
    specColor: 'Color',
    specDoors: 'Doors',
    rulesTitle: 'Rental rules',
    licenseNeed: 'License',
    mapSection: 'Location',
    openMap: 'Open in Maps',
    nextStep: 'Next',
    prevStep: 'Back',
    confirmBooking: 'Confirm booking',
    registerStep1: 'Vehicle type',
    registerStep2: 'Vehicle info',
    registerStep3: 'Insurance & license',
    registerStep4: 'Pricing',
    registerStep5: 'Add-ons',
    registerStep6: 'Fuel & mileage',
    registerStep7: 'Pickup location',
    registerStep8: 'Vehicle photos',
    registerStep9: 'Visibility & contact',
    register: {
      typeScooter: 'Scooter',
      typeBicycle: 'Bicycle',
      stepVehicleInfo: 'Vehicle Info',
      stepPricing: 'Pricing',
      stepPickup: 'Pickup Location',
      stepInsurance: 'Insurance',
      stepPhotos: 'Photos',
      stepOptions: 'Options',
      optionHelmet: 'Helmet',
      optionGPS: 'GPS',
      optionAirport: 'Airport Pickup',
    },
    registerTitle: 'List a vehicle',
    brand: 'Brand',
    model: 'Model',
    year: 'Year',
    color: 'Color',
    seats: 'Seats',
    engineCc: 'Engine (cc)',
    listingTitle: 'Listing title',
    listingTitlePh: 'e.g. 2022 Toyota Camry',
    minAgeShort: 'Min age',
    priceDay: 'Daily price',
    priceWeek: 'Weekly price (optional)',
    priceMonth: 'Monthly price (optional)',
    estMonth: 'Est. 30-day earnings',
    photoHint: 'Bright, clean photos boost bookings!',
    photoFront: 'Front (required)',
    photoRear: 'Rear (required)',
    photoSide: 'Side',
    photoInterior: 'Interior',
    photoExtra: 'Extra',
    incCleanLabel: 'Cleaned',
    incTankLabel: 'Full tank',
    phone: 'Phone',
    kakao: 'KakaoTalk ID',
    consultHours: 'Contact hours',
    instantBook: 'Instant book',
    submitList: 'Submit listing',
    registerDone: 'Submitted. It will appear after review.',
    adminTitle: 'Rentals (admin)',
    adminTotal: 'All vehicles',
    adminAvailable: 'Available',
    adminBooked: 'On trip',
    adminReported: 'Reported',
    adminToday: 'New today',
    adminApprove: 'Approve',
    adminHide: 'Hide',
    adminDelete: 'Delete',
    adminHost: 'Host',
    adminBookings: 'Bookings',
    adminStatus: 'Status',
  },
  extendedDetail: {
    revenueAria: 'Trust & monetization',
    premiumPinned: 'Top placement',
    verifiedBiz: 'Mingo verified business',
    notifyCta: 'Notify me when booking opens',
    notifyOn: 'You will be notified',
    notifySaved: 'Saved. We will remind you.',
    reviewCta: 'Leave a review — earn points',
    reviewPointsHint: 'Reviews help others and unlock points when the program goes live.',
    comingSoon: 'Soon',
  },
  expansion: {
    weatherAria: 'Weather & alerts',
    weatherLoading: 'Loading weather…',
    weatherError: 'Weather unavailable. Pull to retry from home.',
    weatherLocation: 'Da Nang area',
    weatherToday: 'Today',
    weatherTomorrow: 'Tomorrow',
    weatherRefresh: 'Refresh',
    weatherSource: 'Forecast: Open-Meteo (no warranty).',
    sosFab: 'Emergency SOS',
    sosSheetTitle: 'What do you need?',
    sosHint: 'For life-threatening emergencies, call local emergency services first.',
    sosToast: 'SOS: {type} — opening emergency contacts.',
    sosType: {
      medical: 'Medical help',
      scam: 'Scam / fraud',
      legal: 'Legal help',
      lost: 'Lost / directions',
    },
    airportTitle: 'Airport pickup',
    airportIntro: 'Korean-speaking drivers available on selected listings.',
    carpoolTitle: 'Carpool board',
    carpoolIntro: 'Share rides between cities and the airport. Payments open later.',
    carpoolPostSoon: 'Post a ride (coming soon)',
    carpoolSeats: '{n} seats left',
    carpoolJoin: 'Join ride',
    carpoolJoinSoon: 'Booking opens in a later update.',
    insuranceTitle: 'Insurance compare',
    insuranceIntro: 'Tap a partner link — Mingo may earn a commission when you apply (affiliate).',
    insuranceType: { travel: 'Travel', health: 'Health', property: 'Home / contents' },
    compareApply: 'Get a quote (external)',
    affiliateToast: 'Opening partner: {name}',
    remittanceTitle: 'Remittance compare',
    remittanceIntro: 'Compare routes and fees. Links are affiliate placements.',
    remittanceRate: 'Indicative rate',
    remittanceFee: 'Fees',
    remittanceSpeed: 'Speed',
    remittanceOpen: 'Open provider site',
    dealsTitle: 'Local deals',
    dealsIntro: 'Limited-time offers from partners — countdown is indicative.',
    dealsEnds: 'Ends in',
    dealsSold: '{sold} / {total} claimed',
    dealBuy: 'Buy / reserve',
    dealBuySoon: 'Checkout opens in a later update.',
    settlementTitle: 'Settlement packages',
    settlementIntro: 'Arrival & relocation bundles from vetted coordinators.',
    settlementDays: 'days program',
    settlementIncludes: "What's included",
    schoolListTitle: 'Schools & education',
    schoolTypeLabel: 'School type',
    schoolFilterCurr: 'Curriculum',
    schoolFilterLang: 'Language of instruction',
    schoolMaxTuition: 'Max annual tuition (USD): {max}',
    schoolComparePick: '{n} selected (max 3)',
    schoolCompareGo: 'Compare',
    schoolCompareAdd: 'Compare',
    schoolDetailTitle: 'School',
    schoolCurriculum: 'Curriculum',
    schoolGrades: 'Grades / ages',
    schoolWebsite: 'Website',
    schoolTuitionTable: 'Tuition & fees',
    schoolGradeCol: 'Level',
    schoolAnnual: 'Tuition (yr)',
    schoolEnrollment: 'Enrollment / other',
    schoolParentReviews: 'Parent reviews',
    schoolNoReviews: 'No reviews yet.',
    schoolRatingsBreakdown: 'Academics {a} · Facilities {f} · Teachers {te} · Value {v}',
    schoolPros: 'Pros',
    schoolCons: 'Cons',
    schoolAnon: 'Anonymous parent',
    schoolNamed: 'Parent',
    schoolInquiry: 'Admission inquiry',
    schoolChildAge: "Child's age",
    schoolChildGrade: 'Current / target grade',
    schoolDesiredStart: 'Desired start',
    schoolInquirySoon: 'Submit inquiry (coming soon)',
    schoolSimilar: 'Similar schools',
    schoolCompareTitle: 'Compare schools',
    schoolCompareNeedTwo: 'Pick at least two schools from the list, then open Compare.',
    schoolCompareCol: 'Topic',
    schoolTuitionRange: 'Tuition range',
    schoolType: {
      all: 'All',
      kindergarten: 'Kindergarten',
      elementary: 'Elementary',
      middle: 'Middle',
      high: 'High school',
      international: 'International school',
      alternative: 'Alternative / weekend',
      academy: 'Language institute',
      tutoring: 'Tutoring / STEM',
    },
    currFilter: { all: 'All curricula', IB: 'IB', AP: 'AP', US: 'US-style', KR: 'Korean track', VN: 'Vietnamese' },
    eduConsultTitle: 'School admission consultants',
    eduConsultIntro: '1:1 guidance for shortlists, essays, and interviews.',
    eduConsultSchools: 'School focus',
    eduConsultPerSession: '/ session',
    eduConsultApplySoon: 'Book session (coming soon)',
    fitnessTitle: 'Gyms & fitness',
    fitnessTab: { all: 'All', gym: 'Gym', yoga: 'Yoga', pool: 'Pool / swim' },
    fitnessMonthly: 'Monthly',
    fitnessDay: 'Day pass',
    fitnessDetailSoon: 'Venue detail page is coming soon.',
    homeDealsTitle: "Today's deals",
    homeRecTitle: 'Recommended places',
  },
  revenueSvc: {
    title: 'Revenue services',
    description: 'Description',
    price: 'Price',
    book: 'Book',
    golfTitle: 'Golf courses',
    golfIntro: 'Green fees shown are sample partner rates — confirm before play.',
    golfGreen: 'Green fee',
    golfCaddie: 'Caddie',
    golfCart: 'Cart',
    golfBookSoon: 'Book tee time (coming soon)',
    golfDetailTitle: 'Golf course',
    golfFees: 'Fees',
    golfFeeType: 'Item',
    golfWeekday: 'Weekday',
    golfWeekend: 'Weekend',
    golfTeeTime: 'Tee time',
    golfSimilar: 'Other courses',
    medicalTitle: 'Medical tourism & aesthetics',
    medicalIntro: 'Consultation-first listings. Prices are indicative packages.',
    medicalCat: {
      all: 'All',
      plastic: 'Plastic surgery',
      derma: 'Dermatology',
      dental: 'Dental',
      oriental: 'Traditional / wellness',
      checkup: 'Health screening',
    },
    medicalRecovery: 'Recovery',
    medicalDays: 'days',
    medicalBookSoon: 'Reserve (coming soon)',
    boatTitle: 'Yacht & boat charters',
    boatIntro: 'Sunset cruises, fishing, and private charters in Da Nang area.',
    boatType: { cruise: 'Cruise', fishing: 'Fishing', yacht: 'Yacht party' },
    boatCapacity: 'Capacity',
    boatPerHour: 'Per hour',
    boatPerDay: 'Per day',
    boatDepart: 'Departure',
    boatBookSoon: 'Book charter (coming soon)',
    photoTitle: 'Photo & video pros',
    photoIntro: 'Portfolios and package ranges — booking opens later.',
    photoCat: {
      all: 'All',
      wedding: 'Wedding',
      family: 'Family',
      travel: 'Travel',
      product: 'Product',
      drone: 'Drone add-on',
    },
    photoBookSoon: 'Book shoot (coming soon)',
    eventTitle: 'Event planners',
    eventIntro: 'Corporate, wedding, and family milestones.',
    eventFrom: 'From',
    eventDefaultDesc: 'Bilingual coordination and vendor management.',
    digitalTitle: 'IT & digital gigs',
    digitalIntro: 'Fixed-scope listings — escrow & checkout coming later.',
    digitalCat: {
      all: 'All',
      web: 'Web dev',
      app: 'App dev',
      design: 'Design',
      marketing: 'Marketing',
      translate: 'Translation',
      video: 'Video edit',
    },
    digitalDays: 'days delivery',
    digitalOrderSoon: 'Order (coming soon)',
  },
  pet: {
    title: 'Pet services',
    detailTitle: 'Pet listing',
    registerTitle: 'Register Pet Service',
    stepType: 'What service do you offer?',
    petTypes: 'Pet Types',
    stepService: 'Service Details',
    serviceName: 'Service Name',
    serviceNamePlaceholder: 'e.g. Premium Dog Grooming',
    serviceDesc: 'Description',
    serviceDescPlaceholder: 'Describe your service, experience, and highlights',
    price: 'Price',
    duration: 'Duration',
    address: 'Location',
    addressPlaceholder: 'Service area or address',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved listings appear in pet services',
    registerSuccess: 'Pet service registered successfully',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
    registerDesc: 'Offering pet services?',
    registerBtn: 'Register Service',
    cat: {
      all: 'All',
      vet: 'Vet',
      sitter: 'Pet sitter',
      groom: 'Grooming',
      train: 'Training',
      shop: 'Supplies',
      adopt: 'Adoption',
    },
    svcCat: {
      vet: 'Vet',
      sitter: 'Sitter',
      groom: 'Grooming',
      train: 'Training',
      shop: 'Supplies',
    },
    species: { dog: 'Dog', cat: 'Cat' },
    male: 'Male',
    female: 'Female',
    vaccinated: 'Vaccinated',
    neutered: 'Neutered / spayed',
    adoptionFee: 'Adoption fee',
    owner: 'Lister',
    chatSeller: 'Chat with lister',
    adoptionSection: 'Adoption',
    animals: 'Pet types',
  },
  exp: {
    title: 'Experiences & Tickets',
    heroTitle: 'Expat-Recommended Experiences',
    heroDesc: 'Cooking, surfing, tours, shows\nAll in Korean',
    searchPlaceholder: 'Search experiences',
    catAll: 'All',
    catCooking: 'Cooking',
    catCraft: 'Craft',
    catSports: 'Sports',
    catTour: 'Tour',
    catWellness: 'Wellness',
    catFood: 'Food Tour',
    catShow: 'Show',
    catClass: 'Class',
    sortRating: 'Top Rated',
    sortNewest: 'Newest',
    sortPrice: 'Price',
    count: '{n} found',
    empty: 'No experiences found',
    registerFirst: 'Be the first to list',
    registerDesc: 'Running an experience or class?',
    registerBtn: 'List Your Experience',
    perPerson: 'person',
    hours: 'hrs',
    maxGuests: 'Max {n}',
    reviews: 'reviews',
    registerTitle: 'List Experience',
    stepCategory: 'What type of experience?',
    stepBasic: 'Experience Details',
    expTitle: 'Title',
    titlePlaceholder: 'e.g. Da Nang Cooking Class - Traditional Vietnamese',
    expDesc: 'Description',
    descPlaceholder: 'Describe the experience, schedule, and highlights',
    price: 'Price per Person',
    duration: 'Duration',
    includes: "What's Included",
    excludes: 'Not Included',
    excludesPlaceholder: 'e.g. Lunch, extra drinks (comma separated)',
    stepLocation: 'Location & Language',
    meetingPoint: 'Meeting Point',
    meetingPointPlaceholder: 'e.g. Han Market entrance, hotel pickup',
    language: 'Language',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved listings appear in experiences',
    registerNotice3: 'False information may result in restrictions',
    registerSuccess: 'Experience registered. Pending approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  vehicle: {
    title: 'Used vehicles',
    detail: 'Vehicle',
    cat: {
      all: 'All',
      sedan: 'Sedan',
      suv: 'SUV',
      motorcycle: 'Motorcycle',
      scooter: 'Scooter',
      bicycle: 'Bicycle',
      truck: 'Truck',
    },
    brand: 'Brand / model search',
    yearMin: 'Min year',
    priceMaxVnd: 'Max price (VND)',
    kmMax: 'Max km',
    trans: { all: 'Transmission', auto: 'Auto', manual: 'Manual' },
    docsOk: 'Papers OK',
    galleryExterior: 'Exterior',
    galleryInterior: 'Interior',
    galleryEngine: 'Engine bay',
    sides4: 'Four sides',
    negotiable: 'Price negotiable',
    fxLink: 'Open exchange calculator',
    docs: 'Documents',
    docsPartial: 'Partial / verify in person',
    insurance: 'Insurance',
    inspection: 'Inspection valid until',
    seller: 'Seller',
    otherFromSeller: 'More from this seller',
    chat: 'Chat',
    call: 'Call',
    favorite: 'Save',
    year: 'Year',
    mileage: 'Mileage',
    price: 'Price',
    contact: 'Contact',
    noVehicles: 'No vehicles registered.',
  },
  mentor: {
    title: 'Mentoring',
    specialty: 'Specialty',
    experience: 'Experience',
    price: 'Price / hour',
    book: 'Apply for mentoring',
    noMentors: 'No mentors registered.',
    heroTitle: 'Expat Expert Mentoring',
    heroDesc: 'Startup, marketing, real estate, language\nLearn directly from local experts',
    registerBtn: 'Become a Mentor',
    sortRating: 'Top Rated',
    sortReviews: 'Most Reviewed',
    sortPrice: 'Price',
    registerTitle: 'Register as Mentor',
    stepCategory: 'Select your expertise',
    stepCategoryDesc: 'Multiple selection allowed',
    stepProfile: 'Mentor Profile',
    name: 'Name',
    namePlaceholder: 'e.g. John Kim',
    mentorTitle: 'Mentor Title',
    titlePlaceholder: 'e.g. Vietnam Startup Expert Mentor',
    bio: 'Bio',
    bioPlaceholder: 'Describe your experience, expertise, and mentoring style',
    experienceYears: 'Years of Experience',
    pricePerHour: 'Price per Hour',
    hour: 'hr',
    sessionDuration: 'Session Duration',
    minutes: 'min',
    stepConsultation: 'Consultation & Language',
    consultationType: 'Consultation Type',
    languages: 'Languages',
    maxMentees: 'Max Mentees',
    people: ' people',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved profiles appear in mentoring list',
    registerNotice3: 'False information may result in restrictions',
    registerSuccess: 'Mentor registered. Pending approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Register as Mentor',
    detail: 'Mentor',
    cat: {
      all: 'All',
      job: 'Career abroad',
      startup: 'Startup',
      invest: 'Invest / finance',
      immigration: 'Immigration',
      visa: 'Visa',
      lang: 'Language',
      culture: 'Culture',
    },
    years: 'yrs exp',
    modeVideo: 'Video',
    modePhone: 'Phone',
    modeChat: 'Chat',
    mentees: 'Mentees',
    reviews: 'Reviews',
    expertise: 'Background',
    services: 'Services',
    method: 'Method',
    topic: 'Topic',
    applySoon: 'Apply (coming soon)',
    similar: 'Similar mentors',
    booking: 'Booking',
  },
  photo: {
    heroTitle: 'Photo & Video Professionals',
    heroDesc: 'Wedding, product, portrait, video editing\nLocal Da Nang professionals',
    registerDesc: 'Are you a photographer or videographer?',
    registerBtn: 'Register as Photographer',
    registerTitle: 'Register Photo/Video Service',
    stepType: 'What type of photography?',
    styles: 'Photography Styles',
    stepBasic: 'Service Details',
    serviceName: 'Service Name',
    serviceNamePlaceholder: 'e.g. Da Nang Wedding Photography',
    desc: 'Description',
    descPlaceholder: 'Describe your experience, specialty, and equipment',
    priceRange: 'Price Range',
    duration: 'Shooting Duration',
    includes: 'Included',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved listings appear in photo services',
    registerSuccess: 'Service registered. Pending approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  digital: {
    heroTitle: 'IT & Digital Professionals',
    heroDesc: 'Web, app, design, SNS marketing\nIT services for expat businesses',
    registerDesc: 'Offering IT or digital services?',
    registerBtn: 'Register Service',
    registerTitle: 'Register IT/Digital Service',
    stepCategory: 'What service do you offer?',
    stepService: 'Service Details',
    serviceTitle: 'Service Title',
    titlePlaceholder: 'e.g. Responsive Website Development',
    desc: 'Description',
    descPlaceholder: 'Describe your tech stack, experience, and portfolio',
    priceType: 'Price Type',
    price: 'Price',
    deliveryDays: 'Delivery',
    includes: 'Included',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved listings appear in digital services',
    registerSuccess: 'Service registered. Pending approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  coworking: {
    heroTitle: 'Coworking Spaces',
    heroDesc: 'Da Nang & Hoi An coworking spaces\nKorean support · Fast WiFi · Meeting rooms',
    registerBtn: 'List Space',
    sortRating: 'Top Rated',
    sortPrice: 'Price',
    sortNewest: 'Newest',
    registerTitle: 'Register Coworking Space',
    stepType: 'What type of space?',
    amenities: 'Amenities',
    stepBasic: 'Space Details',
    spaceName: 'Space Name',
    spaceNamePlaceholder: 'e.g. Da Nang Korea Coworking',
    desc: 'Description',
    descPlaceholder: 'Describe the space, atmosphere, and surroundings',
    address: 'Address',
    addressPlaceholder: 'e.g. Near My Khê Beach, Da Nang',
    capacity: 'Capacity',
    openingHours: 'Opening Hours',
    wifiSpeed: 'WiFi Speed',
    pricing: 'Pricing (USD)',
    perHour: 'hour',
    perDay: 'day',
    perMonth: 'month',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved spaces appear in the listing',
    registerSuccess: 'Coworking space registered successfully',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  insurance: {
    heroTitle: 'Expat Insurance Services',
    heroDesc: 'Health, travel, life, car insurance\nKorean consultation available',
    registerDesc: 'Want to list an insurance product?',
    registerBtn: 'List Insurance Product',
    registerTitle: 'Register Insurance Product',
    stepType: 'What type of insurance?',
    coverage: 'Coverage',
    stepBasic: 'Product Details',
    provider: 'Insurance Provider',
    providerPlaceholder: 'e.g. AIA Vietnam',
    productName: 'Product Name',
    productNamePlaceholder: 'e.g. Expat Health Insurance Plan',
    desc: 'Description',
    descPlaceholder: 'Describe the product features and benefits',
    priceRange: 'Premium Range',
    duration: 'Duration',
    languages: 'Languages',
    affiliateLink: 'Affiliate Link (optional)',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'False information may result in restrictions',
    registerNotice3: 'Insurance sales must comply with regulations',
    registerSuccess: 'Insurance product registered successfully',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  koreanShop: {
    title: 'Korean products',
    products: 'Products',
    product: 'Product',
    cat: {
      all: 'All',
      food: 'Food',
      beauty: 'Beauty',
      living: 'Living',
      fashion: 'Fashion',
      electronics: 'Electronics',
      medicine: 'Medicine',
    },
    groupSection: 'Group buy shipping',
    groupHint: 'Team up to save on international shipping.',
    groupCta: 'Browse group buys',
    ship: 'Shipping',
    stock: 'Stock',
    minOrder: 'Min order qty',
    buySoon: 'Buy (coming soon)',
    joinGroup: 'Join group buy',
    seller: 'Seller',
    related: 'Related products',
    order: 'Order now',
    noShops: 'No shops registered.',
  },
  news: {
    title: 'News & info',
    readMore: 'Read more',
    noNews: 'No news available.',
    latest: 'Latest',
    trending: 'Trending',
    detail: 'Article',
    views: 'Views',
    cat: {
      all: 'All',
      visa: 'Visa',
      realestate: 'Real estate',
      life: 'Life',
      business: 'Business',
      kr: 'Korea news',
      vn: 'Vietnam news',
    },
    related: 'Related',
    comments: 'Comments',
    sampleComment: 'Great summary — thanks for sharing!',
    postComment: 'Post',
    commentSoon: 'Comments will open soon.',
  },
  wedding: {
    title: 'Wedding',
    package: 'Package',
    price: 'Price',
    book: 'Book consultation',
    noWedding: 'No vendors registered.',
    detail: 'Wedding vendor',
    heroTitle: 'Da Nang Wedding Services',
    heroDesc: 'Hall, photo, dress, makeup\nKorean expat wedding services',
    registerDesc: 'Running a wedding service?',
    registerBtn: 'Register Wedding Service',
    registerTitle: 'Register Wedding Service',
    stepType: 'What wedding service do you offer?',
    stepBasic: 'Service Details',
    bizName: 'Business/Service Name',
    bizNamePlaceholder: 'e.g. Da Nang Ocean View Wedding Hall',
    desc: 'Description',
    descPlaceholder: 'Describe your service, features, and experience',
    priceRange: 'Price Range',
    priceFrom: 'From',
    priceTo: 'To',
    includes: 'Included',
    stepLocation: 'Location & Language',
    address: 'Address/Location',
    addressPlaceholder: 'e.g. Near My Khe Beach, Da Nang',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Approved listings appear in wedding services',
    registerNotice3: 'False information may result in restrictions',
    registerSuccess: 'Wedding service registered. Pending approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
    cat: {
      all: 'All',
      hall: 'Hall',
      studio: 'Studio',
      dress: 'Dress',
      catering: 'Catering',
      honeymoon: 'Honeymoon',
      flower: 'Flowers',
    },
    capacity: 'Capacity',
    packages: 'Packages',
    inquireSoon: 'Inquire (coming soon)',
  },
  advertiser: {
    title: 'Ad manager',
    inquiry: 'Submit ad inquiry',
    type: 'Ad type',
    budget: 'Budget',
    submit: 'Submit inquiry',
    credit: 'Credits',
    newAd: 'Create ad',
    payments: 'Payment history',
    myAds: 'My ads',
    imp: 'Impressions',
    clk: 'Clicks',
    rowCredit: 'Credits left',
  },
  survey: {
    title: 'Surveys',
    participate: 'Participate',
    reward: 'Reward',
    noSurveys: 'No active surveys.',
    completed: 'Completed',
    intro: 'Earn points by sharing feedback (pilot).',
    points: 'pts',
    deadline: 'Deadline',
    join: 'Join',
    joinSoon: 'Survey flow coming soon — thanks for your interest!',
  },
  hospitalBook: {
    title: 'Hospital booking',
    selectDate: 'Select date',
    selectTime: 'Select time',
    symptoms: 'Symptoms',
    confirm: 'Confirm booking',
    cancel: 'Cancel booking',
    noSlots: 'No available slots.',
    cta: 'Book',
    modalTitle: 'Book at {name}',
    symptom: 'Symptoms / notes',
    disclaimer: 'For emergencies call 115. Online booking is a pilot feature.',
    confirmSoon: 'Confirm booking (coming soon)',
    notifyMe: 'Save request & notify me',
    confirmedSoon: 'Request saved. We will notify you when booking opens.',
    badge24: '24h',
    badgeEr: 'ER',
  },
  hospital: {
    title: 'Hospitals & pharmacy',
    tabAll: 'All',
    searchPlaceholder: 'Search name or specialty',
    favoritesOnly: 'Saved',
    favorite: 'Save',
    verified: 'Verified',
    demoBadge: 'Demo',
    demoFavorite: 'Demo listings cannot be saved.',
    notFound: 'Hospital not found.',
    reviewCount: '{n} reviews',
    openNow: 'Open',
    closedNow: 'Closed',
    open24Badge: '24h',
    registerCta: 'List your facility',
    noHospitals: 'No hospitals yet',
    myBookings: 'My bookings',
    bookingConfirmed: 'Booking confirmed!',
    bookingCancelled: 'Booking cancelled',
    needBookingFields: 'Please pick specialty, date and time.',
    typeGeneral: 'General hospital',
    typeClinic: 'Clinic',
    typePharmacy: 'Pharmacy',
    typeDental: 'Dental',
    typeKoreanMed: 'Korean medicine',
    typeEmergency: 'Emergency center',
    type_general: 'General hospital',
    type_clinic: 'Clinic',
    type_pharmacy: 'Pharmacy',
    type_dental: 'Dental',
    type_korean_medicine: 'Korean medicine',
    type_emergency_center: 'Emergency center',
    type_other: 'Other',
    specialtyInternal: 'Internal medicine',
    specialtySurgery: 'Surgery',
    specialtyOrthopedic: 'Orthopedics',
    specialtyPlastic: 'Plastic surgery',
    specialtyDermatology: 'Dermatology',
    specialtyDental: 'Dental',
    specialtyEye: 'Ophthalmology',
    specialtyENT: 'ENT',
    specialtyOBGYN: 'OB/GYN',
    specialtyPediatric: 'Pediatrics',
    specialtyNeuro: 'Neurology',
    specialtyPsych: 'Psychiatry',
    specialtyCardio: 'Cardiology',
    specialtyUrology: 'Urology',
    specialtyRehab: 'Rehabilitation',
    specialtyFamily: 'Family medicine',
    specialtyEmergency: 'Emergency medicine',
    specialtyKoreanMed: 'Korean medicine',
    specialtyCheckup: 'Health checkup',
    specialtyVaccine: 'Vaccination',
    specialtyLasik: 'LASIK / LASEK',
    specialtyAesthetic: 'Aesthetic',
    specialtyPhysical: 'Physiotherapy',
    specialty_internal: 'Internal medicine',
    specialty_surgery: 'Surgery',
    specialty_orthopedic: 'Orthopedics',
    specialty_plastic: 'Plastic surgery',
    specialty_dermatology: 'Dermatology',
    specialty_dental: 'Dental',
    specialty_eye: 'Ophthalmology',
    specialty_ent: 'ENT',
    specialty_obgyn: 'OB/GYN',
    specialty_pediatric: 'Pediatrics',
    specialty_neuro: 'Neurology',
    specialty_psych: 'Psychiatry',
    specialty_cardio: 'Cardiology',
    specialty_urology: 'Urology',
    specialty_rehab: 'Rehabilitation',
    specialty_family: 'Family medicine',
    specialty_emergency: 'Emergency medicine',
    specialty_korean_med: 'Korean medicine',
    specialty_checkup: 'Health checkup',
    specialty_vaccine: 'Vaccination',
    specialty_lasik: 'LASIK / LASEK',
    specialty_aesthetic: 'Aesthetic',
    specialty_physical: 'Physiotherapy',
    specialty_orthopedics: 'Orthopedics',
    specialty_neurology: 'Neurology',
    specialty_cardiology: 'Cardiology',
    specialty_ophthalmology: 'Ophthalmology',
    specialty_obstetrics: 'Obstetrics',
    specialty_pediatrics: 'Pediatrics',
    specialty_psychiatry: 'Psychiatry',
    specialty_general_dental: 'General Dental',
    specialty_orthodontics: 'Orthodontics',
    specialty_implant: 'Implant',
    specialty_whitening: 'Whitening',
    specialty_oral_surgery: 'Oral Surgery',
    specialty_acupuncture: 'Acupuncture',
    specialty_herbal: 'Herbal Medicine',
    specialty_chiropractic: 'Chiropractic',
    specialty_cupping: 'Cupping',
    specialty_prescription: 'Prescription',
    specialty_otc: 'OTC Medicine',
    specialty_health_supplement: 'Supplements',
    specialty_misc: 'Other',
    koreanFriendly: 'Korean speaking',
    emergency: 'ER',
    open24h: '24 hours',
    bookingAvailable: 'Booking',
    selectSpecialty: 'Choose specialty',
    selectDoctor: 'Choose doctor',
    anyDoctor: 'No preference',
    selectDateTime: 'Date & time',
    selectTime: 'Time slot',
    symptoms: 'Symptoms',
    symptomsPlaceholder: 'What symptoms bring you in?',
    interpreterNeeded: 'Korean interpreter needed',
    insuranceKorean: 'Korean insurance',
    insuranceInternational: 'International insurance',
    insuranceTravel: 'Travel insurance',
    insuranceTitle: 'Insurance',
    insuranceNone: 'No insurance info listed',
    ratingStaff: 'Staff kindness',
    ratingFacility: 'Facility cleanliness',
    ratingComm: 'Communication',
    ratingValue: 'Value for money',
    bookNow: 'Book',
    callNow: 'Call',
    specialtiesTitle: 'Specialties',
    hoursTitle: 'Hours',
    weekday: 'Weekdays',
    weekendSat: 'Saturday',
    weekendSun: 'Sunday',
    todayNote: 'Please call ahead to confirm today’s hours.',
    doctorsTitle: 'Medical staff',
    noDoctors: 'No doctors listed.',
    locationTitle: 'Location',
    openMap: 'Open in Maps',
    distanceKm: '~{n} km',
    reviewsTitle: 'Reviews',
    noReviews: 'No reviews yet.',
    hospitalReply: 'Clinic reply',
    nextStep: 'Next',
    prevStep: 'Back',
    confirmBooking: 'Confirm',
    adminTitle: 'Hospitals admin',
    adminTotal: 'All facilities',
    adminKorean: 'Korean OK',
    adminEmergency: 'With ER',
    adminReported: 'Reported',
    adminToday: 'New today',
    adminBookings: 'Bookings',
    adminHost: 'Owner',
    adminApprove: 'Approve',
    adminHide: 'Hide',
    adminDelete: 'Delete',
    adminStatus: 'Status',
    businessTab: '🏥 Hospital bookings',
    bookingSymptomPreview: 'Symptoms',
    interpreterBadge: 'Interpreter',
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
    statusCancelled: 'Cancelled',
    actionConfirm: 'Confirm',
    actionCancel: 'Cancel',
    registerTitle: 'Register facility',
    registerStep1: 'Business type',
    registerStep2: 'Departments',
    registerStep3: 'Basics & location',
    registerStep4: 'Contact',
    registerStep5: 'Hours',
    registerStep6: 'Languages',
    registerStep7: 'Insurance & fees',
    registerStep8: 'Facility photos',
    registerStep9: 'Doctors',
    registerStep10: 'Visibility',
    registerSubmit: 'Submit',
    registerDone: 'Submitted for review.',
    registerLabelNameKo: 'Hospital name (KO)',
    registerLabelNameLocal: 'Hospital name (local)',
    registerLabelIntro: 'Introduction',
    registerLabelCountry: 'Country',
    registerLabelCity: 'City',
    registerLabelAddress: 'Address',
    registerLabelPhoneRequired: 'Phone (required)',
    registerLabelEmergencyPhone: 'Emergency phone',
    registerLabelWebsite: 'Website',
    registerLabelKakao: 'KakaoTalk',
    registerLabel24h: '24 hours',
    registerLabelEmergencyDept: 'Emergency room',
    registerLabelWeekdayStart: 'Weekday opens',
    registerLabelWeekdayEnd: 'Weekday closes',
    registerLabelSatRange: 'Sat open / close',
    registerLabelSunRange: 'Sun open / close',
    registerInsKorean: '🇰🇷 Korean insurance',
    registerInsIntl: '🌍 International insurance',
    registerInsTravel: '✈️ Travel insurance',
    registerPriceMin: 'Min consultation fee',
    registerPriceMax: 'Max consultation fee',
    registerLabelCurrency: 'Currency',
    registerAcceptsBooking: 'Accepts bookings',
    registerPhotoExterior: 'Exterior (required)',
    registerPhotoLobby: 'Interior / waiting area (required)',
    registerPhotoRoom: 'Consultation room',
    registerPhotoEquipment: 'Equipment',
    registerDoctorName: 'Doctor name',
    registerDoctorSpecialty: 'Specialty',
    registerAddDoctor: '+ Add doctor',
    register: {
      typeGeneral: 'General Hospital',
      typeClinic: 'Clinic',
      typeDental: 'Dental',
      typeOriental: 'Oriental Medicine',
      typePharmacy: 'Pharmacy',
      typeOther: 'Other',
      typeSurgery: 'Surgery',
      stepBasicInfo: 'Basic Info',
      stepLocation: 'Location',
      stepDepartments: 'Departments',
      stepHours: 'Hours',
      stepDoctors: 'Doctors',
      stepPhotos: 'Photos',
      stepBooking: 'Booking',
      stepLanguage: 'Languages',
      stepConfirm: 'Confirm',
      specialty: {
        internal: 'Internal Medicine',
        surgery: 'Surgery',
        orthopedics: 'Orthopedics',
        neurology: 'Neurology',
        cardiology: 'Cardiology',
        dermatology: 'Dermatology',
        ophthalmology: 'Ophthalmology',
        ent: 'ENT',
        obstetrics: 'Obstetrics',
        pediatrics: 'Pediatrics',
        urology: 'Urology',
        psychiatry: 'Psychiatry',
        general_dental: 'General Dental',
        orthodontics: 'Orthodontics',
        implant: 'Implant',
        whitening: 'Whitening',
        oral_surgery: 'Oral Surgery',
        acupuncture: 'Acupuncture',
        herbal: 'Herbal Medicine',
        chiropractic: 'Chiropractic',
        cupping: 'Cupping',
        prescription: 'Prescription',
        otc: 'OTC Medicine',
        health_supplement: 'Supplements',
        misc: 'Other',
      },
    },
  },
  visaService: {
    title: 'Visa & admin services',
    typeVisa: 'Visa agency',
    typeTranslation: 'Document translation',
    typeNotary: 'Notary',
    typeTax: 'Tax & accounting',
    typeLegal: 'Legal counsel',
    typeInsurance: 'Insurance',
    typeImmigration: 'Immigration',
    typeOther: 'Other admin',
    visaTourist: 'Tourist visa',
    visaWork: 'Work visa',
    visaStudent: 'Student visa',
    visaInvestment: 'Investment visa',
    visaRetirement: 'Retirement visa',
    visaMarriage: 'Marriage visa',
    visaFamily: 'Family visa',
    visaExtension: 'Extension',
    visaOther: 'Other',
    processingTime: 'Processing time',
    processingNormal: 'Standard',
    processingExpress: 'Express',
    processingDays: '{min}–{max} days',
    processingPriceTitle: 'Processing & pricing',
    requiredDocs: 'Required documents',
    onlineAvailable: 'Online available',
    koreanFriendly: 'Korean speaking',
    reviewCount: '{n} reviews',
    verified: 'Verified',
    docPassportCopy: 'Passport copy',
    docIdPhoto: 'ID photo',
    inquiryType: 'Inquiry type',
    nationality: 'Nationality',
    contactMethod: 'Contact method',
    contactApp: 'In-app chat',
    contactKakao: 'KakaoTalk',
    contactPhone: 'Phone',
    ratingSpeed: 'Speed',
    ratingPrice: 'Value for money',
    ratingComm: 'Communication',
    registerCta: 'List your service',
    noServices: 'No listings yet',
    inquiry: 'Inquire',
    bookNow: 'Book consult',
    searchPlaceholder: 'Search by name or visa type',
    infoGuideDesc: 'Need visa information?',
    infoGuideLink: 'View Visa Guide',
    demoFavorite: 'Demo listings cannot be favorited.',
    fastProcessing: 'Fast track',
    priceRange: 'Price',
    notFound: 'Service not found.',
    inquirySent: 'Your inquiry was sent.',
    inquiryNeedMessage: 'Please enter at least 3 characters.',
    visaKindsTitle: 'Visa types',
    adminServicesTitle: 'Admin services',
    admin_translation: 'Translation',
    admin_notary: 'Notary',
    admin_tax_filing: 'Tax filing',
    admin_accounting: 'Accounting',
    admin_legal: 'Legal',
    admin_insurance: 'Insurance',
    admin_immigration: 'Immigration',
    admin_property_reg: 'Property registration',
    daysUnit: 'days',
    onlineConsultOk: 'Online consultation available',
    onlineConsultNo: 'Mainly in-person',
    registerTitle: 'Register visa/admin service',
    registerStep1: 'Service type',
    registerStep2: 'Visa types',
    registerStep2Translation: 'Translation setup',
    registerStep2Tax: 'Tax services',
    registerStep2Legal: 'Legal areas',
    registerStep2OtherAdmin: 'Service details',
    registerStep2Extra: 'Service overview',
    branchTranslationPair: 'Language pair',
    branchFromLang: 'Source language',
    branchToLang: 'Target language',
    branchTranslationFields: 'Translation fields',
    transField_general: 'General / personal docs',
    transField_legal: 'Legal / contracts',
    transField_medical: 'Medical',
    transField_business: 'Business / finance',
    transField_academic: 'Academic / transcripts',
    branchTaxKinds: 'Tax service types',
    taxKind_tax_filing: 'Tax filing',
    taxKind_accounting: 'Accounting / books',
    taxKind_payroll: 'Payroll / social insurance',
    taxKind_vat: 'VAT / invoices',
    taxKind_bookkeeping: 'Bookkeeping',
    branchLegalKinds: 'Legal practice areas',
    legalKind_labor: 'Labor / employment',
    legalKind_contract: 'Contracts / transactions',
    legalKind_immigration: 'Immigration / visa',
    legalKind_family: 'Family / divorce',
    legalKind_corporate: 'Corporate / M&A',
    branchOtherNote: 'Services you provide',
    branchOtherPlaceholder: 'Describe the admin or agency work you offer.',
    branchServiceNote: 'Service summary',
    branchServiceNotePh: 'Briefly describe scope and strengths.',
    registerStep3: 'Basics',
    registerStep4: 'Timing & pricing',
    registerStep5: 'Documents',
    registerStep6: 'Contact',
    registerStep7: 'Languages',
    registerStep8: 'Portfolio photos',
    registerStep9: 'Visibility',
    register: {
      typeTranslation: 'Document Translation',
      typeTax: 'Tax Service',
      typeLegal: 'Legal Service',
      stepServiceDetail: 'Service Detail',
      stepCertification: 'Certification',
      stepPricing: 'Pricing',
      pricingFixed: 'Fixed Price',
      pricingQuote: 'Get Quote',
      requiredPassport: 'Passport Copy',
      requiredPhoto: 'ID Photo',
    },
    registerSubmit: 'Submit',
    registerDone: 'Submitted. It will appear after review.',
    fieldName: 'Business name',
    fieldIntro: 'Introduction',
    fieldCountry: 'Country',
    fieldCity: 'City',
    fieldAddress: 'Address',
    fieldPhone: 'Phone',
    fieldKakao: 'KakaoTalk ID',
    fieldWebsite: 'Website',
    procMinMax: 'Standard processing (min–max days)',
    priceMinMax: 'Standard price (min–max)',
    currency: 'Currency',
    expressToggle: 'Express processing available',
    expressDays: 'Express days',
    expressPrice: 'Express price',
    addDoc: '+ Add document',
    photoExterior: 'Office exterior',
    photoInterior: 'Interior',
    photoCert: 'License / certificate',
    inquiryOpt_tourist: 'Tourist visa',
    inquiryOpt_work: 'Work visa',
    inquiryOpt_student: 'Student visa',
    inquiryOpt_investment: 'Investment visa',
    inquiryOpt_extension: 'Extension',
    inquiryOpt_translation: 'Translation',
    inquiryOpt_notary: 'Notary',
    inquiryOpt_tax: 'Tax / accounting',
    inquiryOpt_legal: 'Legal',
    inquiryOpt_insurance: 'Insurance',
    inquiryOpt_immigration: 'Immigration',
    inquiryOpt_other: 'Other',
    bannerTitle: '🛂 Visa & admin pros',
    bannerSubtitle: 'Local experts who speak Korean\n— matched for you',
    statExperts: '{n} pros',
    statAvgRating: 'Avg. {n}',
    statVerified: 'Verified',
    quickCat_visa: 'Visa agency',
    quickCat_translation: 'Translation',
    quickCat_notary: 'Notary',
    quickCat_tax: 'Tax & accounting',
    quickCat_legal: 'Legal',
    quickCat_insurance: 'Insurance',
    quickCat_immigration: 'Immigration',
    quickCat_other: 'Other admin',
    filterAll: 'All',
    filterTabKorean: '🇰🇷 Korean',
    filterTabOnline: '💻 Online',
    filterTabVerified: '✅ Verified',
    filterTabFast: '⚡ Fast track',
    cardInquiry: '💬 Message',
    processTitle: 'How it works',
    timelineStep1: 'Document intake',
    timelineStep2: 'Document review',
    timelineStep3: 'Visa filing',
    timelineStep4: 'Result & pickup',
    servicesTitle: 'Services & pricing',
    pkgApply: 'Apply',
    expressSectionTitle: 'Express',
    expressAvailableBadge: '⚡ Express available',
    expressNormalLine: 'Standard: {days} · {range}',
    expressExpressLine: 'Express: {days} · {range}',
    successStoriesTitle: 'Success stories & reviews',
    reviewVisaLine: '{visa} · {days} days',
    expertTitle: 'Your specialist',
    expertSuccess: 'Success rate',
    expertResponse: 'Avg. response',
    expertCerts: 'Credentials',
    docPassport: 'Passport copy',
    docPhotos: 'ID photos (×2)',
    docFinance: 'Proof of funds',
    docHotel: 'Hotel booking',
    docPassportOrig: 'Passport (original)',
    docApplication: 'Application form',
    docContract: 'Related contracts',
    docBizReg: 'Business registration',
    docSales: 'Revenue records',
    docBank: 'Bank statements',
    expertResponse15: '~15 min response',
    expertResponse30: '~30 min response',
    expertResponseSameDay: 'Same-day reply',
  },
  fortune: {
    title: 'Fortune & tarot',
    intro: 'Free readings; some features need a short in-app ad first.',
    freeLabel: 'Free (no ad)',
    adLabel: 'Free after ad',
    adHint: '“Watch ad, use free”',
    badge: 'Free after ad',
    west12: 'signs',
    cats4: 'Wealth · love · work · health',
    lunarYmd: 'Lunar date (year / month / day)',
    sajuHour: 'Birth hour',
    run: 'Get reading',
    analyzing: 'Reading your fortune… 🔮',
    claudeNoKey: 'AI is not configured. Sign in and set ANTHROPIC_API_KEY on the server (Edge Function).',
    claudeFail: 'Please try again in a moment.',
    birthSaved: 'Birth year saved to your profile.',
    birthYear: 'Birth year (for your zodiac)',
    pickZodiac: 'Or choose your zodiac animal',
    date: 'Date',
    saveBirthToProfile: 'Save birth year to profile',
    birthYearSolo: 'Birth year',
    zodiacAuto: 'Your zodiac',
    tabDay: 'Day',
    tabWeek: 'Week',
    tabMonth: 'Month',
    birthMd: 'Birthday (month & day)',
    signIs: 'Sign',
    loading: 'Loading…',
    luckColor: "This month's lucky color",
    luckNum: 'Lucky number',
    shareCta: 'Share my reading',
    shareOk: 'Shared!',
    shareCopy: 'Copied to clipboard',
    sharing: 'Sharing…',
    dreamMin: 'Please enter a bit more (5+ characters).',
    nameLen: 'Name must be 2–6 Korean characters.',
    nameKoOnly: 'Korean characters only.',
    compatScore: 'Match score (reference)',
    tapToFlip: 'Tap to flip',
    tarotSummary: 'Overall: your path is connecting the three moments—learn from the past, own the present, shape what comes next.',
    ad: {
      lead: 'Watch a short ad to use this for free 😊',
      skip: 'Skip',
      continue: 'Continue',
      placeholder: 'Sponsored area',
      brandLine: 'Mingo',
      adInquiry: 'Ad inquiries: support@mingo.app',
    },
    m: {
      today: "Today's fortune",
      horoscope: 'Horoscope',
      zodiac: 'Chinese zodiac',
      astrology: 'Astrology',
      tarot1: 'Tarot (1 card)',
      year: '2026 / New Year',
      saju: 'Saju (four pillars)',
      tojeong: 'Tojeong',
      tarot3: 'Tarot (3 cards · past / present / future)',
      compat: 'Compatibility',
      dream: 'Dream reading',
      name: 'Name meaning',
    },
    cat: { luck: 'Overall', wealth: 'Wealth', health: 'Health', love: 'Love' },
    legalFooter:
      'This content is for entertainment and reference only — not professional advice. For important decisions, consult a qualified professional.',
    aiPreamble1: 'AI-generated entertainment. Not a real fortune-telling or medical/legal reading.',
    aiPreamble2: 'Results may differ from real life or your expectations.',
  },
  cookie: {
    title: 'Cookie & local storage',
    body: 'We use necessary storage to run the app (e.g. login, language). Optional analytics and marketing can be off.',
    gdpr: 'We aim to support GDPR rights (access, correction, erasure) — see our Privacy policy.',
    essential: 'Required (app to work)',
    analytics: 'Analytics (improve the product)',
    marketing: 'Marketing (offers, optional)',
    rejectNonEssential: 'Reject non-essential',
    saveSelection: 'Save choices',
    acceptAll: 'Accept all',
    privacyLink: 'Privacy policy',
  },
  ads: { badge: 'Ad', paidNotice: 'This listing is a paid advertisement' },
  scamAlert: {
    regionLabel: 'Scam and safety alerts',
    badge: 'Warning',
    dismissToday: 'Hide for today',
    detail: 'Learn more',
    carousel: 'More alerts',
  },
  scamBanner: {
    trade:
      'Trade safely. Upfront transfers, moving to outside messengers, or prices far below market may be scams. Meet in person when you can.',
    finance:
      'Beware of transfer scams. Be suspicious of unusually good rates or "send first" requests. Use only verified businesses and official channels.',
  },
  report: {
    title: 'Report',
    type: 'Report type',
    content: 'Details',
    placeholder: 'Please describe what happened (min. 3 characters).',
    submit: 'Submit report',
    sending: 'Sending…',
    done: 'Report received. Thank you.',
    failed: 'Could not send the report.',
    needContent: 'Please enter a short description.',
    types: {
      false_info: 'False or misleading information',
      fraud: 'Fraud / scam',
      illegal: 'Illegal content',
      spam: 'Spam',
      other: 'Other',
      scam: 'Scam / fraud',
      fake: 'Fake listing',
      abuse: 'Harassment / abuse',
    },
    adminQueue: 'Reports are queued for review. Listings with multiple reports may be auto-hidden.',
    duplicate: 'You already reported this item.',
  },
  visaSettings: {
    title: 'Visa expiry',
    kind: 'Visa type',
    expire: 'Expiry date',
    saving: 'Saving…',
    saved: 'Saved.',
    failed: 'Could not save.',
    needDate: 'Please choose an expiry date.',
    kinds: {
      tourist: 'Tourist',
      resident: 'Resident',
      work: 'Work',
      student: 'Student',
      other: 'Other',
    },
  },
  visaAlert: {
    banner30: 'Your visa expires in 30 days or less. Check renewal steps.',
    banner7: 'Your visa expires in 7 days or less. Take action soon.',
    bannerExpired: 'Your saved visa date has passed. Please update your information.',
    urgentTitle: 'Visa expiring very soon',
    urgentBody: 'Your visa expires tomorrow or today. Please confirm status and renewal options.',
    goVisa: 'Open visa guide',
    dismissToday: 'Hide for today',
  },
  visaInfo: {
    pageTitle: 'Visa & admin',
    myVisa: 'My saved visa',
    noDate: 'Not set',
    officialTitle: 'Official references',
    links: {
      immigrationVn: 'Vietnam Immigration (reference)',
      mofaKr: 'Korea MOFA (reference)',
    },
    blocks: {
      tourist: {
        title: 'Tourist visa',
        body: 'Typical short stays; extension rules vary by country of passport. Avoid unofficial brokers and keep copies of entry stamps.',
      },
      resident: {
        title: 'Resident / long stay',
        body: 'Often tied to work, family, or investment. Renewal usually requires valid address registration and supporting documents.',
      },
      work: {
        title: 'Work permit / employment visa',
        body: 'Employer sponsorship is usually required. Verify contract, permit category, and tax obligations before signing.',
      },
      student: {
        title: 'Student visa',
        body: 'Maintain enrollment proof and valid school letters. Inform the school if you change address or program length.',
      },
      other: {
        title: 'Other categories',
        body: 'Rules change frequently. Confirm with the issuing embassy or official immigration portal for your case.',
      },
    },
    guidesTitle: 'Visa guides (database)',
    guidesCountry: 'Country',
    guidesEmpty: 'No guides yet. Apply the latest migration.',
    guidesReq: 'Requirements',
    guidesRenew: 'Renewal',
    guidesLink: 'Official link',
    durationLabel: 'Duration',
    countryVN: 'Vietnam',
    countryTH: 'Thailand',
    countryKR: 'Korea',
    filterAll: 'All',
    notifyExpiry: 'Visa expiry reminders',
    ddayDays: '{n} days',
    officialDisclaimer: 'Note: always check the official site for the latest notices.',
  },
  emergencySafety: {
    barAria: 'Emergency & safety',
    barTitle: '🆘 Emergency & safety',
    alertBarAria: 'Safety alert',
    more: 'More',
    viewContacts: 'View emergency contacts',
    callFirst: 'In an emergency, call first. The app is a secondary guide.',
    trustLine: 'Operator-verified info · not AI-generated',
    sosCall: '📞 Emergency call',
    moreAlerts: '{count} more ›',
    alertModalTitle: 'Safety alerts',
    alertDetailLink: 'Learn more',
    alertTypeScam: 'Scam alert',
    alertTypeDisaster: 'Disaster / weather',
    alertTypeHealth: 'Health',
    alertTypeCivil: 'Civil defense',
  },
  emergencyContacts: {
    title: 'Emergency contacts',
    intro: '',
    regionHint: 'Selected areas: {cities} · Host country: {country}',
    regionUnset: 'None (defaults to Vietnam)',
    tabEmergency: 'Emergency',
    tabLocal: 'My area',
    tabEmbassy: 'Embassy',
    tabHospital: 'Hospital',
    tabCommunity: 'Korean community',
    tabCommon: 'Common',
    sectionLocal: '{country} emergency',
    sectionEmbassy: 'Embassies & consulates ({country})',
    sectionHospital: '{country} hospitals & ER',
    sectionCommunity: 'Korean associations',
    sectionCommon: 'Everyone (KR)',
    embassyMissing: 'No ROK embassy/consulate list for this country yet. Check MOFA Safe Travel.',
    communityNote: '',
    rolePolice: 'Police',
    roleFire: 'Fire',
    roleAmbulance: 'Ambulance',
    roleFireAmbulance: 'Fire & ambulance (combined)',
    embassyKrHanoi: 'Embassy of the ROK in Vietnam (Hanoi)',
    embassyKrHcmc: 'Embassy of the ROK in Vietnam (Ho Chi Minh City)',
    embassyKrDanang: 'ROK Consulate General in Da Nang',
    embassyKrBangkok: 'Embassy of the ROK in Thailand (Bangkok)',
    embassyKrTokyo: 'Embassy of the ROK in Japan (Tokyo)',
    embassyKrOsaka: 'ROK Consulate General in Osaka',
    communityDanang: 'Da Nang Korean community',
    communityHcmc: 'Ho Chi Minh Korean community',
    communityBangkok: 'Bangkok Korean community',
    communitySeoul: 'Seoul expat circle',
    commonKoreanOnly: 'Common resources for Korean nationals.',
    commonMofaTitle: 'MOFA Safe Travel (domestic hotline)',
    commonMofaOverseasTitle: 'Overseas emergency (to Korea)',
    commonWiseTitle: 'Wise urgent support',
    commonWiseBody: 'Use in-app or website customer support.',
    commonInsuranceTitle: 'Travel insurance emergency',
    commonInsuranceBody: 'Use the hotline shown on your policy or insurer app; numbers vary by provider.',
    empty: 'No verified contacts listed.',
  },
  groupBuy: {
    title: 'Group buy',
    register: 'Start a group buy',
    tabRecruiting: 'Recruiting',
    tabOngoing: 'Ongoing',
    tabCompleted: 'Done',
    people: '{cur} / {target} people',
    perPerson: 'Per person',
    deadline: 'Deadline',
    join: 'Join',
    joined: 'You joined.',
    joinFail: 'Could not join.',
    full: 'This group is full.',
    completed: 'Closed',
  },
  groupBuyWrite: {
    title: 'Create group buy',
    productName: 'Product name',
    desc: 'Description',
    price: 'Price per person (number)',
    target: 'Target headcount',
    deadline: 'Deadline',
    delivery: 'Delivery method',
    contact: 'Organizer contact',
    photo: 'Photo',
    pickPhoto: 'Choose photo',
    needFields: 'Please fill required fields.',
    fail: 'Could not publish.',
  },
  talent: {
    hubTitle: 'Looking for a professional?',
    hubDesc: 'Find experts in interior, repair,\nIT, photo, translation and more',
    orBrowseAll: 'Or browse all',
    registerDesc: 'Want to register as a professional?',
    registerLink: 'View Talent Market',
    searchPlaceholder: 'Search services or specialties',
    sortRating: 'Top Rated',
    sortOrders: 'Most Orders',
    sortNewest: 'Newest',
    sortPrice: 'Price',
    registerBtn: 'Register as Expert',
    notFound: 'Service not found',
    reviews: 'reviews',
    orders: 'orders',
    priceFixed: 'Fixed Price',
    pricePerHour: 'Per Hour',
    deliveryIn: 'Delivery in {n} days',
    serviceInfo: 'Service Info',
    deliveryDays: 'Delivery',
    days: ' days',
    revisions: 'Revisions',
    times: 'x',
    noRevision: 'No revision',
    responseTime: 'Response Time',
    about: 'About',
    portfolio: 'Portfolio',
    inquirySent: 'Starting inquiry chat',
    inquiryBtn: 'Contact',
    registerTitle: 'Register as Expert',
    stepCategory: 'What service do you offer?',
    stepService: 'Service Details',
    serviceTitle: 'Service Title',
    serviceTitlePlaceholder: 'e.g. Korean↔Vietnamese Professional Translation',
    serviceDesc: 'Service Description',
    serviceDescPlaceholder: 'Describe your service, experience, and strengths',
    tags: 'Tags',
    tagsPlaceholder: 'e.g. translation, document, contract (comma separated)',
    languages: 'Languages',
    stepPricing: 'Pricing & Delivery',
    priceType: 'Price Type',
    price: 'Price',
    stepContact: 'Contact & Confirm',
    contactKakao: 'KakaoTalk',
    contactPhone: 'Phone',
    registerSuccess: 'Expert registration completed',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Register',
  },
  golf: {
    title: 'Golf & Membership',
    tabMarket: '🎫 Membership Market',
    tabMembership: 'Memberships',
    tabBuddy: 'Find Buddy',
    tabClub: 'Clubs',
    typeAll: 'All',
    typeGolf: 'Golf',
    typeResort: 'Resort',
    typeSpa: 'Spa',
    typeFitness: 'Fitness',
    typeTennis: 'Tennis',
    typeOther: 'Other',
    exclusive: 'Mingo Exclusive',
    verified: 'Verified',
    inquiryOnly: 'Inquiry to Book',
    emptyMembership: 'No memberships available',
    emptyRound: 'No rounds available',
    emptyClub: 'No clubs available',
    postRound: 'Post Round',
    createClub: 'Create Club',
    clubCreateNeedVerified: 'You need a verified named facility membership to create a golf club.',
    clubCreateCta: 'Add or verify membership',
    spotsLeft: 'Spots left',
    joinRound: 'Join Round',
    joinSuccess: 'Successfully joined',
    alreadyJoined: 'Already joined',
    roundFull: 'Full',
    roundDetail: 'Round Detail',
    notFound: 'Not found',
    courseInfo: 'Course Info',
    holes: 'Holes',
    caddie: 'Caddie',
    cart: 'Cart',
    teeTime: 'Tee Time',
    amenities: 'Amenities',
    description: 'About',
    bookingTitle: 'Book Now',
    selectDate: 'Select Date',
    selectSlot: 'Select Tee Time',
    slotsLeft: 'left',
    participants: 'Participants',
    notes: 'Notes',
    notesPlaceholder: 'Enter special requests',
    stage1Notice: 'Currently inquiry only. Chat for details',
    submitInquiry: 'Send Inquiry',
    submitBooking: 'Book Now',
    chatInquiry: 'Chat',
    chatContact: 'Chat',
    bookingSuccess: 'Inquiry received. We will contact you via chat',
    bookingFail: 'Failed to send inquiry',
    website: 'Website',
    skillAll: 'All Levels',
    skillBeginner: 'Beginner',
    skillIntermediate: 'Intermediate',
    skillAdvanced: 'Advanced',
    skillBand: 'Skill level',
    feeTypeLabels: {
      free: 'Free',
      dutch: 'Dutch',
      fixed: 'Fixed Fee',
    },
    date: 'Date',
    feeCost: 'Fee',
    feeIncludes: 'Includes',
    included: 'Included',
    notIncluded: 'Not included',
    clubDetail: 'Club',
    joinClub: 'Join Club',
    joinClubGradeBlocked: 'Grade requirement not met',
    joinGradeLabel: 'Minimum join grade',
    joinGradeAny: 'General or above',
    joinGradeUnnamedPlus: 'Unnamed membership or above',
    joinGradeNamedVerifiedPlus: 'Named verified membership only',
    joinGradeRequired: 'This club requires {grade}.',
    joinClubSuccess: 'You joined the club',
    clubWriteTitle: 'Create Club',
    clubName: 'Club name',
    clubDesc: 'Description',
    clubRegularDay: 'Regular schedule',
    roundWriteTitle: 'Post Round',
    roundTitle: 'Title',
    roundCourse: 'Golf course',
    roundDate: 'Round date',
    roundMax: 'Max players',
    roundFee: 'Fee per person',
    marketBannerTitle: 'Buy & Sell Memberships',
    marketBannerDesc: 'Direct trade of golf, resort & sports memberships',
    marketWrite: 'List My Membership',
    marketNotice: 'This is a direct peer-to-peer marketplace. Mingo is not responsible for transactions. Always verify before trading.',
    marketEmpty: 'No memberships listed',
    marketWriteFirst: 'Be the first to list',
    marketWriteTitle: 'List Membership',
    marketStepType: 'What type of membership?',
    marketStepBasic: 'Basic Information',
    marketStepPrice: 'Price & Contact',
    marketStepLegal: 'Legal Notice & Confirm',
    marketTitle: 'Title',
    marketTitlePlaceholder: 'e.g. Bana Hills unnamed membership for sale',
    marketDesc: 'Description',
    marketDescPlaceholder: 'Describe the membership condition, benefits, and details',
    marketPrice: 'Asking Price',
    marketExpires: 'Expiry Date',
    marketInfo: 'Membership Info',
    marketLegalTitle: 'Trading Notice',
    marketLegal1: 'This platform provides a peer-to-peer listing board only and does not broker transactions.',
    marketLegal2: 'Always verify membership authenticity directly with the golf course or resort.',
    marketLegal3: 'Named memberships may require golf course approval for transfer.',
    marketLegal4: 'Always meet in person and verify documents before trading. Advance payment requests may be fraud.',
    marketLegal5: 'Mingo bears no legal responsibility for losses or fraud arising from transactions.',
    marketLegalAgree: 'I have read and agree to all of the above notices',
    marketLegalNotice: 'Direct peer-to-peer trade. Mingo is not responsible for transactions.',
    marketDetailTitle: 'Membership Detail',
    marketStatusManage: 'Update Status',
    marketStatusUpdated: 'Status updated',
    marketStatus: {
      active: 'Active',
      reserved: 'Reserved',
      sold: 'Sold',
      cancelled: 'Cancelled',
    },
    marketWriteSuccess: 'Membership listed successfully',
    marketWriteFail: 'Failed to list',
    namedBadge: 'Named',
    unnamedBadge: 'Unnamed',
    transferPossible: 'Transferable',
    negotiable: 'Negotiable',
    membershipTypeLabel: 'Membership Type',
    facilityName: 'Facility Name',
    facilityNamePlaceholder: 'e.g. Bana Hills Golf Club',
    facilityRules: 'Transfer Rules',
    facilityRulesPlaceholder: 'Enter the facility transfer policy',
    contactKakao: 'KakaoTalk',
    contactKakaoPlaceholder: 'KakaoTalk open chat ID',
    contactPhone: 'Call',
    region: 'Region',
    saveFail: 'Could not save',
  },
  membership: {
    sectionTitle: 'My Memberships',
    sectionDesc: 'Register named/unnamed memberships to unlock trust badges and extra benefits. You can still create regular meetups in Community without memberships.',
    add: 'Add Membership',
    formTitle: 'Register Membership',
    type: 'Type',
    typeGolf: 'Golf',
    typeResort: 'Resort',
    typeSpa: 'Spa',
    typeFitness: 'Fitness',
    typeTennis: 'Tennis',
    typeOther: 'Other',
    facilityName: 'Facility Name',
    facilityPlaceholder: 'e.g. Bana Hills Golf Club',
    namedType: 'Membership Type',
    named: 'Named',
    unnamed: 'Unnamed',
    memberNumber: 'Member Number (optional)',
    memberNumberPlaceholder: 'Number on membership card',
    expiresAt: 'Expiry Date',
    cardImage: 'Membership Card Photo',
    cardImageHint: 'Upload card photo to request verification',
    notes: 'Notes',
    notesPlaceholder: 'Additional info',
    save: 'Save',
    verified: 'Verified',
    pendingVerify: 'Pending',
    expires: 'Expires',
    verifyNotice: 'Mingo admin will verify your membership card',
    addSuccess: 'Membership registered',
    addFail: 'Failed to register',
    deleteSuccess: 'Membership removed',
  },
  contract: {
    title: 'Contract',
    defaultTitle: 'Mingo Partnership Contract',
    parties: 'Parties',
    subject: 'Subject',
    commissionRate: 'Commission Rate',
    period: 'Period',
    terms: 'Terms',
    signatures: 'Signatures',
    notSigned: 'Not signed',
    agreeLabel: 'I have read and agree to the contract',
    agreeFirst: 'Please check the agreement first',
    sign: 'Sign',
    signSuccess: 'Signed successfully',
    signFail: 'Failed to sign',
    alreadySigned: 'Already signed',
    notFound: 'Contract not found',
    status: {
      draft: 'Draft',
      sent: 'Sent',
      signed: 'Signed',
      expired: 'Expired',
      cancelled: 'Cancelled',
    },
  },
  visaRun: {
    title: 'Visa Run',
    modeSelect: 'Select Type',
    modePersonal: 'Personal',
    modePersonalDesc: 'Free community gathering, no fees',
    modeBusiness: 'Official',
    modeBusinessDesc: 'Travel agency or rental official product',
    filterAll: 'All',
    transportAll: 'All',
    transportType: 'Transport',
    transportBus: 'Bus',
    transportVan: 'Van',
    transportCar: 'Private Car',
    transportTrain: 'Train',
    transportFlight: 'Flight',
    transportMixed: 'Mixed',
    transportDetail: 'Transport Details',
    transportDetailPlaceholder: 'e.g. VIP bus, AC van, etc.',
    borderCrossing: 'Border Crossing',
    borderCrossingPlaceholder: 'e.g. Moc Bai, Lam Lam, Kaew',
    visaType: 'Visa Type',
    visaTourist: 'Tourist Visa',
    visaEVisa: 'E-Visa',
    visaExempt: 'Visa Exempt',
    visaOther: 'Other',
    emptyFilter: 'No listings for this type',
    bookingUrl: 'Booking URL',
    bookingUrlPlaceholder: 'Official booking page URL',
    officialBooking: 'Official Booking',
    chatInquiry: 'Inquire',
    chatContact: 'Chat',
    personalNotice: 'Personal gathering. Contact directly via chat or click join',
    joinUseOfficial: 'Please use the official booking link on the detail page',
    write: 'Post',
    writeTitle: 'Create Visa Run',
    detailTitle: 'Visa Run Detail',
    bannerText: 'Travel together before your visa expires! Cheaper than solo',
    tabRecruiting: 'Recruiting',
    tabFull: 'Full',
    tabCompleted: 'Completed',
    empty: 'No visa runs available',
    writeFirst: 'Be the first to post',
    join: 'Join',
    joinSuccess: 'Successfully joined',
    joinFail: 'Failed to join',
    alreadyJoined: 'Already joined',
    statusFull: 'Full',
    statusCompleted: 'Completed',
    spotsLeft: 'Spots left',
    notFound: 'Visa run not found',
    destination: 'Destination',
    departCity: 'Departure City',
    formTitle: 'Title',
    titlePlaceholder: 'e.g. Da Nang → Cambodia Visa Run',
    departDate: 'Departure',
    returnDate: 'Return',
    price: 'Price per person',
    maxParticipants: 'Max participants',
    currency: 'Currency',
    includes: 'Includes',
    includesPlaceholder: 'e.g. Flights, Hotel (comma separated)',
    excludes: 'Excludes',
    excludesPlaceholder: 'e.g. Visa fee, Meals (comma separated)',
    meetingPoint: 'Meeting Point',
    meetingPointPlaceholder: 'e.g. Da Nang Airport Terminal 3, 6AM',
    description: 'Description',
    descPlaceholder: 'Describe the itinerary, notes, etc.',
    contact: 'Contact',
    contactPlaceholder: 'KakaoTalk ID or phone number',
    submit: 'Post Visa Run',
    writeSuccess: 'Visa run posted successfully',
    writeFail: 'Failed to post',
    city: {
      danang: 'Da Nang',
      hcmc: 'Ho Chi Minh',
      hanoi: 'Hanoi',
    },
  },
  transfer: {
    title: 'Business Transfer',
    write: 'List',
    writeTitle: 'List Business Transfer',
    detailTitle: 'Transfer Detail',
    bannerText: 'Find businesses for transfer. Direct deal, no commission',
    empty: 'No listings available',
    writeFirst: 'Be the first to list',
    notFound: 'Listing not found',
    typeAll: 'All',
    typeStore: 'Store',
    typeRestaurant: 'Restaurant',
    typeCafe: 'Cafe',
    typeOffice: 'Office',
    typeHouse: 'House',
    typeOther: 'Other',
    premium: 'Premium',
    monthlyRent: 'Monthly Rent',
    perMonth: 'mo',
    negotiable: 'Negotiable',
    remainingLease: 'Remaining lease',
    months: ' mo',
    regionSection: 'Region',
    currency: 'Currency',
    formTitle: 'Title',
    titlePlaceholder: 'e.g. Cafe premium transfer near My Khe',
    region: {
      all: 'All',
      danang: 'Da Nang',
      hcmc: 'Ho Chi Minh',
      hanoi: 'Hanoi',
    },
    address: 'Address',
    addressPlaceholder: 'e.g. Near My Khe Beach, Da Nang',
    sizeSqm: 'Size (㎡)',
    reason: 'Transfer reason',
    reasonReturn: 'Returning home',
    reasonBusiness: 'Business closure',
    reasonPersonal: 'Personal reasons',
    reasonOther: 'Other',
    includes: 'Includes',
    includesPlaceholder: 'e.g. Interior, kitchen equipment (comma separated)',
    description: 'Description',
    descPlaceholder: 'Describe current business status, revenue, features...',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk ID',
    kakaoPlaceholder: 'KakaoTalk open chat ID',
    stepType: 'What type of business?',
    stepBasic: 'Pricing',
    stepLocation: 'Location & size',
    stepDetail: 'Details',
    stepContact: 'Contact & confirm',
    stepConfirm: 'Summary',
    submit: 'List Now',
    writeSuccess: 'Listing posted successfully',
    writeFail: 'Failed to post',
    statusUpdated: 'Status updated',
    statusManage: 'Manage status',
    status: {
      active: 'Active',
      negotiating: 'Negotiating',
      done: 'Done',
      cancelled: 'Cancelled',
    },
    kakaoContact: 'KakaoTalk',
    phoneContact: 'Call',
    chatContact: 'Chat',
    legalNotice: 'This platform does not act as a broker. Please verify directly before any transaction.',
  },
  events: {
    title: 'Mingo Events',
    participate: 'Join',
    completed: 'Completed',
    alreadyCompleted: 'You already joined this event.',
    empty: 'No active events right now',
    myMingo: 'My Mingo',
    dDay: 'D-{n}',
    register: 'Create event',
    feeFree: 'Free entry',
    feePaid: 'Fee {amount} {cur}',
    participants: '{cur} / max {max}',
    join: 'RSVP',
    joined: "You're on the list.",
    joinFail: 'Could not RSVP.',
    full: 'This event is full.',
    ticketsTitle: 'Tickets',
    ticketRemaining: '{n} / {max} left',
    ticketBuySoon: 'Buy tickets (coming soon)',
    ticketStandard: 'General admission',
    ticketVip: 'VIP seating',
    ticketTrail: 'Trail pass',
    ticketSnackPack: 'Snack pack add-on',
    rewardGranted: '🎉 {amount} credited!',
  },
  eventsWrite: {
    title: 'Create event',
    name: 'Title',
    datetime: 'Date & time',
    place: 'Location',
    fee: 'Fee (0 = free)',
    max: 'Max participants',
    body: 'Details',
    photo: 'Photo',
    needFields: 'Please fill required fields.',
    fail: 'Could not publish.',
  },
  langEx: {
    title: 'Language exchange',
    intro: 'Share your native language and what you want to learn.',
    cards: 'Profiles',
    partner: 'Member',
    native: 'Native',
    learning: 'Learning',
    level: 'Level',
    times: 'Availability',
    timesPh: 'e.g. weekday evenings',
    mode: 'Mode',
    bio: 'Bio',
    register: 'Register / update my profile',
    save: 'Save',
    needLang: 'Please enter native and target languages.',
    fail: 'Could not save.',
    levelBeginner: 'Beginner',
    levelMid: 'Intermediate',
    levelAdv: 'Advanced',
    methodOnline: 'Online',
    methodOffline: 'Offline',
    methodBoth: 'Both',
  },
  chat: {
    newChat: '+ New Chat',
    title: 'Chats',
    inputPlaceholder: 'Type a message',
    send: 'Send',
    sendPhoto: 'Send photo',
    completeTrade: 'Complete sale',
    writeReview: 'Write review',
    leaveChat: 'Leave chat',
    noMessages: 'No messages',
    blocked: 'This user is blocked',
    loadingList: 'Loading conversations…',
    empty: 'No chats yet. Start from a listing.',
    noMessagesYet: 'No messages yet',
    unread: '{n} unread',
    loginToSee: 'Log in to see your chats.',
    emptyTitle: 'No chats yet',
    emptyDesc: 'Start a conversation with fellow expats',
    emptyDescBiz: 'Tap Inquire on a business listing to start a chat.',
    selectRoom: 'Select a chat',
    expandPopup: 'Expand',
    messageDeleted: 'Message deleted',
    defaultRoom: 'Chat',
    defaultGroup: 'Group',
    loadListFailed: 'Could not load chat list.',
    tabs: {
      chat: 'Chat',
      group: 'Groups',
      business: 'Trade',
      dm: 'DM',
    },
    tradeProduct: 'Marketplace chat',
    businessInquiry: 'Business inquiry',
    unknownUser: 'Unknown user',
    promoTitle: 'Explore these services',
    promoInvite: 'Invite friends',
    promoInviteDesc: 'Invite friends and get rewards',
    promoTheme: 'Appearance',
    promoThemeDesc: 'Customize chat theme',
    promoSafety: 'Safety tips',
    promoSafetyDesc: 'Safe trading conversation guide',
    promoGuide: 'Quick guide',
    promoGuideDesc: 'Quick guide to using chat',
    time: { justNow: 'Just now', daysAgo: '{n}d ago' },
    productStatus: {
      used: 'Used',
      rent: 'Rent',
      job: 'Jobs',
      free: 'Free',
      electronics: 'Electronics',
      furniture: 'Furniture',
      fashion: 'Fashion',
      food: 'Food & Drink',
      sports: 'Sports',
      books: 'Books',
      vehicle: 'Vehicle',
      kids: 'Kids',
      beauty: 'Beauty',
      household: 'Household',
      pets: 'Pets',
      tickets: 'Tickets',
      etc: 'Other',
      car: 'Used car',
      real_estate: 'Real estate',
      property: 'Real estate',
    },
    productSold: 'Sold',
    tradeComplete: 'Mark deal complete',
    tradeConfirmTitle: 'Mark this deal complete?',
    tradeConfirmBody: 'The listing will show as sold and you can leave a review for the other person.',
    tradeConfirmOk: 'Yes, continue',
    tradeDone: 'Deal marked complete.',
    tradeNeedDb: 'Complete deal is only available for server-linked listings.',
    day: { today: 'Today', yesterday: 'Yesterday' },
    room: {
      more: 'More',
      productFallback: 'Listing',
      inputPlaceholder: 'Message',
      send: 'Send',
      addImage: 'Photo',
      addEmoji: 'Emoji',
      sending: 'Sending…',
      loadError: 'Could not open this chat.',
      demoNotice: 'Demo chat — messages are not saved to the server.',
      loading: 'Loading…',
      sendFailed: 'Could not send. Try again.',
      showAdTypesAction: 'See ad types',
      noOriginalMessage: 'Original message unavailable',
      photoLabel: 'Photo',
      adPreviewLabel: 'Ad preview',
      messageFallback: 'Message',
      meLabel: 'Me',
      otherLabel: 'The other person',
      deletedMessageReply: 'Reply to deleted message',
      replyTo: 'Reply to {author}',
      needProfile: 'Please finish signing in to use chat.',
      imageOnly: '[Photo]',
      back: 'Back',
      notifications: 'Notifications',
      emptyConversation: 'Start the conversation.',
      loadFailed: 'Could not load the chat.',
      propertyFallback: 'Listing',
      systemMessage: 'System message',
      fastResponse: 'Fast reply',
      bookingLabel: 'Booking',
      guestsCount: '{n} guests',
      quotationTitle: 'Quotation',
      totalLabel: 'Total',
      acceptQuote: 'Accept quote',
      acceptQuoteSoon: 'Quote acceptance is coming soon.',
      savedMessagesTitle: 'Message to myself',
      productLoadFailed: 'Could not load the product. Please check it from the product page.',
      productNotPublished: 'This product is not published yet.',
      bookingInfoLoadFailed: 'Could not load booking info',
      bookingRequestAccepted: 'Your booking request was received. Please wait for the business to confirm.',
      bookingSummaryAdults: '[Booking request] {title} · {date} · {adults} adult(s)',
      bookingSummaryChildrenSuffix: ', {children} child(ren)',
      bookingRequestMessageSent: 'Booking request sent. The business will confirm it in this chat.',
      bookingRequestFailed: 'Could not send booking request',
      bookingConfirmedToast: 'Booking confirmed.',
      bookingConfirmFailed: 'Could not confirm booking',
      bookingRejectedToast: 'Booking rejected.',
      bookingRejectFailed: 'Could not reject booking',
      quotedMessageDeleted: 'This message was deleted.',
      imageLinkCopied: 'Image link copied.',
      shareFailed: 'Could not share.',
      roomListLoadFailed: 'Could not load your chat rooms.',
      noMessageToForward: 'No message to forward.',
      forwardedToRoom: 'Forwarded to another chat.',
      forwardFailed: 'Could not forward.',
      messageCopied: 'Message copied.',
      copyFailed: 'Could not copy.',
      shareUnsupportedType: 'This message type cannot be shared.',
      shareTextCopied: 'Copied text for sharing.',
      deleteMessageConfirm: 'Delete this message?',
      messageDeletedSuccessToast: 'Message deleted.',
      deleteFailed: 'Could not delete.',
      reportReasonPrompt: 'Enter a report reason (fraud/spam/abuse/other)',
      reportNotePrompt: 'Briefly describe the report.',
      reportSubmitted: 'Report submitted.',
      reportDuplicate: 'You already reported this message.',
      reportFailed: 'Could not submit report.',
      reactionListLoadFailed: 'Could not load reactions.',
      reactionFailed: 'Could not react.',
      viewReactionUsersAria: 'View who reacted',
      forwardAction: 'Forward',
      forwardModalTitle: 'Forward to a chat',
      noForwardableRooms: 'No chats available to forward to.',
      forwardToSelfFailed: 'Could not forward to yourself.',
      sendToMeLabel: 'To myself',
      reactionsTitle: '{emoji} reactions',
      noReactionUsers: 'No one has reacted yet.',
      booking: {
        requested: 'Booking request',
        confirmed: 'Booking confirmed',
        rejected: 'Booking rejected',
        statusRequest: 'Request',
        statusConfirmed: 'Confirmed',
        statusRejected: 'Rejected',
        comboComponentsLabel: 'Included services',
      },
    },
    translate: 'Translate',
    translating: 'Translating…',
    translateFailed: 'Could not translate',
    groupChat: 'Group chat',
    emojiSearchPlaceholder: 'Search emoji',
    emojiCategory: {
      recent: 'Recently used',
      smileys: 'Smileys',
      animals: 'Animals & nature',
      food: 'Food',
      travel: 'Travel & places',
      activities: 'Activities',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags',
    },
  },
  friends: {
    hubTitle: 'Friends',
    findTitle: 'Find friends',
    findAdd: '+ Friend',
    addFriend: 'Add friend',
    hubMenu: 'Friends menu',
    suggestedTitle: 'Suggestions',
    suggestedHint: 'Priority: same city > shared interests > mutual follows > recent activity.',
    suggestedReason: {
      same_city: 'Same city',
      shared_interest: 'Shared interests',
      mutual_friend: 'Mutual follows overlap',
      recent_activity: 'Recently active user',
    },
    suggestedEmpty: 'No recommendations yet',
    suggestedLoadMore: 'Load more',
    dismissSuggestion: 'Not interested',
    shareProfile: 'Share profile',
    shareAction: 'Share profile',
    copyLink: 'Copy link',
    downloadQr: 'Download',
    shareCopied: 'Profile link copied',
    menuAccountSettings: 'Edit profile',
    hubStatsAria: 'My activity stats',
    statsExplainer: 'Friends: mutually connected · Followers: people who follow you · Following: people you follow',
    hubStats: {
      posts: 'Posts',
      friends: 'Friends',
      followers: 'Followers',
      following: 'Following',
    },
    contentTabStories: 'Mingo Stories',
    contentTabReplies: 'Replies',
    contentTabsAria: 'Posts, replies, and Mingo Stories tabs',
    businessOwnerBadge: '{name} business owner',
    gridEmptyStories: 'No Mingo Stories yet',
    gridEmptyReplies: 'No replies yet',
    replyOnOwnPost: 'On my post',
    mingosSection: 'Close Friends',
    regularFriendsSection: 'Friends',
    friendsViewHint: 'Split into close friends and regular friends',
    emptyMingos: 'No close friends yet · set from the ⋮ menu',
    emptyRegularFriends: 'No regular friends',
    mingoBadge: 'Close Friend',
    findClose: 'Close',
    tabs: {
      friends: 'Friends',
      pending: 'Pending',
      find: 'Find',
    },
    pendingReceived: 'Received',
    pendingSent: 'Sent',
    followers: 'Followers',
    following: 'Following',
    mutualFollow: 'Mutual',
    followListEmpty: 'No one here yet',
    emptyFriends: 'No friends yet',
    emptyPending: 'No pending requests',
    loading: 'Loading…',
    loadError: 'Could not load the list. Please try again.',
    searchPlaceholder: 'Search nickname (2+ chars)',
    searching: 'Searching…',
    kakaoFindBtn: 'Find Mingo friends from Kakao',
    kakaoFindLoading: 'Finding…',
    kakaoFindEmpty: 'None of your Kakao friends use Mingo yet.',
    kakaoFindConsentRequired: "Kakao friend-list permission isn't approved yet. This will work automatically once it is.",
    kakaoFindNoToken: 'Please log in with Kakao again to use this.',
    kakaoFindError: 'Could not load your Kakao friends. Please try again in a moment.',
    emptyQuery: 'Enter a nickname to search',
    noResults: 'No users found',
    searchError: 'Search failed. Please try again in a moment.',
    statusFriend: 'Friends',
    statusRequest: 'Add friend',
    statusRequested: 'Requested',
    statusAccept: 'Accept',
    statusDecline: 'Decline',
    statusCancel: 'Cancel',
    requestSent: 'Friend request sent',
    requestAccepted: 'You are now friends',
    requestAcceptedHint: 'You can chat in the Chat tab now',
    requestDeclined: 'Request declined',
    requestCancelled: 'Request cancelled',
    autoFriendMade: 'You became friends through mutual follow!',
    settings: {
      title: 'Friend settings',
      sectionFriends: 'Friends',
      autoFriendOnMutualFollow: 'Auto-add friends on mutual follow',
      autoFriendOnMutualFollowDesc:
        'When on, mutual follows become friends. When off, only follows apply and you add friends manually. Does not change existing relationships.',
    },
    menu: {
      chat: 'Chat',
      hide: 'Hide',
      block: 'Block',
      remove: 'Remove friend',
      hidden: 'Friend hidden',
      blockConfirm: 'Block {name}? You will no longer see their chats or posts.',
      blockedDone: 'Friend blocked',
      removeConfirm: 'Remove {name} from your friends?',
      removedDone: 'Friend removed',
      unhide: 'Unhide',
      unhideDone: 'Friend unhidden',
      manageHidden: 'Hidden friends',
      manageBlocked: 'Blocked friends',
      friendSettings: 'Friend settings',
      searchByHandle: 'Search by nickname/handle',
      backToFriends: 'Friends',
      hiddenTitle: 'Hidden friends',
      hiddenEmpty: 'No hidden friends',
      setMingo: 'Mark as Close Friend',
      unsetMingo: 'Remove Close Friend',
      setMingoDone: 'Marked as Close Friend',
      unsetMingoDone: 'Close Friend mark removed',
    },
    errors: {
      self: 'You cannot send a request to yourself',
      blocked: 'You cannot send a request to this user',
      notFound: 'User not found',
    },
  },
  story: {
    visibility: {
      label: 'Visibility',
      public: 'Public',
      friends: 'Friends only',
      mingoFriends: 'Close friends only',
      private: 'Only me',
    },
    revenueTitle: 'Story Revenue',
    totalRevenue: 'Total Revenue Points',
    revenueDesc: 'Earn points from views, affiliates, and unlocks',
    revenueStructure: 'Revenue Structure',
    rev100Views: 'Every 100 views',
    rev1000Views: 'Reaching 1,000 views',
    revAffiliate: 'Affiliate click',
    revUnlock: 'Premium content unlock',
    revenueHistory: 'Revenue History',
    revenueEmpty: 'No revenue yet\nStart earning by posting Shorts!',
    revenueMenuLabel: 'Story Revenue',
    revenueLoading: 'Loading…',
  },
  productDetail: {
    back: 'Back',
    more: 'More',
    mannerTemp: 'Manner temp.',
    chat: 'Chat',
    chatNoSeller: 'Chat is only available for listings from members.',
    chatOwnProduct: 'This is your own listing.',
    chatOpenFailed: 'Could not start chat. Check your connection.',
    reportScam: 'Report scam',
    reportNeedDb: 'Reporting is available for listings saved in the server.',
    like: 'Like',
    likeOn: 'Remove like',
    likeOff: 'Like',
    sliderLabel: 'Product photos',
    commissionTrade: 'Safe trade fee {rate}% · approx. {fee} {currency} extra',
    commissionJob: 'Safe trade fee {fee} {currency} per listing',
    commissionWaived: 'This listing may qualify for a fee waiver.',
    safePaymentSoon: 'In-app payment coming soon',
    views: '{count} views',
    likeNeedDb: 'Likes cannot be saved for this listing.',
    favorite: 'Save',
    favoriteOn: 'Saved',
    favoriteCount: '{count} saves',
    similarProducts: 'Similar items',
  },
  paymentReady: {
    title: 'Safe checkout is on the way',
    subtitle: 'Please arrange payment directly with the seller for now.',
    note: 'Escrow and in-app payments will be available in a future update.',
    contact: 'Contact seller',
  },
  postDetail: {
    back: 'Back',
    more: 'More',
    report: 'Report',
    reportNeedDb: 'Reporting is available for posts saved in the server.',
    comments: 'Comments',
    commentPlaceholder: 'Write a comment…',
    post: 'Post',
    likes: 'Likes',
    likeOn: 'Unlike',
    likeOff: 'Like',
    views: '{count} views',
    commentEmpty: 'Please enter a comment.',
    commentsEmpty: 'No comments yet. Be the first to comment.',
    commentNeedDb: 'Comments are only available on posts saved to the server.',
    commentSent: 'Comment posted.',
    translate: 'Translate',
    showOriginal: 'Show original',
    viewMyLanguage: 'Show in my language',
    autoTranslatedBadge: 'Auto-translated to your language',
    translateFailed: 'Translation unavailable.',
    translateBusy: 'Translating…',
  },
  event: {
    subtype: {
      event: 'Events & markets',
      visarun: 'Visa run',
      flash: 'Meetup',
      travel: 'Travel together',
    },
    field: {
      origin: 'Departure',
      destination: 'Destination',
      vehicle: 'Vehicle',
      prep: 'What to bring',
      lodging: 'Lodging',
      lodgingPh: 'e.g. hotel name, Airbnb link',
      meal: 'Meals',
    },
    vehicle: {
      bus: 'Bus',
      car: 'Car',
      motorbike: 'Motorbike',
      van: 'Van',
      taxi_share: 'Taxi / carpool',
      other: 'Other',
      otherPh: 'Enter vehicle type',
    },
    meal: {
      included: 'Included',
      excluded: 'Not included',
      hint: 'If meals are included, add details in the body.',
    },
    prep: {
      passport: 'Passport',
      visaFee: 'Visa fee',
      photo: 'ID photo',
      cash: 'Cash (USD)',
      add: 'Add item',
      addPh: 'Custom item',
    },
  },
  write: {
    tradeTitle: 'New listing',
    done: 'Done',
    close: 'Close',
    communityTitle: 'Community post',
    submit: 'Post',
    photos: 'Photos',
    title: 'Title',
    category: 'Category',
    price: 'Price',
    freeShare: 'Free giveaway',
    body: 'Description',
    bodyPlaceholder: 'Trade with neighbors nearby',
    regionLine: 'Trading area',
    regionArea: 'Area',
    communityBodyPh: 'Share tips with neighbors',
    optionalPhoto: 'Photos (optional)',
    regionUnset: 'Not set',
    regionDetecting: 'Detecting location…',
    regionTapToSelect: 'Tap to select area',
    regionPickTitle: 'Select trading area',
    useGpsRegion: 'Use current location',
    needRegion: 'Select a trading area or allow GPS.',
    regionAll: 'All areas',
    titlePlaceholder: 'Enter a title',
    pricePlaceholder: 'Enter price',
    deletePhotoAria: 'Remove photo',
    saving: 'Posting…',
    saved: 'Saved.',
    saveFailed: 'Could not save.',
    needTitle: 'Please enter a title.',
    needTitleBody: 'Please enter title and body.',
    needSupabase: 'Server connection required.',
    freeShareLabel: 'Free · Share',
    priceNegotiable: 'Open price',
    currency: 'Currency',
    submitCta: 'Post listing',
    needSession: 'No login session. Please sign in again.',
    needUserProfile: 'Could not load your profile. Check your connection or sign in again.',
    needAuthorId: 'You must be signed in with a valid profile to publish.',
    errorRls: 'No permission to save. Check that you are signed in.',
    errorFk: 'Your profile is not linked. Please sign in and try again.',
    dbErrorDetail: 'Save error: {detail}',
    justNow: 'Just now',
    imageOptimizing: 'Optimizing images…',
    event: {
      scheduleType: 'Schedule',
      always: 'Always',
      oneday: 'One day',
      period: 'Period',
      recurring: 'Weekly',
      startAt: 'Start',
      endAt: 'End',
      date: 'Date',
      dateFormatHint: 'Year / Month / Day',
      openHours: 'Hours',
      defaultHours: 'Default hours',
      openTime: 'Open',
      closeTime: 'Close',
      perDayHours: 'Different hours by day',
      perDayHoursHint: 'Leave blank to use the default hours.',
      scheduleNote: 'Exception note',
      scheduleNotePh: 'e.g. Sat 6:00–12:00',
      recurrence: 'Repeat days',
      recurrencePh: 'e.g. every_sat',
      weekday: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      needRecurrenceDays: 'Please select at least one repeat day.',
      location: 'Location',
      locationPh: 'e.g. Han Market square',
      priceInfo: 'Price',
      priceInfoPh: 'e.g. Free, from 50,000 VND',
      externalUrl: 'Ticket / link',
      recruitCount: 'Spots',
      recruitCountPh: 'e.g. 4',
      deadline: 'Apply by',
      needScheduleType: 'Please select a schedule type.',
      needStartAt: 'Please enter a start date and time.',
      needEndAt: 'Please enter an end date and time.',
      needEndAfterStart: 'End time must be later than start time.',
    },
  },
  tradeCats: {
    all: 'All',
    used: 'Used',
    rent: 'Rent',
    car: 'Cars',
    job: 'Part-time',
    real_estate: 'Real estate',
    free: 'Free share',
  },
  productCategory: {
    all: 'All',
    electronics: 'Electronics',
    furniture: 'Furniture',
    fashion: 'Fashion',
    food: 'Food & Drink',
    sports: 'Sports',
    books: 'Books',
    vehicle: 'Vehicle',
    kids: 'Kids',
    beauty: 'Beauty',
    household: 'Household',
    pets: 'Pets',
    tickets: 'Tickets',
    job: 'Jobs',
    rent: 'Rental',
    etc: 'Other',
  },
  countries: {
    KR: 'Korea',
    VN: 'Vietnam',
    US: 'United States',
    TH: 'Thailand',
    JP: 'Japan',
    CN: 'China',
    TW: 'Taiwan',
    RU: 'Russia',
    GB: 'United Kingdom',
    PH: 'Philippines',
    ID: 'Indonesia',
    MY: 'Malaysia',
    SG: 'Singapore',
    KH: 'Cambodia',
    MM: 'Myanmar',
    AU: 'Australia',
    CA: 'Canada',
    FR: 'France',
    DE: 'Germany',
    NL: 'Netherlands',
  },
  contentFilter: {
    blocked: 'Your post contains disallowed content.',
    sanitized: 'Some wording was adjusted automatically.',
  },
  spam: {
    rateLimited: 'Please try again in a moment.',
    duplicate: 'You cannot post the same content repeatedly.',
    linkOnlyWarn: 'Link-only posts look like spam. Add more context.',
    phoneWarn: 'Many phone numbers detected. This may be flagged as spam.',
  },
  imageReport: {
    title: 'Report image',
    types: {
      adult: 'Adult content',
      violence: 'Violence',
      spam: 'Spam',
      other: 'Other',
    },
    received: 'Report received ({n} total).',
    hidden: 'This image was auto-hidden after multiple reports. An admin may restore it.',
    hiddenLabel: 'Image under review',
  },
  block: {
    author: 'Block author',
    listTitle: 'Blocked accounts',
    empty: 'No blocked accounts.',
    unblock: 'Unblock',
    unblocked: 'Unblocked.',
    done: 'User blocked.',
    failed: 'Could not update block list.',
    needAuthor: 'Author information is missing.',
    chatBlocked: 'You cannot chat because of a block between accounts.',
  },
  realEstate: {
    title: 'Real estate & rental',
    registerCta: 'List a property',
    filters: 'Filters',
    filterRegion: 'Area',
    filterRegionAll: 'All',
    regionDanang: 'Da Nang',
    regionHcmc: 'Ho Chi Minh City',
    regionOther: 'Other',
    priceMin: 'Min price (digits)',
    priceMax: 'Max price (digits)',
    roomSize: 'Layout',
    roomAll: 'All',
    room: { studio: 'Studio', '1ldk': '1LDK', '2ldk': '2LDK+' },
    furnished: 'Furnished',
    furnishedOnly: 'Furnished only',
    furnYes: 'Furnished',
    furnNo: 'Unfurnished',
    petOk: 'Pets allowed',
    petOnly: 'Pets allowed only',
    petYes: 'Pets OK',
    petNo: 'No pets',
    fieldKind: 'Listing type',
    fieldPrice: 'Price',
    fieldLocation: 'Location',
    fieldDesc: 'Description',
    fieldDescEn: 'English description (for translate)',
    fieldNick: 'Nickname',
    fieldFlag: 'Flag (emoji)',
    photos: 'Photos (max 10)',
    saved: 'Listed.',
    empty: 'No listings match your filters.',
    needPriceLocation: 'Enter price and location.',
    needNickname: 'Enter a nickname.',
    justNow: 'Just now',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    tab: {
      all: 'All',
      monthly: 'Monthly rent',
      jeonse: 'Jeonse',
      short: 'Short stay',
      sale: 'Sale',
    },
    reTabAll: 'All',
    reTabLong: 'Long stay',
    reTabShort: 'Short stay',
    reTabSale: 'Buy & sell',
    reSubLongMonthly: 'Monthly',
    reSubLongJeonse: 'Jeonse',
    reSubLongColiving: 'Coliving',
    reSubShortHotel: 'Hotel',
    reSubShortGuest: 'Guesthouse',
    reSubShortAirbnb: 'Airbnb-style',
    reSubShortServiced: 'Serviced apt',
    reSubSaleApt: 'Apartment',
    reSubSaleVilla: 'Villa',
    reSubSaleRetail: 'Retail',
    rePriceSale: 'Asking',
    rePriceMonth: 'Monthly',
    rePriceNight: 'Per night',
    rePerMonth: 'mo',
    regionHoian: 'Hoi An',
    filterAmenities: 'Amenities',
    filterPets: 'Pet friendly',
    filterInstant: 'Instant book',
    verified: 'Verified',
    instantBook: 'Instant',
    reviews: 'Reviews',
    openWrite: 'List my property (landlord · tenant · agency)',
    tabListings: 'Listings',
    tabBrokers: 'Agencies',
    pageTabsAria: 'Real estate tabs',
    brokerHint: 'Local real-estate agencies. Tap a card to open the business profile.',
    brokerCount: '{n} agencies',
    brokerEmpty: 'No agencies listed yet',
    reLegalDisclaimer:
      'This service is for information sharing only. It is not a licensed real-estate brokerage. Get professional help before signing contracts.',
    detailChat: 'Message host',
    detailCall: 'Call',
    detailPhase2: 'Date picker and booking request will be added in a later update.',
    noHostChat: 'Host chat is not available. Please call instead.',
    selfChat: "This is your own listing.",
    reviewsEmpty: 'No reviews yet.',
    writeStep1: 'Type',
    writeStep2: 'Category',
    writeStep3: 'Basic info',
    writeStep4: 'Pricing',
    writeStep5: 'Amenities',
    writeStep6: 'Photos',
    writeStep7: 'Review',
    writeNext: 'Next',
    writeBack: 'Back',
    writeSubmit: 'Publish',
    myListings: 'My listings',
    myListingsSub: 'Stays & real estate you posted',
    reservationRequestsTitle: 'Reservation requests',
    reservationsSoon: 'Reservation inbox is coming soon.',
    reviewsManageSoon: 'Review management is coming soon.',
    translateSoon: 'Auto-translation (EN) is coming in a later update.',
    catlong_monthly: 'Monthly',
    catlong_jeonse: 'Jeonse',
    catlong_coliving: 'Coliving',
    catshort_hotel: 'Hotel',
    catshort_guesthouse: 'Guesthouse',
    catshort_airbnb: 'Airbnb-style',
    catshort_serviced: 'Serviced',
    catsale_apartment: 'Apartment',
    catsale_villa: 'Villa',
    catsale_retail: 'Retail',
    reChipAll: 'All',
    reChipMonthly: 'Monthly rent',
    reChipJeonse: 'Jeonse',
    reChipSale: 'Sale',
    reChipShort: 'Short stay',
    reChipInstant: 'Move in now',
    reChipPets: 'Pet friendly',
    reChipTransfer: 'Transfer',
    reChipRoommate: 'Roommate',
    reOwnerFilter: 'Listed by',
    rePropertyTypeFilter: 'Property type',
    rePropertyTypeHint: 'Select apartment, house, commercial, or land. (multiple allowed)',
    rePropertyTypeEmpty: 'All property types',
    reTransactionFilter: 'Transaction',
    reTransactionHint: 'Start by choosing rent or sale.',
    reTransAll: 'All',
    reTransRent: 'Rent',
    reTransSale: 'Sale',
    reDealDetailFilter: 'Deal type',
    reDealDetailHint: 'Pick monthly rent, jeonse, short stay, and more.',
    reDealDetailHintSale: 'Select Sale to see purchase listings only.',
    reFilterStepPrefix: 'Step {n}',
    reRoomSpecFilter: 'Rooms & baths',
    reRoomSpecHint: 'Pick minimum bedroom and bathroom counts (e.g. 2+ beds = at least 2 bedrooms).',
    reBedroomFilter: 'Bedrooms',
    reBathroomFilter: 'Bathrooms',
    reBedroomMin: '{n}+ beds',
    reBathroomMin: '{n}+ baths',
    reRoomSpecEmpty: 'Any',
    reRoomSpecSelected: 'Room filters applied.',
    reDepositMonthsAmount: 'Deposit {months} mo · {amount}',
    reFilterScopeTitle: 'Location scope',
    reFilterScopeGps:
      'Showing listings within {radius}km of your GPS and in your selected region ({country} · {city}). Change location at the top to refresh results.',
    reFilterScopeManual:
      'Showing listings for your selected country and city ({country} · {city}). Enable GPS to also factor in distance.',
    reDistrictFilter: 'District',
    reDistrictHint: 'Select one or more districts. Leave empty to include the whole city.',
    reDistrictAll: 'All districts',
    reDistrictEmpty: 'Could not load districts for this city. Try another city or retry later.',
    reOwnerAll: 'All',
    reOwnerIndividual: 'Individual',
    reOwnerBusiness: 'Business',
    reOwnerTenant: 'Tenant',
    reKoreanAmenityFilter: 'Amenities',
    reKoreanAmenityHint: 'Filter by water purifier, bidet, kitchen, and more.',
    reEmptyFirst: 'No listings yet. Be the first to post a property!',
    reEmptyFiltered: 'No listings match your filters.',
    reEmptyCta: 'List a property',
    reAvailabilitySlot: 'Availability checks: {n}',
    reAvailabilityPlaceholder: 'Still available? (coming soon)',
    reListedToday: 'Today',
    reListedDaysAgo: '{n}d ago',
    reListedMonthsAgo: '{n}mo ago',
    reListedYearsAgo: '{n}y ago',
    reCardRating: '★{rating} ({n})',
    rePriceFilterBtn: 'Price',
    rePriceSheetTitle: 'Price range',
    rePriceApply: 'Apply',
    rePriceClose: 'Close',
    reFilterReset: 'Reset',
    reFilterApplyResults: 'Apply ({n})',
    reDisclaimerToggle: 'ⓘ Info',
    reBeachMin: 'Beach {n} min',
    reFloorSuffix: ' fl',
    reFavorite: 'Save',
    reFavoriteOn: 'Saved',
    reCardRailAria: 'Lister, date, and languages',
    reCardBed: '{n} bed',
    reCardBath: '{n} bath',
    reCardLiving: 'living {n}',
    reCardVeranda: 'veranda {n}',
    reChatInquiry: 'Chat',
    rePhoneCall: 'Call',
    reSectionLocation: 'Location & distance',
    reSectionOptions: 'Amenities',
    reSectionHost: 'Lister',
    reSectionDescription: 'Description',
    registerOwnerHint: 'Homeowners and tenants (transfer/takeover): tap below, then choose your type in step 1.',
    reSectionSurroundings: 'Neighborhood',
    reMaintIncludedShort: 'Fees included',
    reActivityBadge: 'Activity',
    reConsultHours: 'Consultation hours',
    reShare: 'Share',
    reMinPrice: 'Min',
    reMaxPrice: 'Max',
    needSectionTitle: 'Choose your needs',
    needSectionHint: 'Select what matters to you so it is easier to find matching listings.',
    needTag_nearStation: 'Near main road/station',
    needTag_petFriendly: 'Pet friendly',
    needTag_lowDeposit: 'Low deposit',
    needTag_furnished: 'Furnished',
    needTag_shortMoveIn: 'Move in now',
    needTag_koreanSupport: 'Korean support',
    needSelected: '{n} needs selected',
    needSelectedEmpty: 'No needs selected yet.',
    distanceUnitMin: ' min',
    register: {
      typeMonthly: 'Monthly Rent',
      typeDeposit: 'Deposit Lease',
      typeSale: 'Sale',
      typeCommercial: 'Commercial',
      step1: 'Property Type',
      step2: 'Basic Info',
      step3: 'Location',
      step4: 'Building Info',
      step5: 'Price',
      step6: 'Amenities',
      step7: 'Move-in Terms',
      step8: 'Photos',
      step9: 'Confirm',
      stepBuildingInfo: 'Building Info',
      stepPricing: 'Price',
      stepAmenities: 'Amenities',
      stepMoveIn: 'Move-in Terms',
      deposit: 'Deposit',
      monthlyRent: 'Monthly Rent',
      maintenanceFee: 'Maintenance Fee',
      isAgent: 'Licensed Agent',
    },
  },
  realEstateWrite: {
    title: 'List a property',
    step: 'Step',
    next: 'Next',
    prev: 'Back',
    submit: 'Publish',
    preview: 'Preview',
    typeApartment: 'Apartment',
    typeVilla: 'Villa',
    typeTownhouse: 'Townhouse',
    typeHouse: 'Detached house',
    typeBuilding: 'Building',
    typeCommercial: 'Retail / office',
    typeLand: 'Land',
    typeHotel: 'Hotel / resort',
    transMonthlyNoDeposit: 'Monthly rent (no deposit)',
    transMonthlyDeposit: 'Monthly rent (with deposit)',
    transSale: 'Sale',
    transShort: 'Short-term (<1 mo)',
    transLong: 'Long-term (1+ mo)',
    success: 'Your listing was published!',
    updateSuccess: 'Your listing was updated!',
    editTitle: 'Edit listing',
    saveEdit: 'Save changes',
    country: 'Country',
    city: 'City',
    selectCity: 'Select a city',
    district: 'District',
    selectDistrict: 'Select district',
    districtHint: 'Used for search and filters. You can leave this blank and enter the street address only.',
    countryVn: 'Vietnam',
    countryKr: 'Korea',
    countryUs: 'United States',
    addressDetail: 'Street address',
    landmarkDist: 'Time to landmarks (minutes)',
    distanceBeach: 'To beach',
    distanceAirport: 'To airport',
    distanceCenter: 'To city center',
    price: 'Price',
    currency: 'Currency',
    deposit: 'Deposit',
    depositMonths: 'Deposit (months of rent)',
    depositHint: 'Enter months only to auto-calculate deposit from monthly rent, or enter the amount directly.',
    depositMonth1: '1 month',
    depositMonth2: '2 months',
    depositMonth3: '3 months',
    depositMonth6: '6 months',
    depositMonthNegotiate: 'Negotiable',
    refundPolicy: 'Refund policy',
    refundFull: 'Full refund',
    refundPartial: 'Partial refund',
    refundNone: 'No refund',
    maintenanceIncluded: 'Maintenance fee included',
    maintenanceFee: 'Maintenance fee (if separate)',
    negotiable: 'Price negotiable',
    availableImmediately: 'Move in immediately',
    moveInDate: 'Available from',
    areaSqm: 'Area (㎡)',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    livingRoom: 'Living room',
    balconyTerrace: 'Balcony / terrace',
    balconySize: 'Balcony / terrace size',
    balconySizePlaceholder: 'e.g. 4㎡ (optional)',
    optionYes: 'Yes',
    optionNo: 'No',
    floor: 'Floor',
    totalFloors: 'Total floors',
    direction: 'Orientation',
    dir_south: 'South',
    dir_east: 'East',
    dir_west: 'West',
    dir_north: 'North',
    dir_se: 'Southeast',
    dir_sw: 'Southwest',
    builtYear: 'Year built',
    petsAllowed: 'Pets allowed',
    smokingAllowed: 'Smoking allowed',
    basicAmenities: 'In-unit amenities',
    buildingFacilities: 'Building facilities',
    amenityAc: 'A/C',
    amenityFridge: 'Fridge',
    amenityWasher: 'Washer',
    amenityBed: 'Bed',
    amenitySofa: 'Sofa',
    amenityTv: 'TV',
    amenityWifi: 'Internet / Wi‑Fi',
    amenityMicrowave: 'Microwave',
    amenityDishwasher: 'Dishwasher',
    facPool: 'Pool',
    facGym: 'Gym',
    facElevator: 'Elevator',
    facSecurity: 'Security',
    facCctv: 'CCTV',
    facParking: 'Parking',
    facConvenience: 'Convenience store',
    facCafe: 'Café',
    photoHint: 'Add living room, bedroom, bath, kitchen, and view photos to get more interest!',
    primaryPhoto: 'Cover photo',
    tapToUpload: 'Tap to upload',
    morePhotos: 'More photos (max 20)',
    addPhotos: 'Add photos',
    remove: 'Remove',
    ownerType: 'Lister type',
    owner_individual: 'Private landlord',
    owner_agency: 'Real estate agency',
    owner_owner: 'Owner-occupier / owner',
    phone: 'Phone',
    kakao: 'KakaoTalk ID',
    telegram: 'Telegram',
    consultStart: 'Consult from',
    consultEnd: 'Consult until',
    languages: 'Languages spoken',
    langKo: 'Korean',
    langEn: 'English',
    langVi: 'Vietnamese',
    langRu: 'Russian',
    langJa: 'Japanese',
    listingTitle: 'Listing title',
    listingDesc: 'Description',
    surroundings: 'Neighborhood',
    notes: 'Special notes',
    exposure: 'Visibility tier',
    exposureFree: 'Free (standard)',
    exposurePremium: 'Premium $10 (boosted)',
    exposureFeatured: 'Featured $30 (top placement)',
    needFields: 'Please complete all required fields.',
    spineStep1: 'Who · deal type',
    spineStep2: 'Listing · amenities',
    spineStep3: 'Deal terms',
    spineStep4: 'Review · publish',
    spineWho: 'Listed by',
    spineDeal: 'Deal type',
    spineOwnerIndividual: 'Homeowner',
    spineOwnerBusiness: 'Business',
    spineOwnerTenant: 'Tenant (transfer / takeover)',
    veranda: 'Balcony / veranda',
    editStep: 'Edit {step}/{total} · {section}',
    businessContextLabel: 'Listing business',
    businessContextLoading: 'Loading business…',
    selectBusiness: 'Your business',
    selectBusinessPlaceholder: 'Select business',
    reBusinessEmptyHint: 'To list as a business, create your business profile first.',
    reBusinessEmptyCta: 'Register a business',
    dealMonthlyRent: 'Monthly rent',
    dealJeonse: 'Jeonse',
    dealSale: 'Sale',
    dealShortTerm: 'Short-term',
    dealTransfer: 'Transfer / succession',
    tenantDealAutoHint: 'Tenant listings are limited to transfer / succession deals.',
    dealRoommate: 'Roommate / share',
    deal_monthly_rent: 'Monthly',
    deal_jeonse: 'Jeonse',
    deal_sale: 'Sale',
    deal_short_term: 'Short-term',
    deal_transfer: 'Transfer',
    deal_roommate: 'Roommate',
    transferKindTitle: 'Transfer type',
    transferResidential: 'Residential transfer',
    transferCommercial: 'Commercial (key money)',
    transfer_residential: 'Residential',
    transfer_commercial: 'Commercial',
    transferCommercialHint: 'Key-money listings are stored only in properties. They will appear in both real-estate and business-transfer lists (next step).',
    spinePropertyType: 'Property type',
    koreanAmenities: 'Korean-style amenities',
    amenitiesSection: 'Amenities',
    consultLanguages: 'Languages spoken',
    consultLang_ko: 'Korean',
    consultLang_vi: 'Vietnamese',
    consultLang_en: 'English',
    consultLang_ru: 'Russian',
    consultLang_zh: 'Chinese',
    consultLang_ja: 'Japanese',
    requiredHint: '* Required fields',
    previewHint: 'This is how your listing will appear in search.',
    invalidImage: 'Only JPG, PNG, GIF, or WEBP images are allowed.',
    photoLimit: 'You can add up to 20 extra photos.',
    mapLat: 'Latitude (optional)',
    mapLng: 'Longitude (optional)',
    monthlyRent: 'Monthly rent',
    salePrice: 'Sale price',
    titleDeedStatus: 'Title / deed status',
    titleDeedStatusPlaceholder: 'e.g. pink book, foreign ownership OK',
    foreignerOwnershipOk: 'Foreign ownership allowed',
    jeonseAmount: 'Jeonse deposit',
    jeonseContractMonths: 'Contract term (months)',
    contractMonthsMin: 'Min. contract (months)',
    shortPrice: 'Price',
    priceUnit: 'Price unit',
    priceUnitMonth: 'Month',
    priceUnitWeek: 'Week',
    minPeriodDays: 'Min. stay (days)',
    maxPeriodDays: 'Max. stay (days)',
    remainingContractMonths: 'Remaining contract (months)',
    depositTransfer: 'Deposit transfer',
    includedItems: 'Included items',
    includedItemsPlaceholder: 'Furniture, appliances (comma-separated)',
    originalContractNotes: 'Original contract notes',
    keyMoney: 'Key money',
    businessType: 'Business type',
    businessTypePlaceholder: 'e.g. cafe, restaurant, massage',
    monthlyRevenue: 'Monthly revenue (optional)',
    operatingMonths: 'Operating months',
    fixtures: 'Fixtures & interior',
    equipment: 'Equipment',
    totalRooms: 'Total rooms',
    shareCount: 'Roommates wanted',
    genderPreference: 'Gender preference',
    genderAny: 'Any',
    genderFemale: 'Female',
    genderMale: 'Male',
    sharedSpaces: 'Shared spaces',
    sharedSpacesPlaceholder: 'Kitchen, living room (comma-separated)',
    costPerPerson: 'Cost per person',
  },
  jobs: {
    title: 'Jobs',
    tabHire: 'Hiring',
    tabSeek: 'Seeking',
    feeNotice:
      'A fee may apply when a match is made. The service is free for now; fees may be introduced later.',
    disclaimerLegal:
      'This service is for sharing job and hire information only. Mingo is not a licensed employment agency or job placement business.',
    writeFab: 'Write',
    writeHire: 'Post a job (hire)',
    writeSeek: 'Post a profile (seek)',
    needTitle: 'Please enter a title.',
    saved: 'Posted.',
    hubBoardBannerTitle: 'Jobs board',
    hubBoardBannerDesc: 'Post hire or seek listings and contact posters',
    hubBoardBannerCta: 'Open board',
    fieldTitle: 'Title / company or nickname',
    fieldCompanyName: 'Company name (optional)',
    fieldCompanyNamePlaceholder: 'e.g. VietHoa Mart',
    fieldSalary: 'Salary / expected pay',
    fieldRegion: 'Region',
    regionPickTitle: 'Select work region',
    needRegion: 'Please select a work region or allow GPS.',
    fieldMapPin: 'Job location (optional)',
    mapPinHint: 'Pin the location so nearby seekers can find this posting',
    fieldOccupation: 'Occupation',
    occupationPlaceholder: 'Select occupation (optional)',
    fieldPostLanguage: 'Posting language',
    postLanguageHint: 'Pick the language this posting is actually written in — job seekers use it to filter by language.',
    occupation: {
      translation: 'Translation & Interpretation',
      it: 'IT & Development',
      marketing: 'Marketing',
      accounting: 'Accounting & Admin',
      food_service: 'Food & Service',
      education: 'Education',
      construction: 'Construction & Trades',
      design: 'Design',
      other: 'Other',
    },
    fieldEmploymentType: 'Employment type',
    employmentTypePlaceholder: 'Select employment type (optional)',
    employmentType: {
      fulltime: 'Full-time',
      contract: 'Contract',
      parttime: 'Part-time',
      freelance: 'Freelance',
      intern: 'Internship',
      daily: 'Daily work',
    },
    fieldCareerLevel: 'Experience',
    careerLevelPlaceholder: 'Select experience level (optional)',
    careerLevel: {
      any: 'No preference',
      entry: 'Entry level',
      experienced: 'Experienced',
    },
    fieldSalaryType: 'Pay type',
    salaryTypePlaceholder: 'Select pay type (optional)',
    salaryType: {
      hourly: 'Hourly',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      negotiable: 'Negotiable',
    },
    fieldWorkDays: 'Work days',
    workDays: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun',
    },
    fieldWorkHours: 'Work hours',
    workHoursPlaceholder: 'e.g. 09:00-18:00, negotiable',
    fieldWorkHoursPresets: 'Work hours (for matching)',
    fieldExpectedDuration: 'Expected duration (for matching)',
    viewOnMapCta: 'View larger map',
    safetyNoticeText:
      "If a listing asks for your debit card or account password under the guise of debt-collection help or a high-paying gig, it may be a scam. Check the list below before applying.",
    companyInfoTitle: 'Company info',
    companyVerifiedBadge: 'Verified',
    companyAddressLabel: 'Address',
    companyRecentHireLabel: 'Hiring activity',
    companyRecentHireValue: '{count} job post(s) in the past year',
    fieldEducationLevel: 'Education',
    educationLevelPlaceholder: 'Select education level (default: none required)',
    educationLevel: {
      any: 'No requirement',
      high_school: 'High school or above',
      associate: 'Associate degree or above',
      bachelor: "Bachelor's degree or above",
      master_or_above: "Master's degree or above",
    },
    fieldBenefits: 'Benefits',
    benefitsPlaceholder: 'Comma-separated (e.g. insurance, paid leave, incentives)',
    fieldPreferredQualifications: 'Preferred qualifications',
    preferredQualificationsPlaceholder: 'e.g. Relevant experience preferred, nearby residents preferred',
    fieldSkillTags: 'Helpful skills',
    skillTagsPlaceholder: 'Comma-separated (e.g. customer service, phone support)',
    fieldHeadcount: 'Headcount',
    headcountPlaceholder: 'e.g. 1',
    fieldDeadline: 'Application deadline',
    deadlineHint: 'Leave blank for ongoing recruitment',
    deadlineNone: 'Ongoing',
    fieldExtra: 'Details',
    fieldContact: 'Contact',
    aiAssist: {
      cta: 'Auto-fill title & description with AI',
      desc: 'AI will draft a title and description based on the occupation, region, salary, etc. you already entered. Add anything you want to highlight below.',
      hintPlaceholder: 'e.g. friendly boss, beginners welcome, Korean speakers preferred',
      generate: 'Generate',
      generating: 'Generating...',
      success: 'AI filled in the title and description. Feel free to edit them.',
      noKey: 'AI writing assistant is unavailable right now.',
      fail: 'Generation failed. Please try again shortly.',
    },
    applyCta: 'Apply',
    alreadyApplied: 'Applied',
    applyCoverLetterLabel: 'Cover message (optional)',
    applyCoverLetterPlaceholder: 'Introduce yourself or share why you’re a good fit',
    applySubmit: 'Send application',
    applyCancel: 'Cancel',
    applySuccess: 'Application sent.',
    applyFailed: 'Failed to apply. Please try again.',
    applyOwnPost: 'This is your own listing.',
    viewApplicants: 'Applicants',
    applicantsEmpty: 'No applicants yet.',
    applicationStatus: {
      applied: 'Applied',
      reviewed: 'In review',
      accepted: 'Accepted',
      rejected: 'Rejected',
    },
    acceptCta: 'Accept',
    rejectCta: 'Reject',
    reviewCta: 'Mark as in review',
    contactApplicantCta: 'Contact via chat',
    contactPosterCta: 'Message via chat',
    callCta: 'Call',
    noPosterChat: 'No poster info available, so chat can\'t be opened.',
    chatBlocked: 'You can\'t chat with a blocked user.',
    premiumSection: 'Premium options',
    premiumFree: 'Standard listing: free',
    premiumPin: 'Pinned to top',
    premiumPinPrice: '$10 / week',
    premiumUrgent: 'Urgent badge',
    premiumUrgentPrice: '$5',
    premiumResume: 'Resume views',
    premiumResumePrice: '$3',
    premiumComing: 'Coming soon',
    badgeTop: 'Top',
    badgeUrgent: 'Urgent',
    fallbackHire: 'Hiring',
    fallbackSeek: 'Job seeker',
    emptyList: 'No job listings yet.',
    negotiable: 'Negotiable',
    workConditions: 'Work conditions',
    recruitConditions: 'Recruitment details',
    workRegionLabel: 'Work location',
    applyMethodLabel: 'How to apply',
    postedAt: 'Posted',
    myApplicationsTitle: 'My applications',
    myApplicationsEmpty: "You haven't applied to any jobs yet.",
    talentDirectory: {
      title: 'Talent directory',
      subtitle: 'Meet job seekers ready to work now.',
      empty: 'No public talent profiles yet.',
      anonymous: 'Mingo member',
      saveCta: 'Save',
      savedCta: 'Saved',
      unlockHint: 'First contact costs 1 credit',
      unlockInsufficientCredit: 'Not enough ad credit.',
      unlockFailed: 'Could not unlock contact. Please try again shortly.',
      badges: {
        all: 'All',
        realtime: 'Active now',
        veteran: 'Veteran',
        student: 'Student',
        freelancer: 'Freelancer',
      },
    },
    scamSearch: {
      title: 'Scam contact lookup',
      subtitle: 'Search reported job-scam contacts by phone, email, or company name.',
      searchPlaceholder: 'Search phone, email, or company (3+ characters)',
      searchBtn: 'Search',
      searching: 'Searching…',
      tooShort: 'Enter at least 3 characters.',
      noResult: 'No results found. Good news if you were just checking.',
      report: {
        cta: 'Report a job scam',
        formTitle: 'Report a scam',
        phone: "Their phone number",
        email: "Their email",
        company: 'Company name',
        bankAccount: 'Bank account',
        amountLost: 'Amount lost (optional)',
        description: 'What happened',
        moderationNotice: 'Reports are reviewed by our team before appearing in search results.',
        saving: 'Submitting…',
        submit: 'Submit report',
        done: 'Report submitted. It will appear after review.',
        error: {
          needDescription: 'Please describe what happened.',
          needContact: 'Enter at least one of phone, email, company, or bank account.',
        },
      },
    },
    resume: {
      title: 'My Resume',
      subtitle: 'Save a resume once and it\'s auto-attached whenever you apply.',
      photo: 'Photo',
      photoUpload: 'Upload photo',
      photoUploading: 'Uploading…',
      photoRemove: 'Remove',
      photoTooLarge: 'That image is too large.',
      headline: 'Headline',
      headlinePlaceholder: 'e.g. Reliable barista with 2 years experience',
      summary: 'About me',
      summaryPlaceholder: 'Write a short introduction about yourself.',
      experience: 'Experience',
      experiencePlaceholder: 'e.g. Cafe ABC, server (Jan 2023 - Jun 2023)',
      education: 'Education',
      educationPlaceholder: 'e.g. ABC University, Business major',
      languages: 'Languages',
      languagesPlaceholder: 'e.g. Korean (native), English (business)',
      addLine: 'Add',
      skills: 'Skills',
      skillsPlaceholder: 'Comma-separated (e.g. POS, inventory, driving license)',
      desiredSalary: 'Desired salary',
      desiredRegion: 'Desired area',
      desiredJobType: 'Desired employment type',
      desiredConditions: 'Desired conditions',
      nationality: 'Nationality',
      publicConsent: 'Show my resume in the talent directory',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Resume saved.',
      untitled: 'Resume',
      completenessTitle: 'Resume completeness',
      expEmpty: 'No experience added yet.',
      expCompanyPh: 'Company name',
      expRolePh: 'Role/title (e.g. server, manager)',
      expCurrent: 'Currently working here',
      expDescriptionPh: 'Briefly describe what you did.',
      expAdd: 'Add experience',
      eduEmpty: 'No education added yet.',
      eduSchoolPh: 'School name',
      eduDegreePh: 'Select degree',
      eduFieldPh: 'Field of study',
      eduAdd: 'Add education',
      degree: {
        high_school: 'High school',
        associate: 'Associate degree',
        bachelor: "Bachelor's",
        master: "Master's",
        doctorate: 'Doctorate',
        other: 'Other',
      },
      viewFullCta: 'View full resume',
      modalTitle: 'Resume',
      loadError: 'Could not load the resume.',
    },
    safetyTips: {
      title: 'Job Safety Guide',
      intro: 'Learn common job scam patterns and a checklist for safer job hunting.',
      ctaScamSearch: 'Go to scam contact search',
      ctaLaborConsult: 'Get labor consulting',
      ctaContractTemplate: 'View labor contract template',
    },
    contractTemplate: {
      title: 'Labor Contract Template',
      subtitle: 'A reference checklist and fill-in template based on Vietnam labor law.',
      printCta: 'Print / Save as PDF',
      docTitle: 'Labor Contract',
      docSubtitle: 'Fill in the fields below and sign. (Korean / Vietnamese)',
    },
    followEmployerCta: 'Follow employer',
    unfollowEmployerCta: 'Unfollow',
    followedEmployers: {
      title: 'Followed Employers',
      subtitle: 'See new postings from employers you follow, all in one place.',
      empty: 'You haven\'t followed any employers yet.',
      activeCount: '{count} active listing(s)',
    },
    savedTalents: {
      title: 'Saved Talent',
      subtitle: 'See all the talent profiles you\'ve saved, in one place.',
      empty: 'You haven\'t saved any talent yet.',
      unsaveCta: 'Unsave',
    },
    moreMenu: 'More menu',
    searchPlaceholder: 'Search job titles',
    aiBannerText: 'AI found jobs that match you!',
    iconMenu: {
      matched: 'Matched',
      region: 'By area',
      shortTerm: 'Short-term',
      urgent: 'Urgent',
      all: 'All',
    },
    chipOccupationAll: 'All occupations',
    chipCountryAll: 'All countries',
    chipRegionAll: 'All areas',
    chipEmploymentAll: 'All employment types',
    filterSheetTitle: 'Filters',
    filterReset: 'Reset',
    filterApply: 'Apply',
    matchBadge: 'Recommended',
    regionBadge: {
      slot1Exact: 'My location',
      slot2Exact: 'Saved area',
      slot1Radius: 'Near my location · {km}km',
      slot1RadiusPlain: 'Near my location',
      slot2Radius: 'Near saved area · {km}km',
      slot2RadiusPlain: 'Near saved area',
    },
    matchReason: {
      tag: 'Matches your field',
      career: 'Matches your career level',
      days: 'Matches your work days',
      hours: 'Matches your work hours',
      duration: 'Matches your work duration',
      nearby: 'Near you',
    },
  },
  jobsOnboarding: {
    title: 'Job search preferences',
    next: 'Next',
    bannerText: 'Find jobs matched to you',
    bannerCta: 'Set preferences',
    stepStyleTitle: 'What kind of job are you looking for?',
    style: {
      beginner_friendly: 'Beginner-friendly',
      start_immediately: 'Start right away',
      with_friends: 'Work with friends',
      short_term: 'Short-term',
      browse_myself: "I'll browse myself",
    },
    styleDesc: {
      beginner_friendly: 'Looking for an easy, fun first job',
      start_immediately: 'Need a job urgently',
      with_friends: 'Want to work with a friend',
      short_term: 'Want to work for under a month',
      browse_myself: "I'll take my time browsing",
    },
    stepTagsTitle: 'Select 3 or more roles you’re interested in',
    stepCareerTitle: 'Tell us about your experience',
    stepReasonTitle: 'Why are you job hunting right now?',
    reason: {
      vacation: 'Vacation job',
      ongoing: 'Ongoing job',
      urgent: 'Urgent job',
      browsing: 'Just browsing',
    },
    stepConditionDuration: 'Work duration',
    duration: {
      day: 'One day',
      under_week: 'Under a week',
      week_to_month: '1 week - 1 month',
      m1_3: '1 - 3 months',
      m3_6: '3 - 6 months',
      m6_12: '6 - 12 months',
      over_year: 'Over a year',
    },
    stepConditionDays: 'Work days',
    days: {
      all_week: 'Mon - Sun',
      mon_sat: 'Mon - Sat',
      weekday: 'Mon - Fri',
      weekend: 'Weekend (Sat, Sun)',
    },
    stepConditionHours: 'Work hours',
    hours: {
      morning: 'Morning',
      afternoon: 'Afternoon',
      evening: 'Evening',
      dawn: 'Dawn',
      fulltime: 'Full-time (8h+)',
    },
    finishTitle: 'All set!',
    finishDesc: 'Check your personalized listings from the home tab now.',
    locationConsent: 'Also recommend jobs near me',
    talentPublicConsent: 'Show my profile in the talent directory (visible to employers)',
    talentBadgesLabel: 'Badges that describe you',
    talentBadges: {
      veteran: 'Veteran',
      student: 'Student',
      freelancer: 'Freelancer',
    },
    saving: 'Saving…',
    start: 'Get started',
  },
  creditCharge: {
    title: 'Mingo credits',
    balance: 'Your credits',
    unit: '{n}',
    amountTitle: 'How many credits to add',
    amountPh: 'Credit amount',
    notePh: 'Payer name or note (optional)',
    noticeTitle: 'Notes',
    notice1: 'Credits are added after we review your request.',
    notice2: 'Credits are for in-app order confirmation only (you still pay cash at the store).',
    historyTitle: 'Your requests',
    statusApproved: 'Paid',
    statusRejected: 'Rejected',
    statusPending: 'Pending',
    submit: 'Request top-up',
    success: 'Request received. Credits will be added after review.',
    fail: 'Could not submit the request.',
  },
  business: {
    listTitle: 'Businesses',
    registerCta: 'Register business',
    advertiseLikeThis: 'Want to advertise like this business?',
    registerTitle: 'Register business',
    submit: 'Submit',
    name: 'Business name',
    category: 'Category',
    contact: 'Contact',
    address: 'Address',
    region: 'Area',
    regionPh: 'e.g. My Khe',
    intro: 'Description',
    hours: 'Hours',
    targetLang: 'Languages you serve',
    scopeLevel: 'Service Scope',
    scopeCity: 'Local Service',
    scopeCityDesc: 'Only in specific city\n(restaurant/hospital/academy)',
    scopeCountry: 'National Service',
    scopeCountryDesc: 'For expats in entire country\n(legal/insurance/real estate)',
    scopeGlobal: 'Global Service',
    scopeGlobalDesc: 'Available worldwide\n(online/mentoring/digital)',
    targetAudience: 'Target Audience',
    targetExpat: 'Expats',
    targetTourist: 'Tourists',
    targetBoth: 'Expats + Tourists',
    targetBusiness: 'Business',
    serviceOnline: 'Online Service Available',
    serviceOnlineDesc: 'Can provide service remotely\n(video/delivery/remote)',
    operatingCities: 'Operating Cities',
    addCity: 'Add City',
    photos: 'Photos',
    needName: 'Please enter a business name.',
    saved: 'Saved.',
    notFound: 'Business not found.',
    reviews: '{n} reviews',
    contactBtn: 'Contact',
    inquiryCta: 'Send inquiry',
    contactSoon: 'Contact flow is coming soon.',
    adBtn: 'Ad inquiry',
    adInquiry: 'Ad inquiries will route to support in a future update.',
    introEn: 'English description (optional, for translate)',
    primaryTitle: 'Primary business',
    primaryHint: 'Choose one business to show as your profile badge.',
    primarySaved: 'Primary business saved.',
    deliverySection: 'Delivery & pickup',
    deliveryOn: 'Delivery available',
    deliveryArea: 'Delivery area',
    deliveryAreaPh: 'e.g. within 3 km of My Khe',
    minOrder: 'Minimum order',
    deliveryFee: 'Delivery fee',
    pickupOn: 'Pickup available',
    orderMethod: 'How to order',
    orderPhone: 'Phone',
    orderKakao: 'KakaoTalk',
    orderApp: 'App',
    orderVisit: 'Walk-in',
    orderContact: 'Order contact',
    closedDays: 'Closed on',
    dayMon: 'Mon',
    dayTue: 'Tue',
    dayWed: 'Wed',
    dayThu: 'Thu',
    dayFri: 'Fri',
    daySat: 'Sat',
    daySun: 'Sun',
    menuSection: 'Menu',
    addMenu: 'Add menu item',
    menuName: 'Name',
    menuPrice: 'Price',
    menuDesc: 'Description',
    menuPhoto: 'Photo',
    menuSoldOut: 'Sold out',
    menuEdit: 'Edit',
    menuDelete: 'Remove',
    menuSave: 'Save',
    menuCats: {
      korean: 'Korean',
      chinese: 'Chinese',
      western: 'Western',
      drink: 'Drinks',
      other: 'Other',
      popular: 'Popular',
      set: 'Set / combo',
      dessert: 'Dessert',
    },
    badgeDelivery: 'Delivery',
    badgePickup: 'Pickup',
    detailMinOrder: 'Min. order',
    detailDeliveryFee: 'Delivery fee',
    detailOrder: 'Order',
    detailHours: 'Hours',
    detailClosed: 'Closed',
    detailMenus: 'Menu',
    translate: 'Translate',
    translateOriginal: 'Original',
    cats: {
      restaurant: 'Restaurant',
      hospital: 'Hospital',
      beauty: 'Beauty',
      travel: 'Travel',
      realestate: 'Real estate',
      other: 'Other',
      food_cafe_mart: 'Food, Cafe & Mart',
      travel_activity_experience: 'Travel & tours',
      accommodation_stay: 'Hotel & stay',
      living_realestate_rental: 'Real estate & rental',
      home_interior: 'Home & interior',
      health_medical_beauty: 'Medical, health & beauty',
      beauty_wellness: 'Beauty & Wellness',
      health_medical: 'Medical & Health',
      education_lesson: 'Education & lessons',
      mobility_transport: 'Mobility & moving',
      telecom: 'Telecom, SIM & internet',
      finance_remittance: 'Finance & remittance',
      wedding_event: 'Wedding & events',
      pet: 'Pets',
      creator_media: 'Creator & media',
      parenting_care: 'Parenting & care',
      jobs_business: 'Jobs & Recruitment',
      professional_services: 'Visa, legal & accounting',
    },
    catsDesc: {
      food_cafe_mart: 'Local eats, Korean food, cafés, marts, delivery',
      living_realestate_rental: 'Real estate, rent, lease, sale, appliance rental',
      home_interior: 'Wallpaper, flooring, interior work, home care',
      travel_activity_experience: 'Tours, activities, booking transfers',
      accommodation_stay: 'Hotels, resorts, pool villas, guesthouses',
      jobs_business: 'Hiring, job seeking, freelance, internships',
      professional_services: 'Visa, legal consult, tax & accounting, company setup, translation & interpretation',
      education_lesson: 'Schools, lessons, classes, experiences',
      health_medical_beauty: 'Medical, health & beauty services',
      beauty_wellness: 'Hair, barber, nail, waxing, massage, spa, gym',
      health_medical: 'Clinics, dental, dermatology, plastic surgery, pharmacy',
      mobility_transport: 'Rental, moving, delivery, vehicle sales & repair',
      telecom: 'SIM/eSIM, phone activation, internet install, pocket wifi',
      finance_remittance: 'Exchange, remittance, insurance',
      wedding_event: 'Weddings, events, photo, video',
      pet: 'Vet, pet grooming, pet sitting, supplies',
      creator_media: 'Live, webtoon, YouTube, creators',
      parenting_care: 'Babysitter, postpartum care, childcare, playrooms',
    },
    defaultMenuGroupName: {
      popular: 'Popular',
      set: 'Set / combo',
      drink: 'Drinks',
      dessert: 'Dessert',
      service: 'Services & products',
      other: 'Other',
    },
    deliveryZonesTitle: 'Delivery zones',
    zoneNamePh: 'Zone name (e.g. District A)',
    zoneOn: 'ON',
    zoneDelete: 'Remove zone',
    addZone: 'Add zone',
    menuCategoriesTitle: 'Menu categories',
    menuCategoriesHint: 'Name categories (e.g. popular, sets, drinks) and assign each item.',
    offeringsSection: 'Services & products (optional)',
    offeringsHint:
      'Add classes, treatments, packages, etc. For restaurants and cafés, choose Food & beverage as the main category to use the full menu and delivery form.',
    offeringName: 'Item name (e.g. Korean beginner 3x/week)',
    offeringPrice: 'Price / tuition',
    offeringDesc: 'Details (schedule, level, what to bring, …)',
    categoryDelete: 'Delete',
    addCategory: 'Add category',
    minOneCategory: 'Keep at least one category.',
    optionGroupsTitle: 'Options (size, toppings, …)',
    optionGroupNamePh: 'Group name (e.g. Size)',
    optionGroupDelete: 'Remove group',
    addOptionGroup: 'Add option group',
    addOptionItem: 'Add option',
    optLabelPh: 'Label (e.g. L)',
    optPriceDeltaPh: 'Extra price (+0)',
    optTypeSingle: 'Single choice',
    optTypeMulti: 'Multi choice',
    optRequired: 'Required',
    optionItem: 'Item',
    openNow: 'Open today',
    closedNow: 'Closed today',
    callNow: 'Call Now',
    mapLink: 'Map Link',
    profileHubTitle: 'My business',
    profileHubLead: 'Register and manage listings from My page → Business dashboard.',
    profileLocalTitle: 'Saved on this device',
    profileLocalHint: 'For quick preview after registering. Clearing app data may remove these entries.',
    profileEmptyLocal: 'No saved businesses yet. Register one above.',
    profileOpenStore: 'View store',
  },
  categories: {
    medical_health: 'Medical / health',
    beauty: 'Beauty',
    food_beverage: 'Food & beverage',
    real_estate_life: 'Real estate / living',
    education: 'Education',
    professional: 'Professional services',
    shopping_convenience: 'Shopping / convenience',
    transport: 'Transport',
    event_leisure: 'Events / leisure',
    care: 'Care',
    repair_tech: 'Repair / tech',
    misc: 'Other',
    med_hospital: 'Hospital / clinic',
    med_dental: 'Dental',
    med_pharmacy: 'Pharmacy',
    med_korean: 'Korean medicine',
    med_plastic: 'Plastic surgery',
    med_derma: 'Dermatology',
    med_eye: 'Ophthalmology',
    med_ent: 'ENT',
    med_obgyn: 'OB-GYN',
    med_pediatric: 'Pediatrics',
    med_ortho: 'Orthopedics',
    med_gym: 'Gym / fitness',
    med_yoga: 'Yoga / Pilates',
    med_rehab: 'Rehab / physiotherapy',
    bea_hair: 'Hair salon',
    bea_nail: 'Nail salon',
    bea_spa: 'Massage / spa',
    bea_wax: 'Waxing',
    bea_lash: 'Brows / lashes',
    bea_skin: 'Skin care clinic',
    bea_tattoo: 'Tattoo / piercing',
    food_korean: 'Korean restaurant',
    food_japanese: 'Japanese restaurant',
    food_chinese: 'Chinese restaurant',
    food_western: 'Western restaurant',
    food_sea: 'Southeast Asian',
    food_other_intl: 'Other international',
    food_cafe: 'Cafe / dessert',
    food_bakery: 'Bakery',
    food_bar: 'Bar / pub',
    food_delivery: 'Delivery-only',
    re_agency: 'Real estate agency',
    re_interior: 'Interior / remodeling',
    re_cleaning: 'Cleaning',
    re_moving: 'Moving / hauling',
    re_laundry: 'Laundry',
    re_ac: 'AC / appliance repair',
    re_lock: 'Locksmith / security',
    re_pest: 'Pest control',
    edu_korean: 'Korean language school',
    edu_english: 'English school',
    edu_local: 'Local language school',
    edu_music: 'Music school',
    edu_art: 'Art school',
    edu_sports: 'Swimming / sports',
    edu_tutor: 'Tutoring',
    edu_cooking: 'Cooking class',
    edu_it: 'Coding / IT',
    edu_dance: 'Dance',
    pro_visa: 'Visa / admin agency',
    pro_tax: 'Tax / accounting',
    pro_legal: 'Legal',
    pro_insurance: 'Insurance',
    pro_interpret: 'Interpretation / translation',
    pro_photo: 'Photo / video',
    pro_itdev: 'IT / web dev',
    pro_design: 'Design',
    pro_consult: 'Consulting',
    shop_kmart: 'Korean mart',
    shop_cvs: 'Convenience store',
    shop_flower: 'Flower shop',
    shop_pet: 'Pet shop',
    shop_fashion: 'Fashion',
    shop_electronics: 'Electronics',
    tr_taxi: 'Taxi / charter',
    tr_rentcar: 'Car rental',
    tr_bike: 'Motorbike rental',
    tr_airport: 'Airport pickup',
    tr_move: 'Moving help',
    tr_quick: 'Express delivery',
    ev_planner: 'Event planner',
    ev_wedding: 'Wedding / studio',
    ev_travel: 'Travel / guide',
    ev_golf: 'Golf',
    ev_boat: 'Yacht / boat',
    ev_sports: 'Sports facility',
    ev_karaoke: 'Karaoke / arcade',
    care_baby: 'Babysitter',
    care_postpartum: 'Postpartum care',
    care_elder: 'Elder care',
    care_pet: 'Pet care',
    care_pethotel: 'Pet hotel / grooming',
    rep_phone: 'Phone repair',
    rep_pc: 'Computer repair',
    rep_appliance: 'Appliance repair',
    rep_car: 'Car repair',
    rep_bike: 'Motorbike repair',
    rep_cycle: 'Bicycle repair',
    misc_other: 'Other business type',
  },
  bookingTransfer: {
    title: 'Booking transfer',
    write: 'List transfer',
    writeTitle: 'List booking transfer',
    detailTitle: 'Booking transfer detail',
    urgent: 'Urgent transfers',
    urgentToday: 'Ends today',
    urgentDday: 'D-{days}',
    filterAll: 'All',
    listSection: 'All listings',
    empty: 'No transfers yet',
    emptyHint: 'Be the first to list a transfer.',
    viewDetail: 'View details',
    chat: 'Chat',
    chatFail: 'Could not start chat',
    trustBadge: 'Trust {tier}',
    comingSoonHint: 'Opening soon. Please check back.',
    stepLabel: 'Step {step}',
    fieldType: 'Booking type',
    fieldVenue: 'Venue name',
    fieldCheckIn: 'Check-in',
    fieldCheckOut: 'Check-out',
    fieldOriginalPrice: 'Original price (USD)',
    fieldPricePoints: 'Transfer price (points)',
    fieldProof: 'Booking confirmation (required)',
    fieldTitle: 'Title',
    fieldDescription: 'Description',
    fieldExpiry: 'Expiry date',
    regionAuto: 'Region: {region}',
    proofRequired: 'Please upload booking confirmation.',
    proofUploadFail: 'Proof upload failed.',
    proofCount: '{count} uploaded',
    legalRequired: 'Please accept the legal notice.',
    next: 'Next',
    back: 'Back',
    submit: 'Submit',
    writeSuccess: 'Transfer listed.',
    writeFail: 'Could not submit.',
    defaultTitle: 'Booking transfer',
    notFound: 'Transfer not found.',
    proofView: 'Booking proof',
    disputeDefault: 'Dispute report',
    disclaimer: 'This platform is not a party to the transaction. Verify details before you trade.',
    type: {
      hotel: 'Hotel',
      golf: 'Golf',
      restaurant: 'Restaurant',
      pool_villa: 'Pool villa',
      spa: 'Spa',
      activity: 'Activity',
      other: 'Other',
    },
    escrow: {
      lock: 'Buy with points',
      release: 'Complete trade',
      dispute: 'Report dispute',
      lockSuccess: 'Escrow locked.',
      lockFail: 'Escrow failed.',
      disputeSuccess: 'Dispute submitted.',
      disputeFail: 'Could not submit dispute.',
    },
  },
  succession: {
    title: 'Succession trade',
    write: 'List succession',
    writeTitle: 'List succession',
    detailTitle: 'Succession detail',
    filterAll: 'All',
    empty: 'No succession listings yet',
    emptyHint: 'List your first succession offer.',
    deposit: 'Deposit / premium',
    remainingMonths: '{months} months left',
    fieldType: 'Succession type',
    fieldTitle: 'Title',
    fieldRegion: 'Region',
    fieldDeposit: 'Deposit / premium',
    fieldMonthly: 'Monthly rent',
    fieldRemaining: 'Remaining term (months)',
    fieldProof: 'Contract (required)',
    landlordConsent: 'Landlord consent obtained',
    proofRequired: 'Please upload the contract.',
    proofUploadFail: 'Proof upload failed.',
    legalRequired: 'Please accept the legal notice.',
    legalAck: 'I have read and understood the notice',
    verificationHint: 'Higher seller verification means higher trust.',
    writeSuccess: 'Succession listed.',
    writeFail: 'Could not submit.',
    notFound: 'Succession not found.',
    disclaimer: 'This platform is not a party to the contract. Obtain landlord consent and verify in person.',
    type: {
      house: 'Home / room',
      business: 'Business',
      membership: 'Membership',
      vehicle: 'Vehicle',
      other: 'Other',
    },
  },
  businessRegisterHub: {
    title: 'Register business',
    lead: 'What type of business are you registering?',
    searchPlaceholder: 'Search categories',
    searchAria: 'Search categories',
    emptyCta: 'No results. Register as general business',
    inquiryLink: 'Registration inquiry',
    items: {
      food_mart: { label: 'Food & mart', desc: 'Restaurants, cafes, marts, delivery' },
      life: { label: 'Life services', desc: 'Cleaning, laundry, moving, errands' },
      travel: { label: 'Travel & stay', desc: 'Hotels, tours, activities' },
      realestate: { label: 'Real estate', desc: 'Rent, sale, commercial' },
      freelance: { label: 'Freelance & lessons', desc: 'Tutoring, design, translation' },
      interior: { label: 'Interior', desc: 'Construction, furniture, install' },
      repair: { label: 'Repair & service', desc: 'Appliances, vehicles, on-site repair' },
      jobs: { label: 'Jobs', desc: 'Job posts, job seeker profiles' },
      sports: { label: 'Sports & hobbies', desc: 'Golf, fitness, meetups' },
      business: { label: 'Business & admin', desc: 'Visa, legal, tax' },
      medical: { label: 'Medical & health', desc: 'Hospitals, dental, pharmacy' },
      education: { label: 'Education & childcare', desc: 'Academies, tutoring, childcare' },
      vehicles: { label: 'Vehicles', desc: 'Sales, rental, maintenance' },
      finance: { label: 'Finance', desc: 'Exchange, remittance, insurance' },
      class: { label: 'Classes & experiences', desc: 'One-day classes, cultural experiences' },
      creator: { label: 'Creator / media', desc: 'Live, webtoon, shorts' },
      pet: { label: 'Pets', desc: 'Pet shops, grooming, vet' },
      wedding: { label: 'Wedding & events', desc: 'Weddings, event planners' },
    },
  },
  businessRegister: {
    majorTitle: 'Main category',
    majorHint: 'Pick the closest match.',
    businessTypeTitle: 'Business type',
    businessTypeGeneral: 'General',
    businessTypeWholesale: 'Wholesale',
    businessTypeManufacturer: 'Manufacturer',
    manufacturerGuidePlaceholder: 'Describe your production process and delivery references.',
    wholesaleGuidePlaceholder: 'Describe your product lineup and unit-price guide.',
    moq: 'MOQ (minimum order quantity)',
    moqPlaceholder: 'e.g. 100',
    companyProfilePdfUrl: 'Company profile PDF URL',
    companyProfilePdfUrlPlaceholder: 'https://.../company-profile.pdf',
    certificationImageUrls: 'Certification image URLs',
    certificationImageUrlsPlaceholder: 'Separate multiple URLs with commas',
    productionCapacity: 'Production capacity',
    productionCapacityPlaceholder: 'e.g. 20,000 units/month, 3 lines',
    b2bTargetCategories: 'Priority target industries',
    b2bTargetCategoriesPlaceholder: 'e.g. cafe, bakery, restaurant',
    subTitle: 'Subcategories',
    subHint: 'You can select multiple items that apply.',
    needMajor: 'Please select a main category.',
    needSub: 'Please select at least one subcategory.',
    hospitalBanner: 'For hospital and medical listings, use My page → Business dashboard to register and manage.',
    hospitalCta: 'Open business dashboard',
  },
  quickRegister: {
    title: 'Quick business signup',
    lead: 'Just 5 fields — register in about 30 seconds',
    fieldName: 'Business name *',
    namePlaceholder: 'Enter business name',
    fieldMajor: 'Category *',
    fieldSub: 'Business types (multi-select)',
    subHint: 'Select all that apply. The first selection is your primary type.',
    subLoading: 'Loading business types…',
    tagsHint: 'Offerings / types (optional, up to 8) — or add your own',
    fieldContact: 'Contact *',
    contactPlaceholder: 'Phone, Kakao ID, Instagram, etc.',
    fieldPhoto: 'Cover photo',
    submit: 'Register',
    submitting: 'Registering…',
    successToast: 'Registered! Complete your profile to get more exposure.',
    claimBannerText: 'Already listed on Mingo? Find your business',
  },
  businessClaim: {
    title: 'Find my business',
    lead: 'If your business is already listed on Mingo as a sample, search for it and request to claim it. Once an admin approves, it will be linked to your account.',
    searchPlaceholder: 'Search by business name',
    searchBtn: 'Search',
    searching: 'Searching…',
    noResults: 'No matching business found.',
    goRegisterNew: 'Register a new business',
    thisIsMine: 'This is mine',
    myRequestsTitle: 'My requests',
    confirmTitle: 'Is this your business?',
    contactLabel: 'Contact',
    contactPlaceholder: 'Phone, Kakao ID, etc.',
    noteLabel: 'Note (optional)',
    notePlaceholder: 'Add business info or a way to verify you own it',
    reviewHint: 'Once an admin reviews and approves, it will be linked to your account.',
    submit: 'Submit request',
    submitting: 'Submitting…',
    requestSent: 'Request sent. It will be linked once an admin reviews it.',
    requestFailed: 'Request failed. Please try again.',
    status: {
      pending: 'Pending review',
      approved: 'Approved',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
  },
  delivery: {
    won: ' KRW',
    comingSoonTitle: 'Delivery in preparation',
    comingSoonDesc: 'Cart and order placement will open in a later update. Get notified when we launch.',
    waitlistCta: 'Notify me at launch',
    needLoginNotify: 'Please sign in to request a notification.',
    waitlistOk: "You're on the list. We'll let you know.",
    cartTitle: 'Cart',
    cartEmpty: 'Your cart is empty.',
    storeName: 'Store',
    deliveryFee: 'Delivery fee',
    pickupSelected: 'Pickup — no delivery fee for this order.',
    serviceType: 'Service',
    serviceDelivery: 'Delivery',
    servicePickup: 'Pickup',
    orderNote: 'Request to store',
    orderNotePh: 'e.g. No green onions',
    subtotal: 'Subtotal',
    grandTotal: 'Total',
    placeOrder: 'Place order',
    orderSoon: 'Order placement is in preparation. Thanks for your patience.',
    clearCart: 'Empty cart',
    clearCartOtherStore: 'Your cart has items from another store. Clear it and add this item?',
    addedToCart: 'Added to cart',
    addToCart: 'Add to cart',
    optionsTitle: 'Options',
    optRequired: 'Required',
    optSingle: 'Single',
    optMulti: 'Multi',
    fee: 'Fee',
    zoneOff: 'off',
    ordersTitle: 'Order history',
    noOrders: 'No orders yet.',
    activeOrders: 'In progress',
    pastOrders: 'Past orders',
    reorder: 'Reorder',
    writeReview: 'Write review',
    reorderEmpty: 'This order has no line items to reorder.',
    reorderDone: 'Items added to cart',
    reviewSoon: 'Reviews will be available in a later update.',
    stReceived: 'Order received',
    stPreparing: 'Preparing',
    stDelivering: 'On the way',
    stDone: 'Completed',
    stRejected: 'Cancelled',
    dashTitle: 'Store dashboard',
    dashNoBiz: 'No registered business yet.',
    dashSelectBiz: 'Store',
    dashNew: 'New orders',
    dashRevenue: "Today's sales",
    dashMonth: 'This month (completed)',
    dashAvgRating: 'Avg. listing rating',
    dashCalendar: 'Orders by date (7 days)',
    dashCouponTitle: 'Issue coupon',
    dashCouponPct: 'Discount %',
    dashCouponUntil: 'Valid until',
    dashCouponCreate: 'Save coupon',
    dashCouponSoon: 'Coupons will apply at checkout in a future update.',
    dashInbox: 'Inbox',
    dashAccept: 'Accept',
    dashReject: 'Reject',
    dashPipeline: 'Active orders',
    dashSoldout: 'Quick sold out',
    dashZones: 'Delivery zones',
    orderAccepted: 'Order accepted',
    orderRejected: 'Order rejected',
    statusUpdated: 'Status updated',
  },
  notifications: {
    title: 'Notifications',
    groupCommunity: 'Community',
    groupTrade: 'Trade',
    groupBusiness: 'Business',
    groupLocal: 'Local Info',
    groupMarketing: 'Marketing',
    groupSystem: 'System',
    rowChat: 'Chat Messages',
    descChat: 'When a new chat message arrives',
    rowComment: 'Comment Notifications',
    descComment: 'When someone comments on my post',
    rowLike: 'Comment Likes',
    descLike: 'When someone likes my comment',
    rowPostLike: 'Post Likes',
    descPostLike: 'When someone likes my post',
    rowFollow: 'New Followers',
    descFollow: 'When someone follows me',
    rowNewPost: 'New Local Posts',
    descNewPost: 'When new posts are added in my region',
    rowTradeInquiry: 'Trade Inquiry',
    descTradeInquiry: 'When someone inquires about my listing',
    rowTradeDone: 'Trade Complete',
    descTradeDone: 'When a trade is completed',
    rowPriceChange: 'Price Change',
    descPriceChange: 'When the price of a saved item changes',
    rowBizApproval: 'Business Approval',
    descBizApproval: 'When your business registration is reviewed',
    rowBizInquiry: 'Business Inquiry',
    descBizInquiry: 'When a new inquiry arrives for your business',
    rowBizReview: 'New Review',
    descBizReview: 'When a new review is posted for your business',
    rowBizBooking: 'New Booking',
    descBizBooking: 'When a new booking is made',
    rowExchangeAlert: 'Exchange Rate Alert',
    descExchangeAlert: 'When the exchange rate reaches your target',
    rowExpiryAlert: 'Expiry Reminder Alert',
    descExpiryAlert: 'When an expiry reminder is getting close',
    rowLocalNew: 'New Local Business',
    descLocalNew: 'When a new business is registered in my region',
    rowEmergency: 'Emergency Notice',
    descEmergency: 'Emergency and safety announcements',
    rowVisa: 'Visa & Admin',
    descVisa: 'When there is new visa-related information',
    rowScam: 'Scam Alert',
    descScam: 'When a scam alert is posted in your region',
    rowAd: 'Events & Promotions',
    descAd: 'Mingo events and business promotions',
    rowAds: 'Ads & promos',
    rowNoShowWarn: 'No-show Warning',
    descNoShowWarn: 'Warning when no-show count accumulates',
    rowSecurity: 'Account Security',
    descSecurity: 'Login and password change notifications',
    rowAnnouncement: 'Service Announcements',
    descAnnouncement: 'Maintenance and update notices',
    pushTitle: 'Browser push',
    pushAllow: 'Allow notifications',
    pushOn: 'Notifications enabled',
    pushDenied: 'Allow notifications for this site in browser settings.',
    pushUnsupported: 'This browser does not support push notifications.',
    pushDeniedHint: 'Enable notifications in settings to receive pushes.',
  },
  currencyExchange: {
    title: 'P2P currency exchange',
    writeTitle: 'New exchange post',
    writeHint: 'Match with people nearby. Always meet safely in public places.',
    needTitle: 'Please enter a title.',
    have: 'I have',
    want: 'I want',
    rateOptional: 'Offered rate (optional)',
    amountMin: 'Min amount (optional)',
    amountMax: 'Max amount (optional)',
    locationLabel: 'Meet-up area (optional)',
    rate: 'Rate',
    views: 'Views',
    doneN: 'Completions',
    badgeTop: 'Top',
    badgeUrgent: 'Urgent',
    badgeVerified: 'Verified',
    untitled: 'Exchange',
    reportThis: 'Report',
    reportToast: 'Thanks — our team reviews reports in the app admin tools.',
    reportCta: 'Report a problem',
    tab_all: 'All',
    tab_popular: 'Popular',
    tab_urgent: 'Urgent',
    tab_done: 'Done',
    filterVerified: 'Verified users only',
    filterRating: 'Min rating',
    filterAmtMin: 'Min amount',
    filterAmtMax: 'Max amount',
    empty: 'No posts yet.',
    safetyTitle: 'Safe exchange tips',
    safety1: 'Meet in a public place (café, mall lobby).',
    safety2: 'Start with a small test amount before large transfers.',
    safety3: 'Prefer verified profiles and clear written terms.',
    partnersTitle: 'Official partner services',
    partnersLead: 'Often better rates than cash exchange counters — compare before you meet.',
    partnersCta: 'Open official site',
    bannerSponsor: 'Send with {name} for less',
    bannerSub: 'Cheaper cross-border transfers — partner link',
    writeCta: 'New post',
    alertsCta: 'Rate alerts',
    premiumBlock: 'Premium (coming soon)',
    optTop: 'Pin to top — 10 credits/day',
    optUrgent: 'Urgent badge — 5 credits',
    optVerify: 'Verified exchanger — $5/mo',
    premiumNote: 'Paid options will be enabled when billing is connected.',
    detailTitle: 'Exchange post',
    completeCta: 'Mark deal done & review',
    ownerNote: 'You are the poster. Chat with responders to complete the deal.',
    reviewLogin: 'Log in to complete and review',
    reviewDialog: 'How was this deal?',
    reviewLead: 'Your review helps others stay safe.',
    reviewText: 'Comment (optional)',
    reviewThanks: 'Thanks for your review.',
    posterDefault: 'Member',
    legalNoticeTitle: 'Important',
    legalNoticeBody:
      'This board is for sharing P2P exchange information only. You transact at your own risk; Mingo is not involved. We recommend licensed or official exchange services.',
    writeRiskAgree: 'I understand the risks of private deals and agree',
    needRiskAgree: 'Please check the box to confirm you understand private-deal risks.',
    writeAmountHint: 'We recommend deals of $500 or less; start small when meeting someone new.',
    writeMeetHint: 'Meet in a public place and verify details before sending money.',
    reportAdminNote: 'After 3 reports, a post may be auto-hidden pending review.',
  },
  exchangeAlert: {
    title: 'Rate alerts',
    lead: 'Get an in-app notification when the rate crosses your target.',
    current: 'Current cross-rate (reference)',
    target: 'Target rate (1 unit of “have” in “want”)',
    above: 'Notify when at or above target (uncheck = when at or below)',
    premiumUnlimited: 'Free: 1 active alert. Premium: unlimited (coming in membership).',
    add: 'Save alert',
    saved: 'Alert saved.',
    limitFree: 'Free accounts can have 1 active alert. Remove one or upgrade later.',
    mine: 'My alerts',
    empty: 'No alerts yet.',
    remove: 'Remove',
    notified: 'Notified',
    inAppNote: 'We check rates when you open the app. Enable push in notification settings for the best experience.',
    loginHint: 'Log in to set alerts.',
  },
  adminExchange: {
    blockTitle: 'P2P currency exchange (admin)',
    listTitle: 'Recent posts',
    reportTitle: 'Reported (report_count > 0)',
    reportedCount: 'Posts with reports: {count}',
    reportEmpty: 'No reported posts in the loaded window.',
    partnersTitle: 'Partners',
    revenueTitle: 'Affiliate & revenue (reference)',
    revenueBody: 'Commission % is stored per partner. Clicks and conversions can be tracked in a future analytics build.',
    empty: 'No rows',
    thTitle: 'Title',
    thStatus: 'Status',
    thPrem: 'Premium',
    thViews: 'Views',
    thReports: 'Reports',
  },
  exchange: {
    title: 'FX calculator',
    hint: 'Default currency is guessed from your regions. Edit amount to convert.',
    base: 'Base currency',
    amount: 'Amount',
    refresh: 'Refresh rates',
    updated: 'Last update: {time}',
    loadError: 'Could not load rates. Try again later.',
    fallbackHint: 'Showing fixed reference rates.',
  },
  remittance: {
    heroTitle: 'International Remittance',
    heroDesc: 'Korea ↔ Vietnam remittance\nLowest fees · Fast transfer',
    registerDesc: 'Want to list a remittance service?',
    registerBtn: 'List Remittance Service',
    registerTitle: 'Register Remittance Service',
    stepBasic: 'Service Details',
    provider: 'Service Name',
    providerPlaceholder: 'e.g. Hana Money',
    desc: 'Description',
    descPlaceholder: 'Describe the service features and benefits',
    currencyPair: 'Currency Pair',
    from: 'From',
    to: 'To',
    exchangeRate: 'Exchange Rate',
    feeFixed: 'Fixed Fee',
    feePercent: '% Fee',
    minMax: 'Min/Max Amount',
    min: 'Min',
    max: 'Max',
    languages: 'Languages',
    stepContact: 'Contact & Confirm',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    affiliateLink: 'Service Link (optional)',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Pending admin review and approval',
    registerNotice2: 'Please keep exchange rates and fees updated',
    registerSuccess: 'Remittance service registered successfully',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
    calcTitle: 'Enter Amount',
    amountPlaceholder: 'Enter amount',
    youReceive: 'You Receive',
    fee: 'Fee',
    transferTime: 'Transfer Time',
    goToService: 'Go to Service',
    redirecting: 'Redirecting to service...',
    liveData: 'Live',
    pairKrwVnd: 'KRW → VND',
    pairKrwUsd: 'KRW → USD',
    pairUsdVnd: 'USD → VND',
    pairVndKrw: 'VND → KRW',
  },
  medicine: {
    title: 'Medicine Info',
    detailTitle: 'Medicine Detail',
    searchPlaceholder: 'Search Korean medicine name',
    notice: 'For reference only. Consult a pharmacist or doctor before use',
    empty: 'No results found',
    notFound: 'Medicine not found',
    localName: 'Local Medicine Name',
    ingredients: 'Ingredients',
    effects: 'Effects',
    dosage: 'Dosage',
    warnings: 'Warnings',
    rxRequired: 'Prescription Required',
    findPharmacy: 'Find Nearby Pharmacy',
    nameKo: 'Korean Name',
    catAll: 'All',
    catPainFever: 'Pain & Fever',
    catCold: 'Cold & Flu',
    catDigestive: 'Digestive',
    catSkin: 'Skin',
    catVitamin: 'Vitamins',
    catAllergy: 'Allergy',
    catDental: 'Dental',
    catEyeEar: 'Eye & Ear',
    catChronic: 'Chronic',
    catOther: 'Other',
  },
  myTrades: {
    title: 'My listings',
    tabs: { selling: 'Selling', reserved: 'Reserved', done: 'Sold' },
    empty: 'No items in this status.',
    markReserved: 'Mark reserved',
    backToSelling: 'Back to selling',
    markDone: 'Mark sold',
  },
  myFavorites: {
    title: 'Saved',
    empty: 'No saved items yet.',
    properties: 'Listings',
    products: 'Products',
    posts: 'Posts',
  },
  appSettings: {
    title: 'App settings',
    exchange: 'Exchange calculator',
    language: 'Language',
    region: 'Region',
    notifications: 'Notifications',
    privacy: 'Privacy policy',
    terms: 'Terms of service',
    version: 'App version',
    logout: 'Log out',
    withdraw: 'Delete account',
    loggedOut: 'Signed out.',
    withdrawConfirm: 'Delete your local data and sign out?',
    withdrawModalTitle: 'Delete account',
    withdrawModalBody: 'This clears saved settings on this device and signs you out. Continue?',
    withdrawModalBodyV2:
      'Your in-app data will be deleted from our database where possible, and you will be signed out. The email identity in our auth system may be removed separately. Continue?',
    withdrawConfirmBtn: 'Delete account',
    withdrawDone: 'Account data cleared.',
    withdrawFail: 'Could not complete full server deletion. You were signed out locally.',
  },
  editProfile: {
    title: 'Account settings',
    photoSection: 'Profile photo',
    changePhoto: 'Change profile photo',
    camera: 'Camera',
    gallery: 'Gallery',
    defaultAvatars: 'Default avatars',
    basicSection: 'Basic info',
    nickname: 'Nickname',
    name: 'Name',
    namePlaceholder: 'Real name (optional)',
    birthDate: 'Date of birth',
    genderLabel: 'Gender',
    genderSelect: 'Prefer not to say',
    genderMale: 'Male',
    genderFemale: 'Female',
    bio: 'Bio',
    bioPlaceholder: 'Short intro (50 characters)',
    contactSection: 'Contact',
    kakao: 'KakaoTalk ID',
    zalo: 'Zalo ID',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    phone: 'Phone (optional)',
    requestVerify: 'Request verify',
    verifyRequested: 'Verification request received',
    emailReadonly: 'Email',
    residenceSection: 'Residence',
    residenceCountry: 'Country',
    residenceCity: 'City / area',
    expatSince: 'Expat since (optional)',
    dateFormatHint: 'Year / Month / Day',
    nationalitySection: 'Nationality',
    selectNationality: 'Select nationality',
    languagesSection: 'Languages you use',
    spokenLang: {
      ko: 'Korean',
      en: 'English',
      vi: 'Vietnamese',
      ru: 'Russian',
      ja: 'Japanese',
      zh: 'Chinese',
      hi: 'Hindi',
    },
    visaSection: 'Visa',
    save: 'Save',
    saved: 'Saved.',
    loadFail: 'Could not load profile.',
    nicknameRequired: 'Please enter a nickname (at least one character).',
    photoUpdated: 'Profile photo updated.',
    photoSaveFail: 'Photo uploaded but not saved to your profile. Please try again.',
    avatarUpdated: 'Avatar applied.',
    visaDday: 'D-{n}',
    visaExpired: 'Expired',
    privateHint: 'Only you can see this. It is not shown on your public community profile.',
    profileGearCue: 'Use ⚙ to switch to My Info. Set notifications, expiry reminders, language, and region right under your profile.',
    editTabsAria: 'Profile sections',
    tabProfile: 'Profile',
    tabImportant: 'Important info',
    tabMyInfo: 'My info',
    tabMyInfoHint:
      'Manage contact channels, residence country/city, expat start date, nationality, memberships, and account actions here.',
    openMyInfoAria: 'Edit my info',
    closeMyInfoAria: 'Back to profile edit',
    settingsShortcuts: 'Alerts · expiry · language · region',
    openNotifications: 'Notifications (expiry, etc.)',
    openLanguage: 'App display language',
    openRegions: 'Regions of interest',
    openAppSettings: 'All app settings',
    emailSection: 'Login email',
    deadlinesAlertCue: 'These dates can later tie into reminders.',
    openMyBusiness: 'My business dashboard',
    regionUnset: 'No regions selected',
    cancel: 'Cancel',
    reverted: 'Changes reverted.',
    discardConfirm: 'You have unsaved changes. Leave this page?',
    nationalityCode: 'Nationality / origin (short)',
    nationalityPlaceholder: 'e.g. KR, Vietnam',
    visaTypeField: 'Visa / stay type',
    visaExpiryField: 'Visa / stay expiry',
    deadlinesSection: 'Dates & deadlines',
    deadlinesHelp: 'Passport, lease, rent day, etc. (We can hook these up to reminders later.)',
    deadlinesNeedAccount: 'Saved to your account after sign-in.',
    addDeadline: '+ Add item',
    removeDeadline: 'Remove',
    deadlineKindLabel: 'Type',
    deadlineTitle: 'Title',
    deadlineDue: 'Key date',
    remindDaysBefore: 'Remind N days before (0–365)',
    repeatRentDay: 'Repeat monthly on day (1–28, optional)',
    deadlineNeedDate: 'Please set a key date for rows that have a title.',
    accountSection: 'Account',
    deadlineKind: {
      passport: 'Passport',
      drivers_license: "Driver's / intl. permit",
      visa: 'Visa / stay',
      residence: 'Residence registration',
      lease: 'Home lease (contract end)',
      rent: 'Rent / fees due date',
      contract: 'Other contract',
      insurance: 'Insurance',
      flight: 'Travel / flight',
      school: 'School / course',
      other: 'Other',
    },
  },
  legal: {
    placeholderBody: '[LEGAL_PLACEHOLDER — document body will be injected externally]',
    privacyTitle: 'Privacy policy',
    termsTitle: 'Terms of service',
    privacyBody:
      'Mingo collects only the minimum data needed to run the service. Full policy text will be published later.',
    termsBody:
      'The service is in beta; terms may change. Please follow community and safety guidelines.',
  },
  adInquiry: {
    title: 'Advertising inquiry',
    lead: 'Tell us where you want to advertise and how to reach you.',
    scope: 'Ad tier',
    scopeNeighborhood: 'Neighborhood',
    scopeCity: 'City',
    scopeCountry: 'Country',
    scopeGlobal: 'Global',
    businessName: 'Business name',
    contact: 'Contact',
    message: 'Message',
    notice: 'We usually respond within 1–2 business days.',
    submit: 'Submit',
    sending: 'Sending…',
    done: 'Inquiry received.',
    needFields: 'Contact and message (3+ chars) are required.',
    adPaymentNav: 'Pay advertising fees online',
    chatConsult: 'Chat with us',
    chatConsultUnavailable: 'Not ready yet — please try again shortly.',
    pointsRequired: 'Points required: {pts} P',
    pointsBalanceLine: 'Your balance: {bal} P',
    pointsShortHint: 'Not enough points. Earn points or review payment options.',
    loginRequired: 'Sign in to submit with points.',
    submitPayPoints: 'Submit (deduct points)',
    submitFail: 'Submit failed. Please try again.',
    earnPointsLink: 'Earn points',
    b2bTargetPreview: 'Estimated owner reach with this B2B targeting: about {n}',
    previewGalleryTitle: 'Where your ad can show up',
    previewFeedCaption: 'Shows in screen feeds like chat and community, like this',
  },
  tradeReview: {
    title: 'Trade review',
    subtitle: 'This updates the other party’s trust score.',
    starsAria: 'Star rating',
    comment: 'Review',
    placeholder: 'Briefly describe the trade.',
    submit: 'Submit review',
  },
  sos: {
    title: 'Emergency help request',
    medical: 'Medical help',
    fraud: 'Fraud / crime',
    legal: 'Legal help',
    lost: 'Lost',
    accident: 'Accident',
    description: 'Situation description',
    location: 'Current location',
    contact: 'Contact',
    send: 'Request help',
    resolved: 'Resolved',
    tabSos: 'SOS Request',
    tabContacts: 'Emergency Contacts',
    locationPlaceholder: 'GPS or enter manually',
    helpersTitle: 'Nearby helpers (demo)',
    demoHelper1Name: 'Da Nang expat safety team',
    demoHelper1Help: 'Medical / lost & found',
    demoHelper1Dist: '1.2 km',
    demoHelper2Name: 'Mingo emergency supporter',
    demoHelper2Help: 'Interpretation / legal referral',
    demoHelper2Dist: '2.1 km',
    emergencyCallTitle: 'Emergency numbers',
    emergencyCallLine: 'Police 113 · Ambulance 115',
    casesTitle: 'Resolved SOS examples',
    demoCase1: 'Passport lost SOS → temporary steps within 35 min',
    demoCase2: 'ER escort request → interpretation support, visit completed',
    activeSosTitle: 'Active SOS requests',
  },
  referral: {
    myCode: 'My invite code',
    copy: 'Copy',
    copied: 'Copied!',
    share: 'Share',
    invited: 'Invited friends',
    reward: 'Received mingo',
    invite: 'Invite friends and earn mingo',
    inviterReward: '1,000 mingo for inviter',
    inviteeReward: '500 mingo for invitee',
  },
  coupon: {
    title: 'Coupon',
    enter: 'Enter coupon code',
    apply: 'Apply',
    invalid: 'Invalid coupon',
    used: 'Coupon already used',
    expired: 'Expired coupon',
  },
  academy: {
    title: 'Academies & classes',
    typeLanguage: 'Language School',
    typeMusic: 'Music School',
    typeArt: 'Art school',
    typeSports: 'Sports',
    typeTutor: 'Tutoring',
    typeCooking: 'Cooking class',
    typeCoding: 'Coding / IT',
    typeDance: 'Dance',
    typeYoga: 'Yoga / Pilates',
    typeExam: 'Test prep',
    typeCert: 'Certification',
    typeOther: 'Other',
    targetKids: 'Children',
    targetElementary: 'Elementary',
    targetTeen: 'Teenagers',
    targetAdult: 'Adults',
    targetSenior: 'Seniors',
    targetForeigner: 'Foreign residents',
    classPrivate: 'Private Lesson',
    classGroup: 'Group Class',
    classOnline: 'Online',
    classVisit: 'In-person visit',
    valueEmpty: '—',
    perHour: 'Per hour',
    perMonth: 'Monthly',
    trial: 'Trial class',
    curriculum: 'Curriculum',
    teachers: 'Teachers',
    schedule: 'Schedule',
    applyClass: 'Apply for class',
    selectSubject: 'Choose subject',
    selectType: 'Class format',
    selectSchedule: 'Preferred schedule',
    purposeLabel: 'Goals / current level',
    ratingTeacher: 'Teachers',
    ratingCurriculum: 'Curriculum',
    ratingFacility: 'Facility',
    ratingValue: 'Value for money',
    registerCta: 'List your academy',
    noAcademies: 'No academies yet',
    applicationSent: 'Your class request was sent!',
    searchPlaceholder: 'Search by name or subject',
    chipKorean: 'Korean OK',
    chipOnline: 'Online OK',
    chipVerified: 'Verified',
    onlineShort: 'Online',
    newShort: 'New',
    verified: 'Verified',
    reviewCount: '{n} reviews',
    favorited: 'Saved to favorites',
    unfavorited: 'Removed from favorites',
    favorite: 'Save',
    demoFavorite: 'Demo listings cannot be favorited',
    inquiryShort: 'Contact',
    classInfo: 'Class info',
    languages: 'Languages',
    targets: 'Age groups',
    formats: 'Formats',
    hours: 'Class hours',
    teacherCount: 'Teachers',
    pricing: 'Pricing',
    location: 'Location & facility',
    hoursSection: 'Opening hours',
    weekday: 'Weekdays',
    weekend: 'Weekends',
    registerFlowTitle: 'Register academy',
    stepLabel: 'Step {cur} of {total}',
    courseName: 'Subject name',
    levelBeginner: 'Beginner',
    levelMid: 'Intermediate',
    levelAdv: 'Advanced',
    levelAll: 'All levels',
    durationMin: 'Duration (min)',
    priceHour: 'Hourly rate (USD)',
    addCourse: 'Add subject',
    namePlaceholder: 'Academy name',
    descPlaceholder: 'Description',
    country: 'Country code',
    city: 'City',
    address: 'Address',
    teacherName: 'Teacher name',
    teacherSubjects: 'Specialties (comma-separated)',
    teacherExp: 'Experience',
    teacherLangs: 'Languages (comma-separated)',
    teacherPhotoUrl: 'Profile photo URL',
    addTeacher: 'Add teacher',
    trialOffer: 'Offer trial class',
    photoUrl: 'Photo URL {n}',
    exposureTier: 'Visibility tier',
    tierStandard: 'Standard',
    tierPlus: 'Plus',
    registerOk: 'Academy registered',
    registerDemoOk: 'Demo mode: registration simulated',
    langKo: '🇰🇷 Korean',
    langEn: '🇺🇸 English',
    langVi: '🇻🇳 Vietnamese',
    langRu: '🇷🇺 Russian',
    langJa: '🇯🇵 Japanese',
    register: {
      typeArt: 'Art School',
      typeSports: 'Sports',
      typeMath: 'Math',
      typeScience: 'Science',
      typeCoding: 'Coding',
      typeTutoring: 'Tutoring',
      stepCurriculum: 'Curriculum',
      stepTuition: 'Tuition',
      stepInstructor: 'Instructor',
      onlineAvailable: 'Online Available',
    },
  },
  education: {
    title: 'Education Guide',
    tabSchool: 'Schools',
    tabAcademy: 'Academies',
    tabTutoring: 'Tutoring',
    tabInfo: 'Info',
    schoolDesc: 'Find schools in Da Nang, Hanoi, and Ho Chi Minh City',
    academyDesc: 'Find language, math, and other academies',
    tutoringDesc: 'Find private tutors for your child',
    goToSchoolList: 'View School List',
    goToAcademy: 'View Academy List',
    goToTutoring: 'Find Tutors',
    typeInternational: 'International',
    typeKorean: 'Korean School',
    typeLocal: 'Local School',
    typeHomeschool: 'Homeschool',
    infoAdmission: 'Admission Season',
    infoAdmissionDesc: 'International school admission timeline and requirements',
    infoTuition: 'Tuition Guide',
    infoTuitionDesc: 'Average tuition by school type',
    infoCurriculum: 'Curriculum Comparison',
    infoCurriculumDesc: 'Compare IB, AP, Korean, and Vietnamese curricula',
    infoConsult: 'Academy Consultation',
    infoConsultDesc: 'Register for academies or find tutors',
  },
  villa: {
    title: 'Pool Villa',
    heroTitle: 'Private Pool Villas',
    heroDesc: 'Expat special pool villas · Direct · No commission',
    searchPlaceholder: 'Search by name or location',
    guests: 'Guests',
    guestsUnit: ' guests',
    typeAll: 'All',
    typePrivate: 'Private',
    typeShared: 'Shared',
    typeBeach: 'Beachside',
    typeMountain: 'Mountain View',
    sortRecommended: 'Recommended',
    sortPriceAsc: 'Price: Low to High',
    sortRating: 'Top Rated',
    count: '{n} villas',
    empty: 'No pool villas found',
    verified: 'Verified',
    bedrooms: ' beds',
    maxGuests: 'Max {n} guests',
    perNight: 'night',
    notFound: 'Villa not found',
    reviews: 'reviews',
    bathrooms: 'baths',
    poolSize: 'Pool Size',
    pricePerNight: 'Per Night',
    pricePerWeek: 'Per Week',
    checkInOut: 'Check-in / Check-out',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    minStay: 'Minimum {n} nights',
    amenities: 'Amenities',
    description: 'Description',
    ownerMenu: 'Manage',
    editVilla: 'Edit Villa',
    inquirySent: 'Starting inquiry chat',
    inquiryBtn: 'Inquire',
    registerTitle: 'Register Pool Villa',
    stepType: 'What type of villa?',
    stepBasic: 'Basic Info',
    stepPrice: 'Price & Operations',
    stepContact: 'Contact & Confirm',
    villaName: 'Villa Name',
    villaNamePlaceholder: 'e.g. My Khe Beach Private Pool Villa',
    location: 'Location',
    locationPlaceholder: 'e.g. Near My Khe Beach, Da Nang',
    address: 'Address',
    addressPlaceholder: 'Full address (optional)',
    maxGuestsLabel: 'Max Guests',
    poolType: 'Pool Type',
    descriptionPlaceholder: 'Describe your villa, surroundings, and highlights',
    minStayLabel: 'Minimum Stay',
    nights: 'nights',
    contactPhone: 'Phone',
    contactKakao: 'KakaoTalk',
    contactZalo: 'Zalo',
    registerNoticeTitle: 'Before Registering',
    registerNotice1: 'Your listing will be reviewed and approved by Mingo admin',
    registerNotice2: 'False information may result in account restrictions',
    registerNotice3: 'Inquiries are connected directly via chat',
    registerSuccess: 'Villa registered. Pending admin approval',
    registerFail: 'Registration failed',
    registerSubmit: 'Submit Registration',
    registerDesc: 'Running a pool villa?',
    registerBtn: 'Register Your Villa',
  },
  interior: {
    registerTitle: 'Register Interior Business',
    stepWorkType: 'What type of work do you do?',
    stepWorkTypeDesc: 'Multiple selection allowed',
    specialties: 'Specialties',
    stepBasic: 'Basic Business Info',
    bizName: 'Business Name',
    bizNamePlaceholder: 'e.g. Da Nang Interior Pro',
    contact: 'Contact',
    address: 'Address',
    addressPlaceholder: 'Office or work area',
    hours: 'Business Hours',
    languages: 'Languages',
    description: 'About',
    descriptionPlaceholder: 'Describe your experience, portfolio, and strengths',
    stepScope: 'Scope & Pricing',
    areaRange: 'Work Area Range',
    priceRange: 'Price Range',
    responseRate: 'Response Rate',
    stepConfirm: 'Confirm Registration',
    registerNoticeTitle: 'Registration Notice',
    registerNotice1: 'Your listing will be reviewed by Mingo admin',
    registerNotice2: 'False information may result in account restrictions',
    registerNotice3: 'Approved listings will appear in the interior directory',
    registerSuccess: 'Registration submitted. Pending admin approval',
    registerFail: 'Registration failed. Please try again',
    registerSubmit: 'Submit Registration',
  },
  restaurant: {
    title: 'Restaurants',
    typeKorean: '🍜 Korean',
    typeJapanese: '🍣 Japanese',
    typeChinese: '🥢 Chinese',
    typeWestern: '🍝 Western',
    typeVietnamese: '🍜 Vietnamese',
    typeItalian: '🍕 Italian',
    typeMexican: '🌮 Mexican',
    typeIndian: '🍛 Indian',
    typeFusion: '🍱 Fusion',
    typeCafe: '☕ Cafe',
    typeBar: '🍺 Bar / Pub',
    typeBakery: '🥐 Bakery',
    typeFastFood: '🍔 Fast food',
    typeOther: '🍽️ Other',
    priceBudget: 'Budget',
    priceMedium: 'Moderate',
    priceExpensive: 'Upscale',
    priceLuxury: 'Luxury',
    priceCard_budget: '💚 Budget (under $5 / person)',
    priceCard_medium: '💛 Moderate ($5–15)',
    priceCard_expensive: '🧡 Upscale ($15–30)',
    priceCard_luxury: '❤️ Luxury ($30+)',
    delivery: 'Delivery',
    reservation: 'Reservations',
    parking: 'Parking',
    koreanFriendly: 'Korean OK',
    verified: 'Verified',
    ratingTaste: 'Taste',
    ratingService: 'Service',
    ratingPrice: 'Value',
    ratingAtmosphere: 'Atmosphere',
    menu: 'Menu',
    popularMenu: 'Popular',
    reserveNow: 'Reserve',
    selectDate: 'Pick a date',
    selectTime: 'Pick a time',
    partySize: 'Guests',
    requests: 'Requests',
    registerCta: 'Add restaurant',
    noRestaurants: 'No restaurants yet',
    reservationConfirmed: 'Your reservation is confirmed!',
    searchPlaceholder: 'Search name or cuisine',
    openNow: 'Open',
    closedNow: 'Closed',
    reviewCount: '{n} reviews',
    menuPreview: 'Signature dishes',
    priceFilter: 'Price',
    favorited: 'Saved',
    unfavorited: 'Removed',
    favorite: 'Save',
    favoriteShort: 'Save',
    demoFavorite: 'Demo: favorite is local only',
    galleryAll: 'View all {n} photos',
    galleryTitle: 'All photos',
    keyInfo: 'Quick facts',
    hours: 'Hours',
    location: 'Location',
    phone: 'Phone',
    languages: 'Languages',
    payment: 'Payment',
    locationSection: 'Location',
    mapPreview: 'Open in Maps',
    hoursSection: 'Hours',
    closedDays: 'Closed on',
    todayStatus: 'Today',
    confirmReservation: 'Confirm reservation',
    fillDateTime: 'Please pick date and time',
    yes: 'Yes',
    no: 'No',
    registerFlowTitle: 'Register restaurant',
    stepLabel: 'Step {cur} / {total}',
    register: {
      stepLabel: 'Step',
      typeKorean: 'Korean',
      typeJapanese: 'Japanese',
      typeChinese: 'Chinese',
      typeWestern: 'Western',
      typeVietnamese: 'Vietnamese',
      typeItalian: 'Italian',
      typeMexican: 'Mexican',
      typeIndian: 'Indian',
      typeFusion: 'Fusion',
      typeCafe: 'Cafe',
      typeBar: 'Bar/Pub',
      typeBakery: 'Bakery',
      typeFastFood: 'Fast Food',
      typeOther: 'Other',
      priceLow: 'Budget',
      priceMid: 'Moderate',
      priceHigh: 'Fine Dining',
      priceLuxury: 'Luxury',
    },
    registerOk: 'Restaurant submitted',
    registerDemoOk: 'Demo mode: registration simulated',
    nameLabel: 'Restaurant name',
    descLabel: 'Description',
    menuTagsLabel: 'Signature dishes / tags',
    menuTagsPh: 'e.g. bulgogi, pho',
    open24: 'Open 24 hours',
    closedDaysLabel: 'Closed days',
    amenityCard: 'Cards accepted',
    amenityGroup: 'Group seating',
    amenityAlcohol: 'Alcohol',
    amenityNonsmoke: 'Non-smoking area',
    langKo: '🇰🇷 Korean',
    langEn: '🇺🇸 English',
    langVi: '🇻🇳 Vietnamese',
    langRu: '🇷🇺 Russian',
    langJa: '🇯🇵 Japanese',
    menuName: 'Item name',
    menuPrice: 'Price (USD)',
    menuDesc: 'Description',
    menuImageUrl: 'Image URL',
    addMenu: 'Add menu item',
    photoExterior: 'Exterior photo URL',
    photoInterior: 'Interior photo URL',
    photoFood: 'Food photo URL',
    photoMenuBoard: 'Menu board URL',
    phoneLabel: 'Phone',
    kakaoLabel: 'KakaoTalk ID',
    instaLabel: 'Instagram',
    webLabel: 'Website',
  },
  businessInbox: {
    title: 'Inquiry inbox',
    all: 'All',
    unread: 'Unread',
    booking: 'Booking',
    general: 'General',
    done: 'Done',
    empty: 'No inquiries yet',
    emptyDesc: 'Keep your business profile fresh to get more inquiries.',
    replyChat: 'Reply in chat',
    replyCall: 'Call',
    markDone: 'Mark complete',
    newInquiry: 'You have a new inquiry.',
    inquiryType: 'Inquiry type',
    typeBooking: 'Booking request',
    typeGeneral: 'General question',
    typeQuote: 'Quote request',
    filter: 'Filter',
    filterByBusiness: 'Filter by business',
    allBusinesses: 'All businesses',
    detailTitle: 'Inquiry detail',
    sentAt: 'Received at',
    message: 'Message',
    statusPending: 'Pending',
    statusRead: 'Read',
    statusClosed: 'Resolved',
    noPhone: 'No phone number on file.',
    send: 'Send',
    viewAll: 'View all inquiries',
    guideNoOwner: 'Inquiries are not available until this guide is linked to an account.',
    inquirySent: 'Your inquiry was sent.',
    hotelNoBusiness: 'This host is not linked to a business profile yet, so inquiries are unavailable.',
    visaTab: '🛂 Visa inquiries',
    visaInquiryPreview: 'Message',
    visaReply: 'Reply in chat',
    academyTab: '🎓 Class requests',
    academySubject: 'Subject',
    academyFormat: 'Format',
    academySchedule: 'Preferred time',
    academyConfirm: 'Confirm',
    academyReject: 'Decline',
    academyStatusPending: 'Pending',
    academyStatusConfirmed: 'Confirmed',
    academyStatusRejected: 'Declined',
    restaurantTab: '🍜 Reservations',
    restaurantConfirm: 'Confirm',
    restaurantReject: 'Decline',
    restaurantStatusPending: 'Pending',
    restaurantStatusConfirmed: 'Confirmed',
    restaurantStatusRejected: 'Declined',
    restaurantParty: 'Party size',
    restaurantNotes: 'Notes',
    restaurantWhen: 'Date & time',
  },
  biz: {
    tabOverview: 'Overview',
    tabManage: 'Manage',
    tabAds: 'Ads',
    tabShorts: 'AI Shorts',
    tabPlan: 'Plan',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    planFreePrice: 'Free',
    perMonth: 'mo',
    planFreeF1: 'Business profile listing',
    planFreeF2: 'Basic exposure',
    planFreeF3: 'Chat inquiries',
    planBasicF1: 'All free features',
    planBasicF2: 'Statistics dashboard',
    planBasicF3: 'Review management',
    planBasicF4: 'Unlimited photo uploads',
    planPremiumF1: 'All basic features',
    planPremiumF2: 'AI Shorts auto-generation x4/month',
    planPremiumF3: 'Priority search placement',
    planPremiumF4: 'Auto Mingo Story upload',
    planPremiumF5: 'Monthly performance report',
    planTitle: 'Subscription Plan',
    currentPlan: 'Current Plan',
    planExpires: 'Expires',
    planRecommended: 'Recommended',
    planUpgrade: 'Upgrade',
    planDowngrade: 'Downgrade',
    planCurrent: 'Current Plan',
    planUpgraded: 'Plan updated successfully',
    planShortsLine: 'AI Shorts {n}/month',
    shortsLockedTitle: 'AI Shorts is Premium only',
    shortsLockedDesc: 'We auto-generate 4 AI Shorts monthly. Just provide photos and text.',
    upgradeToPremium: 'Upgrade to Premium',
    shortsUsage: 'This month',
    shortsPerMonth: '/month',
    requestShorts: 'Request Shorts',
    shortsEmpty: 'No shorts generated yet',
    shortsPending: 'Pending',
    shortsProcessing: 'Processing',
    shortsCompleted: 'Completed',
    shortsFailed: 'Failed',
    requestShortsTitle: 'Request AI Shorts',
    shortsText: 'Business intro / promo text',
    shortsTextPlaceholder: 'Enter business features, events, or promotional content',
    shortsRequested: 'AI Shorts requested. You will be notified when ready',
    requestShortsSubmit: 'Submit Request',
    myAdsSummary: 'My Ad Performance',
    totalImpressions: 'Impressions',
    totalClicks: 'Clicks',
    activeAds: 'Active Ads',
    noAds: 'No ads registered yet',
    adActive: 'Active',
    adPending: 'Pending',
    adInactive: 'Inactive',
  },
  dashboard: {
    title: 'Business dashboard',
    myBusinesses: 'My businesses',
    manage: 'Manage',
    managePanel: 'Business management',
    noBusiness: 'No registered businesses',
    stats: 'Statistics',
    statsSummary: 'Summary statistics',
    periodStats: 'Performance by period',
    statsViewsToday: 'Views today',
    statsViews7d: 'Views (7 days)',
    statsViews30d: 'Views (30 days)',
    statsInquiry: 'Inquiries',
    statsFavorite: 'Favorites',
    statsReview: 'Reviews',
    reviews: 'Review management',
    reviewsUnifiedHint: 'Only unified listing reviews (public.reviews) are shown here. Domain-specific reviews (hospital, restaurant, etc.) appear on each listing’s page.',
    reviewsEmpty: 'No reviews yet',
    ownerReply: 'Owner reply',
    writeReply: 'Write reply',
    reportReview: 'Report',
    replyPlaceholder: 'Write a reply',
    businessName: 'Business name',
    category: 'Category',
    nameChangeHint: 'Changing the name requires re-review',
    categoryChangeHint: 'Changing the category requires re-review',
    photos: 'Photos',
    photosPlaceholder: 'One image URL per line',
    hours: 'Business hours',
    description: 'Description',
    contact: 'Contact',
    editInfo: 'Edit profile',
    today: 'Today',
    week: 'This week',
    month: 'This month',
    views: 'Views',
    orders: 'Orders',
    revenue: 'Revenue',
    rating: 'Rating',
    ads: 'Ad management',
    newAd: 'Create ad',
    impressions: 'Impressions',
    clicks: 'Clicks',
    ctr: 'CTR',
    notifications: 'Notifications',
    inquirySection: 'Inquiries',
    inquiryUnread: 'Unread inquiries',
    inquiryRecent: 'Recent inquiries',
    inquiryViewAll: 'View all inquiries',
    bookings: 'Bookings',
    noShow: 'Report no-show',
  },
  subscription: {
    title: 'Subscription plans',
    current: 'Current plan',
    upgrade: 'Upgrade',
    expires: 'Expires',
    free: 'Free',
    silver: 'Silver',
    gold: 'Gold',
    business: 'Business',
    commission: 'Commission',
    commissionHistory: 'Commission history',
    adCredit: 'Ad credit',
    convertPoints: 'Convert points to credits',
    adPromote: 'Promote my business',
    adPromoteBtn: 'Start advertising',
  },
  guide: {
    title: 'Expat guide',
    verified: 'Verified guide',
    book: 'Book now',
    chat: 'Chat',
    halfDay: 'Half-day',
    fullDay: 'Full-day',
    custom: 'Custom',
    reviews: 'Reviews',
    rating: 'Rating',
    languages: 'Languages',
    regions: 'Regions',
    priceFrom: 'from',
    noGuides: 'No guides available yet',
    emptyListTitle: 'No guides registered yet',
    emptyListDescription: 'We are preparing guide onboarding. Check back soon!',
    filterAllRegions: 'All regions',
    filterAllLangs: 'All languages',
    filterAllTours: 'All tour types',
    regionDaNang: 'Da Nang',
    regionHoiAn: 'Hoi An',
    regionHue: 'Hue',
    langKorean: 'Korean',
    langEnglish: 'English',
    langRussian: 'Russian',
    langVietnamese: 'Vietnamese',
    emptyFilterHint: 'Try changing region or language filters.',
    verifiedPill: '✓ Verified guide',
    expertiseRegion: 'Focus area: {region}',
    priceHalfFull: 'Half-day {half} / Full-day {full}',
    demoGuide1Name: 'Kim Min-su',
    demoGuide1Intro: 'Da Nang local food, night market, and downtown routes.',
    demoGuide2Name: 'Natasha',
    demoGuide2Intro: 'Hoi An old town, night views, and photo-spot tours.',
    demoGuide3Name: 'Tran Van Nam',
    demoGuide3Intro: 'Hue royal palace and history tours on a flexible schedule.',
    register: {
      title: 'Register as Guide',
      stepServiceType: 'Service Type',
      stepBasicInfo: 'Basic Info',
      stepRegion: 'Activity Region',
      stepLanguage: 'Languages',
      stepService: 'Service Info',
      stepPricing: 'Pricing',
      stepCareer: 'Career',
      stepPhotos: 'Photos',
      stepConfirm: 'Confirm',
      namePlaceholder: 'Enter your name',
      nationalityPlaceholder: 'Enter your nationality',
      regionPlaceholder: 'Enter activity regions',
      descriptionPlaceholder: 'Describe your service',
      careerPlaceholder: 'Enter career and qualifications',
      submit: 'Register',
      typeTour: 'Tour Guide',
      typeInterpreter: 'Interpreter',
      typeAirport: 'Airport Pickup',
      typeCompanion: 'Companion',
      typeOther: 'Other',
      priceHourly: 'Per Hour',
      priceHalfDay: 'Half Day',
      priceFullDay: 'Full Day',
      lang: {
        korean: 'Korean',
        english: 'English',
        vietnamese: 'Vietnamese',
        russian: 'Russian',
        japanese: 'Japanese',
        chinese: 'Chinese',
        other: 'Other',
      },
    },
  },
  property: {
    inquirySentToast: 'Your inquiry was sent.',
    footerWish: 'Save',
    wishlisted: 'Saved to your list',
    unwishlisted: 'Removed from saved',
    footerCall: 'Call',
    footerChat: 'Chat',
    noPhone: 'No phone number on file.',
    dashTitle: 'Listings',
    dashRegister: 'Add listing',
    dashStatusFilter: 'Listing status',
    dashStatusAll: 'All',
    dashEmpty: 'No listings yet',
    dashEmptySub: 'Published listings appear on /real-estate',
    dashEmptySubPersonal: 'Landlord and tenant listings appear on /real-estate',
    myListingsSub: 'Manage all your listings — personal and business — in one place',
    dashLoadFailed: 'Could not load your listings.',
    dashFirstRegister: 'Add first listing',
    dashFilterEmpty: 'No listings match this filter',
    dashShowAll: 'Show all',
    dashOwnerBarTitle: 'Manage your listing',
    dashEdit: 'Edit',
    dashView: 'View',
    dashDelete: 'Delete',
    dashTradeComplete: 'Deal done',
    dashDeleteConfirm: 'Delete this listing? It will be hidden from your dashboard.',
    dashDeleteDone: 'Listing deleted.',
    dashDeleteFailed: 'Could not delete listing.',
    dashTradeConfirmTitle: 'Mark this deal complete?',
    dashTradeConfirmBody: 'It will be hidden from the public list and shown as completed.',
    dashTradeDone: 'Marked as deal complete.',
    dashBoost7: 'Boost 7 days ({price}P)',
    dashBoost14: 'Boost 14 days ({price}P)',
    dashBoostActive: 'Boosted until {date}',
    dashBoostSuccess: 'Listing boosted to the top.',
    dashBoostFail: 'Boost failed.',
    dashBoostInsufficientCredit: 'Not enough ad credit.',
    statusPublished: 'Live',
    statusPendingReview: 'In review',
    statusHidden: 'Hidden',
    statusDraft: 'Draft',
    statusCompleted: 'Deal complete',
    dealCompletedNote: 'This listing has been completed.',
    detailTitle: 'Listing details',
    optionsSelectedOnly: 'Only options selected when listing was created.',
    hubListingsTitle: 'Listed properties',
    hubListingsSub: 'Individual and business listings appear here and on /real-estate',
    hubBrowseAll: 'View all',
    hubListingsEmpty: 'No public listings yet. Be the first to list.',
    footerInquiryShort: '✉️ Inquiry',
    inquiryModalTitle: 'Property inquiry',
    inquiryTypeLabel: 'Inquiry type',
    inquiryTypeRent: '🔑 Rental inquiry',
    inquiryTypeVisit: '📅 Visit booking',
    inquiryTypeGeneral: '💬 General inquiry',
    inquiryMoveInLabel: 'Preferred move-in date',
    inquiryMessageLabel: 'Message',
    inquiryMessagePlaceholder: 'Enter your inquiry (3+ characters).',
    inquiryCancel: 'Cancel',
    inquirySending: 'Sending…',
    inquirySend: 'Send',
    availabilityButton: 'Still available?',
    availabilityCount: '{n} availability checks',
    availabilitySentToast: 'Availability check sent. The host will be notified.',
    availabilityInquiryMessage: 'Is this listing still available?',
  },
  serviceMenu: {
    profileFallback: 'My profile',
    ariaProfile: 'My profile',
    followCounts: 'Following {following} · Followers {followers}',
    loginSignup: 'Log in / Sign up',
  },
  expatInfo: {
    title: 'Expat Essential Guide',
    heroTitle: 'Expat Essential Guide',
    heroDesc: 'Visa, medical, legal, settlement\nAll you need for life abroad',
    essentialTitle: 'Essential Shortcuts',
    searchPlaceholder: 'Search visa, medical, legal...',
    noResults: 'No results found',
    urgentTitle: 'Urgent Information',
    urgentDesc: 'Check immediately in case of emergency',
    categoriesTitle: 'Browse by Category',
    featuredTitle: 'Must-Know Information',
    empty: 'No information available',
    emptyHint: 'More information will be added soon',
    guideCount: '{n} guides',
    notFound: 'Not found',
    urgent: 'Urgent',
    lastVerified: 'Last verified',
    outdatedWarning: 'This information may be outdated',
    linkCopied: 'Link copied',
    bookmark: 'Bookmark',
    bookmarkAdded: 'Bookmarked',
    bookmarkRemoved: 'Bookmark removed',
    reportOutdated: 'Outdated? Report it',
    reportSent: 'Report submitted',
    relatedFeatures: 'Related Features',
    relatedLinks: 'Related Links',
    quick: {
      passportLoss: 'Lost Passport',
      accident: 'Accident',
      medical: 'Medical',
      visa: 'Visa',
      legal: 'Legal',
      settle: 'Settlement',
      fraud: 'Fraud',
    },
    cat: {
      visa: 'Visa & Stay',
      emergency: 'Emergency',
      medical: 'Medical',
      legal: 'Legal',
      family: 'Family',
      settle: 'Settlement',
      finance: 'Finance',
      embassy: 'Embassy',
    },
    essential: {
      visaStay: {
        title: 'Visa & Stay',
        desc: 'Visa rules, stay status, extensions',
      },
      legalAdmin: {
        title: 'Legal & Admin',
        desc: 'Documents, reporting, basic legal steps',
      },
      schoolInfo: {
        title: 'School Info',
        desc: 'International schools and enrollment',
      },
      medicineInfo: {
        title: 'Medicine Info',
        desc: 'Pharmacy guidance and OTC medicine',
      },
      repatriateInfo: {
        title: 'Repatriation Info',
        desc: 'Return prep, paperwork, and relocation checklist',
      },
    },
    legalAdminPage: {
      title: 'Legal & Admin Essentials',
      subtitle: 'Frequently used legal and admin tasks for expat life',
      coreTasksTitle: 'Quick Access',
      cards: {
        visa: {
          title: 'Visa & Stay Check',
          desc: 'Review visa status, type, and latest guidance',
        },
        expiry: {
          title: 'Expiry Reminders',
          desc: 'Track visa, passport, and permit deadlines',
        },
        privacy: {
          title: 'Privacy & Terms',
          desc: 'Review core legal documents for service use',
        },
        sos: {
          title: 'Emergency Request',
          desc: 'Request help quickly in urgent situations',
        },
      },
    },
    schoolInfoPage: {
      title: 'Basic School Information',
      subtitle: 'Guide to Korean, international, and local schools',
      typesTitle: 'School Types at a Glance',
      types: {
        korean: {
          icon: '🇰🇷',
          title: 'Korean School',
          desc: 'Based on Korean curriculum with smoother adaptation',
          point1: 'Often easier to align when returning to Korea',
          point2: 'Check local availability and waiting lists early',
        },
        international: {
          icon: '🌍',
          title: 'International School',
          desc: 'English-based curricula such as IB/AP are common',
          point1: 'Confirm tuition, entrance tests, and language criteria',
          point2: 'Compare university track and extracurricular options',
        },
        local: {
          icon: '🇻🇳',
          title: 'Local School',
          desc: 'Strong local language and culture immersion with lower cost',
          point1: 'Prepare a language adaptation plan in advance',
          point2: 'Review commute distance and school calendar differences',
        },
      },
      checklistTitle: 'Pre-Admission Checklist',
      checklist: {
        admission: {
          title: 'Admission Timeline',
          item1: 'Check term start dates, deadlines, and exams',
          item2: 'Confirm transfer policy and seat availability',
        },
        documents: {
          title: 'Documents',
          item1: 'Prepare passport, visa, vaccine records, and transcripts',
          item2: 'Check notarization/translation requirements early',
        },
      },
      openSchoolList: 'Open School List',
    },
  },

  local: {
    title: 'Local info',
    subtitle: 'Everything for life abroad',
    allServices: 'All Services',
    catTrade: 'Trade & Shopping',
    catLife: 'Life & Services',
    catSports: 'Sports & Leisure',
    catBooking: 'Booking & Tickets',
    catMedical: 'Medical & Education',
    catFreelance: 'Freelance & Talent',
    catBusiness: 'Business & Pro',
    catCreator: 'Creator',
    catCommunity: 'Community',
    emergencySection: '🆘 Emergency & Safety',
    sectionEmergency: '🆘 Emergency',
    sectionBusiness: '📋 Local Services',
    businessSection: '🏪 Local Services',
    sectionInfo: '📖 Expat Info',
    sectionCommunity: '👥 Community Life',
    communitySection: '👥 Expat Life',
    hospital: 'Hospital / Pharmacy',
    food: 'Food',
    visa: 'Visa / Admin',
    beauty: 'Beauty / Massage',
    move: 'Cleaning / moving',
    realestate: 'Real estate',
    repatriate: 'Repatriation',
    rental: 'Rental',
    professional: 'Tax / Legal / Pro',
    academy: 'Academy',
    activity: 'Activities & leisure',
    visaAgency: 'Visa agencies',
    pet: 'Pets',
    petLabel: 'Pet Services',
    koreanShop: 'Korean products',
    wedding: 'Wedding',
    mentoring: 'Mentoring',
    news: 'Expat News',
    airportPickup: 'Airport pickup',
    carpool: 'Carpool',
    insurance: 'Insurance',
    remittance: 'Remittance',
    deals: 'Group Deals',
    settlement: 'Settlement packs',
    fitness: 'Gym / fitness',
    educationConsult: 'School consultants',
    golf: 'Golf & Membership',
    poolVilla: 'Pool Villa',
    medicalTourism: 'Medical tourism',
    boat: 'Yacht / boat',
    photo: 'Photo / video',
    eventPlanner: 'Event planning',
    digital: 'IT / digital',
    tours: 'Tours / packages',
    interior: 'Interior',
    subscription: 'Subscription box',
    coworking: 'Coworking',
    cooking: 'Recipes',
    visaRun: 'Visa Run',
    businessTransfer: 'Business Transfer',
    supermarket: 'Supermarket / mart',
    dental: 'Dental clinic',
    laundry: 'Laundry',
    repair: 'A/C & appliance repair',
    babysitter: 'Babysitter / childcare',
    translation: 'Interpretation / translation',
    guideMarket: 'Guide market',
    sos: 'SOS Request',
    emergency: 'Emergency Contacts',
    emergencyContacts: 'Emergency Contacts',
    expiry: 'Expiry Reminder',
    expatInfo: 'Expat Info',
    expatInfoTitle: 'Expat Essential Guide',
    schools: 'Schools & Education',
    visaGuide: 'Visa Guide',
    groupDelivery: 'Korea group delivery',
    interpreter: 'Interpreter service',
    listingsHub: 'Unified listings (DB)',
    lostFound: 'Lost & Found',
    medicine: 'Medicine Info',
    categoryExperience: 'Experience',
    categoryMedical: 'Medical',
    categoryFitnessSport: 'Sports',
    categoryTravel: 'Travel',
    categoryAdmin: 'Admin',
    interiorSearchPlaceholder: 'Search by name or specialty',
    interiorCount: '{n} businesses',
    interiorEmpty: 'No interior businesses found',
    interiorRegisterDesc: 'Running an interior business?',
    interiorRegisterBtn: 'Register Business',
    businessSearchPlaceholder: 'Search businesses',
    searchNoResultsTitle: 'No results',
    callPhone: 'Call',
    listLanguageExp: 'Language {language} · Experience {exp}',
    repairOnsiteLine: 'On-site visit: {status}',
    onsiteAvailable: 'Available',
    onsiteUnavailable: 'Not available',
    translationPairLine: 'Language pairs {pair}',
  },
  localInfo: {
    lostFound: 'Lost & Found',
    medicine: 'Medicine Info',
  },
  listings: {
    hubTitle: 'Service categories',
    hubIntro:
      'Listings load only after you open a category. The category catalog is cached on your device for a while to reduce API calls.',
    loadError: 'Could not load the list.',
    emptyCategories: 'No categories to show',
    emptyCategoriesHint: 'Add rows to Supabase `categories` with active=true.',
    emptyLifeNavHint:
      'Apply migration 20260613 or insert `categories` rows with type=life_nav and active=true.',
    noListingCategories: 'No categories to open as unified listings',
    addLifeNavHint: 'Add more `life_nav` rows (other than the /listings hub row) to browse listings here.',
    categoryTitle: 'Listings',
    emptyList: 'No posts yet',
    emptyListHint: 'Published rows in `listings` will show here.',
    verified: 'Verified',
    badCategory: 'Invalid link',
    badCategoryHint: 'Pick a category again from Life info.',
    notFound: 'Post not found',
    notFoundHint: 'It may have been removed or unpublished.',
    backToCategory: 'Back to this category',
  },
  groups: {
    title: 'Groups',
    myGroups: {
      pendingSection: 'Pending approval',
      pendingBadge: 'Pending',
      organizerBadge: 'Organizer',
    },
    searchPlaceholder: 'Search groups',
    create: '+ Create',
    loadFailed: 'Could not load groups.',
    empty: 'No groups in this area.',
    loginToJoin: 'Sign in to join.',
    btn: {
      manage: 'Manage',
      enter: 'Enter',
      join: 'Join',
      inAppChat: 'In-app Chat',
      externalChat: 'External Chat',
    },
    chatRoomError: 'Could not open chat room',
    join: 'Join',
    joining: 'Joining…',
    joinSuccess: 'You joined the group.',
    joinFailed: 'Could not join.',
    alreadyMember: 'You are already a member.',
    groupFull: 'This group is full.',
    leave: 'Leave',
    leaveSuccess: 'You left the group.',
    leaveFailed: 'Could not leave.',
    notFound: 'Group not found.',
    regionUnset: 'Region not set',
    memberCount: '{count} members',
    maxMembers: 'max {max}',
    filterAll: 'All',
    filterFree: 'Free',
    filterPaid: 'Paid',
    paidFilterLabel: 'Free / paid filter',
    cat: {
      all: 'All',
      sports: 'Sports',
      learning: 'Language exchange',
      food: 'Food',
      support: 'Faith',
      general: 'General',
      jobs: 'Business',
      parenting: 'Parenting',
      gaming: 'Gaming',
      culture: 'Culture',
    },
    type: {
      general: 'General',
      sports: 'Sports',
      learning: 'Learning',
      culture: 'Culture',
      support: 'Faith',
      jobs: 'Jobs',
      parenting: 'Parenting',
      buy_sell: 'Group buy',
      gaming: 'Gaming',
    },
    privacy: {
      public: 'Public',
      private: 'Private',
      secret: 'Secret',
    },
    badge: {
      free: 'Free',
      paid: 'Paid',
      diamond: 'Diamond',
      gold: 'Gold',
      silver: 'Silver',
      bronze: 'Bronze',
    },
    escrowNotice:
      'Your join fee is held by the platform and paid to the organizer after the first event is completed.',
    joinFeeConfirm: 'You will pay the join fee in points.',
    joinFeeLabel: 'Join fee',
    myPoints: 'Your balance',
    chargePoints: 'Top up points',
    insufficientPoints: 'Not enough points. Please top up and try again.',
    pendingApproval: 'Pending approval',
    kickMember: 'Remove',
    kickConfirm: 'Remove this member?',
    kickSuccess: 'Member removed.',
    promoteMember: 'Make moderator',
    promoteSuccess: 'Moderator assigned.',
    approve: 'Approve',
    reject: 'Reject',
    approveSuccess: 'Member approved.',
    rejectSuccess: 'Request rejected.',
    actionFailed: 'Action failed.',
    pendingSection: 'Pending requests',
    recurringEvent: 'Recurring meetup',
    sponsoredBusiness: 'Partner business',
    sponsoredPlaceholder: 'Partner listings will appear here soon.',
    translatePost: 'Translate',
    tab: {
      board: 'Board',
      members: 'Members',
      events: 'Events',
      info: 'Info',
      revenue: 'Revenue',
    },
    postPlaceholder: 'Write to the group',
    post: 'Post',
    posting: 'Posting…',
    postSuccess: 'Posted.',
    postFailed: 'Could not post.',
    boardMembersOnly: 'Only members can use the board. Join to participate.',
    notice: 'Notice',
    memberFallback: 'Member',
    noPosts: 'No posts yet.',
    createEvent: 'Create event',
    upcomingEvents: 'Upcoming',
    pastEvents: 'Past',
    noUpcomingEvents: 'No upcoming events.',
    noPastEvents: 'No past events.',
    selectDate: 'Select date',
    eventMaxParticipantsShort: 'People',
    noDescription: 'No description.',
    rules: 'Group rules',
    schedule: 'Regular schedule',
    createdAt: 'Created',
    revenueTotal: 'Total earnings (organizer)',
    revenueMonth: 'This month',
    requestPayout: 'Request payout',
    payoutSoon: 'Payout requests are coming soon.',
    noRevenue: 'No revenue yet.',
    mna: {
      title: 'Group M&A',
      desc: 'Merge with another group or transfer ownership.',
      merge: 'Merge with another group',
      transfer: 'Transfer ownership (sale)',
      minMembersNotice: '{{count}} members · M&A requires {{required}}+ active members',
      voteTitle: 'Merge vote',
      voteDesc: 'Our group is voting on a merge. Do you agree?',
      voteYes: 'Yes',
      voteNo: 'No',
      voteWarning: 'After merge approval you can choose whether to stay in the new group.',
      voteDeadline: 'Vote ends in {{days}} days',
      voteStats: 'Yes {{yes}}% · No {{no}}%',
      escrowNotice: 'Funds are held in escrow for 14 days before payout',
      adminReview: 'High-value deals need admin review (50,000P+)',
      feePct: 'Platform fee 15%',
      paidOnly: 'Paid groups only',
      paidDurationNotice: 'Transfer available after {{remaining}} more months as paid',
      insufficientManagers: '{{count}} managers · appoint 3+ before applying',
      managerApprovalTitle: 'Manager pre-approval',
      managerApprovalDesc: 'Approve M&A request for {{name}}?',
      managerApprovalExpiry: 'Respond within {{days}} days',
      managerApproved: 'Approve',
      managerRejected: 'Reject',
      managerRejectHint: 'Rejecting cancels the request immediately',
      submit: 'Submit request',
      submitSuccess: 'M&A request submitted. Awaiting manager approvals.',
      submitFailed: 'Could not submit request',
      eligible: 'Eligibility requirements met',
      targetGroup: 'Target group',
      pickTarget: 'Select target',
      newNameOptional: 'New group name (optional)',
      priceLabel: 'Transfer price (points)',
      buyerIdOptional: 'Buyer user ID (optional)',
      votingInProgress: 'Merge vote in progress',
      voteRecorded: 'Vote recorded',
      voteFailed: 'Vote failed',
      mergeChoiceTitle: 'Merge approved',
      mergeChoiceDesc: 'Stay in the merged group?',
      mergeChoiceStay: 'Stay',
      mergeChoiceLeave: 'Leave',
      mergeChoiceExpiry: 'If you do not choose within {{days}} days you will remain in the new group.',
    },
  },
  myReservations: {
    title: 'Reservations',
    loading: 'Loading...',
    empty: 'No reservations yet',
    browseServices: 'Browse services',
    businessNameFallback: 'Business',
    partySize: '{n} people',
    noShowLimited: 'No-show x{count} — booking is restricted',
    noShowWarning: 'No-show x{count} — 3 or more will restrict booking',
    noShowContact: 'Contact support to lift the restriction.',
    cancelBtn: 'Cancel reservation',
    cancelConfirm: 'Cancel this reservation?',
    cancelSuccess: 'Reservation cancelled.',
    cancelFail: 'Could not cancel.',
    status: {
      pending: 'Pending',
      holding: 'Confirming payment',
      confirmed: 'Confirmed',
      in_progress: 'In progress',
      cancelled: 'Cancelled',
      failed: 'Failed',
      completed: 'Completed',
    },
  },
};

export default deepMerge(en, phaseMyPageDashboardEn, phaseE1En, phaseE2En, phaseE3En, phaseE4En, phaseGroupsCreateEn, phaseGroupsListDetailEn, phaseGroupCategoriesEn, phaseTradeChatEn, phaseHandleH0En, phaseP0DashEn, phaseP0CatalogEn, phaseManageWidgetsEn, phaseFoodOrderFlowEn, phaseBrandCatalogEn, phaseMenuFeedEn, phaseBrandPageEn, phaseLocationSetupEn, phaseUserAddressBookEn, phaseHomeWeatherHourlyEn, phaseLostFoundResolveEn, phaseAdminCoreEn, phaseBusinessRegInquiryEn, phaseJobsHireGateEn, phaseSearchSurfaceEn, phaseHubEmptyEn, phaseBizNotifEn, phaseCatalogBookingEn, phaseCreatorCommissionEn, phaseTravelerFormEn, phaseRestaurantRegisterEn, phaseLocalRegisterChipsEn, phaseMentorBusinessRegisterEn, phaseLocalRegisterChips2En, phaseWriteChipsEn, phaseLiveHangulEn, getShellUiOverlay('en'), getScreenUiOverlay('en'));
